const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaveTestPixSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.0000010000001111620804, -0.0000010000001253729351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.6 1152.6 H 23.4 V 1163.4 H 12.6 V 1152.6 Z",
    style: {
      fill: "rgba(255,255,255,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.6 864.6 H 35.4 V 875.4 H 24.6 V 864.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 624.6 H 47.4 V 635.4 H 36.6 V 624.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 636.6 H 47.4 V 647.4 H 36.6 V 636.6 Z",
    style: {
      fill: "rgba(242,247,248,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 648.6 H 47.4 V 659.4 H 36.6 V 648.6 Z",
    style: {
      fill: "rgba(180,186,193,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 660.6 H 47.4 V 671.4 H 36.6 V 660.6 Z",
    style: {
      fill: "rgba(167,173,182,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 672.6 H 47.4 V 683.4 H 36.6 V 672.6 Z",
    style: {
      fill: "rgba(167,173,181,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 684.6 H 47.4 V 695.4 H 36.6 V 684.6 Z",
    style: {
      fill: "rgba(178,183,192,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 696.6 H 47.4 V 707.4 H 36.6 V 696.6 Z",
    style: {
      fill: "rgba(192,195,199,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 708.6 H 47.4 V 719.4 H 36.6 V 708.6 Z",
    style: {
      fill: "rgba(225,237,231,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 720.6 H 47.4 V 731.4 H 36.6 V 720.6 Z",
    style: {
      fill: "rgba(216,235,235,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 828.6 H 47.4 V 839.4 H 36.6 V 828.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 840.6 H 47.4 V 851.4 H 36.6 V 840.6 Z",
    style: {
      fill: "rgba(223,223,223,0.03)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 852.6 H 47.4 V 863.4 H 36.6 V 852.6 Z",
    style: {
      fill: "rgba(230,230,230,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 864.6 H 47.4 V 875.4 H 36.6 V 864.6 Z",
    style: {
      fill: "rgba(225,240,225,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 876.6 H 47.4 V 887.4 H 36.6 V 876.6 Z",
    style: {
      fill: "rgba(216,233,228,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 888.6 H 47.4 V 899.4 H 36.6 V 888.6 Z",
    style: {
      fill: "rgba(177,182,185,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 900.6 H 47.4 V 911.4 H 36.6 V 900.6 Z",
    style: {
      fill: "rgba(162,168,177,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 912.6 H 47.4 V 923.4 H 36.6 V 912.6 Z",
    style: {
      fill: "rgba(156,162,171,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 924.6 H 47.4 V 935.4 H 36.6 V 924.6 Z",
    style: {
      fill: "rgba(159,165,174,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 936.6 H 47.4 V 947.4 H 36.6 V 936.6 Z",
    style: {
      fill: "rgba(166,172,178,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 948.6 H 47.4 V 959.4 H 36.6 V 948.6 Z",
    style: {
      fill: "rgba(178,190,190,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.6 960.6 H 47.4 V 971.4 H 36.6 V 960.6 Z",
    style: {
      fill: "rgba(181,195,188,0.15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 612.6 H 59.4 V 623.4 H 48.6 V 612.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 624.6 H 59.4 V 635.4 H 48.6 V 624.6 Z",
    style: {
      fill: "rgba(244,248,248,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 636.6 H 59.4 V 647.4 H 48.6 V 636.6 Z",
    style: {
      fill: "#c2c6cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 648.6 H 59.4 V 659.4 H 48.6 V 648.6 Z",
    style: {
      fill: "#b3b8c1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 660.6 H 59.4 V 671.4 H 48.6 V 660.6 Z",
    style: {
      fill: "#adb3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 672.6 H 59.4 V 683.4 H 48.6 V 672.6 Z",
    style: {
      fill: "#b4b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 684.6 H 59.4 V 695.4 H 48.6 V 684.6 Z",
    style: {
      fill: "#c1c4c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 696.6 H 59.4 V 707.4 H 48.6 V 696.6 Z",
    style: {
      fill: "rgba(225,238,231,0.64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 864.6 H 59.4 V 875.4 H 48.6 V 864.6 Z",
    style: {
      fill: "rgba(222,237,231,0.91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 876.6 H 59.4 V 887.4 H 48.6 V 876.6 Z",
    style: {
      fill: "#bec3c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 888.6 H 59.4 V 899.4 H 48.6 V 888.6 Z",
    style: {
      fill: "#aeb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 900.6 H 59.4 V 911.4 H 48.6 V 900.6 Z",
    style: {
      fill: "#a3aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 912.6 H 59.4 V 923.4 H 48.6 V 912.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 924.6 H 59.4 V 935.4 H 48.6 V 924.6 Z",
    style: {
      fill: "#a7adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 936.6 H 59.4 V 947.4 H 48.6 V 936.6 Z",
    style: {
      fill: "rgba(180,192,192,0.76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 1104.6 H 59.4 V 1115.4 H 48.6 V 1104.6 Z",
    style: {
      fill: "rgba(180,190,190,0.31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.6 1116.6 H 59.4 V 1127.4 H 48.6 V 1116.6 Z",
    style: {
      fill: "rgba(127,127,127,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 612.6 H 71.4 V 623.4 H 60.6 V 612.6 Z",
    style: {
      fill: "rgba(238,244,245,0.83)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 624.6 H 71.4 V 635.4 H 60.6 V 624.6 Z",
    style: {
      fill: "#c6cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 636.6 H 71.4 V 647.4 H 60.6 V 636.6 Z",
    style: {
      fill: "#b8bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 648.6 H 71.4 V 659.4 H 60.6 V 648.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 660.6 H 71.4 V 671.4 H 60.6 V 660.6 Z",
    style: {
      fill: "#b7bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 672.6 H 71.4 V 683.4 H 60.6 V 672.6 Z",
    style: {
      fill: "#c1c5c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 684.6 H 71.4 V 695.4 H 60.6 V 684.6 Z",
    style: {
      fill: "rgba(224,237,231,0.67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 852.6 H 71.4 V 863.4 H 60.6 V 852.6 Z",
    style: {
      fill: "rgba(224,238,232,0.82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 864.6 H 71.4 V 875.4 H 60.6 V 864.6 Z",
    style: {
      fill: "#c2c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 876.6 H 71.4 V 887.4 H 60.6 V 876.6 Z",
    style: {
      fill: "#b4b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 888.6 H 71.4 V 899.4 H 60.6 V 888.6 Z",
    style: {
      fill: "#a9aeb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 900.6 H 71.4 V 911.4 H 60.6 V 900.6 Z",
    style: {
      fill: "#a4aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 912.6 H 71.4 V 923.4 H 60.6 V 912.6 Z",
    style: {
      fill: "#a7adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 924.6 H 71.4 V 935.4 H 60.6 V 924.6 Z",
    style: {
      fill: "rgba(178,189,189,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 1092.6 H 71.4 V 1103.4 H 60.6 V 1092.6 Z",
    style: {
      fill: "rgba(170,170,170,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 1104.6 H 71.4 V 1115.4 H 60.6 V 1104.6 Z",
    style: {
      fill: "rgba(170,178,180,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.6 1116.6 H 71.4 V 1127.4 H 60.6 V 1116.6 Z",
    style: {
      fill: "rgba(150,165,165,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 588.6 H 83.4 V 599.4 H 72.6 V 588.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 600.6 H 83.4 V 611.4 H 72.6 V 600.6 Z",
    style: {
      fill: "rgba(241,247,247,0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 612.6 H 83.4 V 623.4 H 72.6 V 612.6 Z",
    style: {
      fill: "#c7cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 624.6 H 83.4 V 635.4 H 72.6 V 624.6 Z",
    style: {
      fill: "#b9bec5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 636.6 H 83.4 V 647.4 H 72.6 V 636.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 648.6 H 83.4 V 659.4 H 72.6 V 648.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 660.6 H 83.4 V 671.4 H 72.6 V 660.6 Z",
    style: {
      fill: "#c2c6c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 672.6 H 83.4 V 683.4 H 72.6 V 672.6 Z",
    style: {
      fill: "rgba(223,235,231,0.69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 840.6 H 83.4 V 851.4 H 72.6 V 840.6 Z",
    style: {
      fill: "rgba(224,237,232,0.74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 852.6 H 83.4 V 863.4 H 72.6 V 852.6 Z",
    style: {
      fill: "#c2c7c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 864.6 H 83.4 V 875.4 H 72.6 V 864.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 876.6 H 83.4 V 887.4 H 72.6 V 876.6 Z",
    style: {
      fill: "#abb0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 888.6 H 83.4 V 899.4 H 72.6 V 888.6 Z",
    style: {
      fill: "#a6adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 900.6 H 83.4 V 911.4 H 72.6 V 900.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 912.6 H 83.4 V 923.4 H 72.6 V 912.6 Z",
    style: {
      fill: "rgba(179,186,189,0.41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 1080.6 H 83.4 V 1091.4 H 72.6 V 1080.6 Z",
    style: {
      fill: "rgba(127,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 1092.6 H 83.4 V 1103.4 H 72.6 V 1092.6 Z",
    style: {
      fill: "rgba(173,182,183,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 1104.6 H 83.4 V 1115.4 H 72.6 V 1104.6 Z",
    style: {
      fill: "#a3a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.6 1116.6 H 83.4 V 1127.4 H 72.6 V 1116.6 Z",
    style: {
      fill: "rgba(150,165,165,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 588.6 H 95.4 V 599.4 H 84.6 V 588.6 Z",
    style: {
      fill: "rgba(243,248,248,0.92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 600.6 H 95.4 V 611.4 H 84.6 V 600.6 Z",
    style: {
      fill: "#c7cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 612.6 H 95.4 V 623.4 H 84.6 V 612.6 Z",
    style: {
      fill: "#b9bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 624.6 H 95.4 V 635.4 H 84.6 V 624.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 636.6 H 95.4 V 647.4 H 84.6 V 636.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 648.6 H 95.4 V 659.4 H 84.6 V 648.6 Z",
    style: {
      fill: "#c4c8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 660.6 H 95.4 V 671.4 H 84.6 V 660.6 Z",
    style: {
      fill: "rgba(227,238,233,0.65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 828.6 H 95.4 V 839.4 H 84.6 V 828.6 Z",
    style: {
      fill: "rgba(226,237,232,0.44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 840.6 H 95.4 V 851.4 H 84.6 V 840.6 Z",
    style: {
      fill: "#c1c5c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 852.6 H 95.4 V 863.4 H 84.6 V 852.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 864.6 H 95.4 V 875.4 H 84.6 V 864.6 Z",
    style: {
      fill: "#abb1b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 876.6 H 95.4 V 887.4 H 84.6 V 876.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 888.6 H 95.4 V 899.4 H 84.6 V 888.6 Z",
    style: {
      fill: "#aab0b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 900.6 H 95.4 V 911.4 H 84.6 V 900.6 Z",
    style: {
      fill: "rgba(180,191,191,0.39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 1080.6 H 95.4 V 1091.4 H 84.6 V 1080.6 Z",
    style: {
      fill: "rgba(173,181,182,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 1092.6 H 95.4 V 1103.4 H 84.6 V 1092.6 Z",
    style: {
      fill: "#a5aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 1104.6 H 95.4 V 1115.4 H 84.6 V 1104.6 Z",
    style: {
      fill: "#9ea5af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.6 1116.6 H 95.4 V 1127.4 H 84.6 V 1116.6 Z",
    style: {
      fill: "rgba(150,165,165,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 576.6 H 107.4 V 587.4 H 96.6 V 576.6 Z",
    style: {
      fill: "rgba(237,243,244,0.84)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 588.6 H 107.4 V 599.4 H 96.6 V 588.6 Z",
    style: {
      fill: "#c7cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 600.6 H 107.4 V 611.4 H 96.6 V 600.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 612.6 H 107.4 V 623.4 H 96.6 V 612.6 Z",
    style: {
      fill: "#b2b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 624.6 H 107.4 V 635.4 H 96.6 V 624.6 Z",
    style: {
      fill: "#b7bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 636.6 H 107.4 V 647.4 H 96.6 V 636.6 Z",
    style: {
      fill: "#c3c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 648.6 H 107.4 V 659.4 H 96.6 V 648.6 Z",
    style: {
      fill: "rgba(226,238,234,0.65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 816.6 H 107.4 V 827.4 H 96.6 V 816.6 Z",
    style: {
      fill: "rgba(223,237,232,0.44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 828.6 H 107.4 V 839.4 H 96.6 V 828.6 Z",
    style: {
      fill: "#bfc3c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 840.6 H 107.4 V 851.4 H 96.6 V 840.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 852.6 H 107.4 V 863.4 H 96.6 V 852.6 Z",
    style: {
      fill: "#aaafb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 864.6 H 107.4 V 875.4 H 96.6 V 864.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 876.6 H 107.4 V 887.4 H 96.6 V 876.6 Z",
    style: {
      fill: "#abb1b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 888.6 H 107.4 V 899.4 H 96.6 V 888.6 Z",
    style: {
      fill: "rgba(184,197,194,0.6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 1056.6 H 107.4 V 1067.4 H 96.6 V 1056.6 Z",
    style: {
      fill: "rgba(127,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 1068.6 H 107.4 V 1079.4 H 96.6 V 1068.6 Z",
    style: {
      fill: "rgba(172,180,182,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 1080.6 H 107.4 V 1091.4 H 96.6 V 1080.6 Z",
    style: {
      fill: "#a5aab1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 1092.6 H 107.4 V 1103.4 H 96.6 V 1092.6 Z",
    style: {
      fill: "#a0a6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 1104.6 H 107.4 V 1115.4 H 96.6 V 1104.6 Z",
    style: {
      fill: "#9da4ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 96.6 1116.6 H 107.4 V 1127.4 H 96.6 V 1116.6 Z",
    style: {
      fill: "rgba(150,165,165,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 552.6 H 119.4 V 563.4 H 108.6 V 552.6 Z",
    style: {
      fill: "rgba(255,255,255,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 564.6 H 119.4 V 575.4 H 108.6 V 564.6 Z",
    style: {
      fill: "rgba(236,239,241,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 576.6 H 119.4 V 587.4 H 108.6 V 576.6 Z",
    style: {
      fill: "#c6c9ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 588.6 H 119.4 V 599.4 H 108.6 V 588.6 Z",
    style: {
      fill: "#b8bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 600.6 H 119.4 V 611.4 H 108.6 V 600.6 Z",
    style: {
      fill: "#b2b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 612.6 H 119.4 V 623.4 H 108.6 V 612.6 Z",
    style: {
      fill: "#b7bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 624.6 H 119.4 V 635.4 H 108.6 V 624.6 Z",
    style: {
      fill: "#c3c7c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 636.6 H 119.4 V 647.4 H 108.6 V 636.6 Z",
    style: {
      fill: "rgba(225,236,232,0.73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 804.6 H 119.4 V 815.4 H 108.6 V 804.6 Z",
    style: {
      fill: "rgba(222,234,232,0.43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 816.6 H 119.4 V 827.4 H 108.6 V 816.6 Z",
    style: {
      fill: "#c0c3c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 828.6 H 119.4 V 839.4 H 108.6 V 828.6 Z",
    style: {
      fill: "#b2b6bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 840.6 H 119.4 V 851.4 H 108.6 V 840.6 Z",
    style: {
      fill: "#a9aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 852.6 H 119.4 V 863.4 H 108.6 V 852.6 Z",
    style: {
      fill: "#a6acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 864.6 H 119.4 V 875.4 H 108.6 V 864.6 Z",
    style: {
      fill: "#abb1b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 876.6 H 119.4 V 887.4 H 108.6 V 876.6 Z",
    style: {
      fill: "rgba(184,197,196,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 1044.6 H 119.4 V 1055.4 H 108.6 V 1044.6 Z",
    style: {
      fill: "rgba(191,191,191,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 1056.6 H 119.4 V 1067.4 H 108.6 V 1056.6 Z",
    style: {
      fill: "rgba(173,180,182,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 1068.6 H 119.4 V 1079.4 H 108.6 V 1068.6 Z",
    style: {
      fill: "#a5aab1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 1080.6 H 119.4 V 1091.4 H 108.6 V 1080.6 Z",
    style: {
      fill: "#a1a6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 1092.6 H 119.4 V 1103.4 H 108.6 V 1092.6 Z",
    style: {
      fill: "#a0a6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 1104.6 H 119.4 V 1115.4 H 108.6 V 1104.6 Z",
    style: {
      fill: "#a0a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.6 1116.6 H 119.4 V 1127.4 H 108.6 V 1116.6 Z",
    style: {
      fill: "rgba(165,165,165,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 540.6 H 131.4 V 551.4 H 120.6 V 540.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 552.6 H 131.4 V 563.4 H 120.6 V 552.6 Z",
    style: {
      fill: "rgba(239,244,245,0.91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 564.6 H 131.4 V 575.4 H 120.6 V 564.6 Z",
    style: {
      fill: "#c6c9ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 576.6 H 131.4 V 587.4 H 120.6 V 576.6 Z",
    style: {
      fill: "#b8bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 588.6 H 131.4 V 599.4 H 120.6 V 588.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 600.6 H 131.4 V 611.4 H 120.6 V 600.6 Z",
    style: {
      fill: "#b7bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 612.6 H 131.4 V 623.4 H 120.6 V 612.6 Z",
    style: {
      fill: "#c3c6c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 624.6 H 131.4 V 635.4 H 120.6 V 624.6 Z",
    style: {
      fill: "rgba(222,236,230,0.67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 792.6 H 131.4 V 803.4 H 120.6 V 792.6 Z",
    style: {
      fill: "rgba(224,236,231,0.42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 804.6 H 131.4 V 815.4 H 120.6 V 804.6 Z",
    style: {
      fill: "#c1c5c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 816.6 H 131.4 V 827.4 H 120.6 V 816.6 Z",
    style: {
      fill: "#b3b6bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 828.6 H 131.4 V 839.4 H 120.6 V 828.6 Z",
    style: {
      fill: "#a8adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 840.6 H 131.4 V 851.4 H 120.6 V 840.6 Z",
    style: {
      fill: "#a5aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 852.6 H 131.4 V 863.4 H 120.6 V 852.6 Z",
    style: {
      fill: "#aaafb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 864.6 H 131.4 V 875.4 H 120.6 V 864.6 Z",
    style: {
      fill: "rgba(182,195,194,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 1032.6 H 131.4 V 1043.4 H 120.6 V 1032.6 Z",
    style: {
      fill: "rgba(170,170,170,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 1044.6 H 131.4 V 1055.4 H 120.6 V 1044.6 Z",
    style: {
      fill: "rgba(174,182,183,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 1056.6 H 131.4 V 1067.4 H 120.6 V 1056.6 Z",
    style: {
      fill: "#a5abb1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 1068.6 H 131.4 V 1079.4 H 120.6 V 1068.6 Z",
    style: {
      fill: "#a1a7ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 1080.6 H 131.4 V 1091.4 H 120.6 V 1080.6 Z",
    style: {
      fill: "#a1a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 1092.6 H 131.4 V 1103.4 H 120.6 V 1092.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 1104.6 H 131.4 V 1115.4 H 120.6 V 1104.6 Z",
    style: {
      fill: "rgba(169,177,180,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.6 1116.6 H 131.4 V 1127.4 H 120.6 V 1116.6 Z",
    style: {
      fill: "rgba(170,191,191,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 540.6 H 143.4 V 551.4 H 132.6 V 540.6 Z",
    style: {
      fill: "rgba(239,244,245,0.82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 552.6 H 143.4 V 563.4 H 132.6 V 552.6 Z",
    style: {
      fill: "#c7cacf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 564.6 H 143.4 V 575.4 H 132.6 V 564.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 576.6 H 143.4 V 587.4 H 132.6 V 576.6 Z",
    style: {
      fill: "#b2b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 588.6 H 143.4 V 599.4 H 132.6 V 588.6 Z",
    style: {
      fill: "#b7bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 600.6 H 143.4 V 611.4 H 132.6 V 600.6 Z",
    style: {
      fill: "#c3c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 612.6 H 143.4 V 623.4 H 132.6 V 612.6 Z",
    style: {
      fill: "rgba(223,234,230,0.63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 780.6 H 143.4 V 791.4 H 132.6 V 780.6 Z",
    style: {
      fill: "rgba(225,237,233,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 792.6 H 143.4 V 803.4 H 132.6 V 792.6 Z",
    style: {
      fill: "#c0c3c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 804.6 H 143.4 V 815.4 H 132.6 V 804.6 Z",
    style: {
      fill: "#b3b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 816.6 H 143.4 V 827.4 H 132.6 V 816.6 Z",
    style: {
      fill: "#a8adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 828.6 H 143.4 V 839.4 H 132.6 V 828.6 Z",
    style: {
      fill: "#a4a9b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 840.6 H 143.4 V 851.4 H 132.6 V 840.6 Z",
    style: {
      fill: "#a7acb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 852.6 H 143.4 V 863.4 H 132.6 V 852.6 Z",
    style: {
      fill: "rgba(179,192,190,0.45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 1020.6 H 143.4 V 1031.4 H 132.6 V 1020.6 Z",
    style: {
      fill: "rgba(185,199,196,0.29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 1032.6 H 143.4 V 1043.4 H 132.6 V 1032.6 Z",
    style: {
      fill: "#afb8b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 1044.6 H 143.4 V 1055.4 H 132.6 V 1044.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 1056.6 H 143.4 V 1067.4 H 132.6 V 1056.6 Z",
    style: {
      fill: "#a1a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 1068.6 H 143.4 V 1079.4 H 132.6 V 1068.6 Z",
    style: {
      fill: "#a1a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 1080.6 H 143.4 V 1091.4 H 132.6 V 1080.6 Z",
    style: {
      fill: "#a5abb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 1092.6 H 143.4 V 1103.4 H 132.6 V 1092.6 Z",
    style: {
      fill: "rgba(173,183,184,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.6 1116.6 H 143.4 V 1127.4 H 132.6 V 1116.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 516.6 H 155.4 V 527.4 H 144.6 V 516.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 528.6 H 155.4 V 539.4 H 144.6 V 528.6 Z",
    style: {
      fill: "rgba(236,242,242,0.67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 540.6 H 155.4 V 551.4 H 144.6 V 540.6 Z",
    style: {
      fill: "#c7cacf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 552.6 H 155.4 V 563.4 H 144.6 V 552.6 Z",
    style: {
      fill: "#b9bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 564.6 H 155.4 V 575.4 H 144.6 V 564.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 576.6 H 155.4 V 587.4 H 144.6 V 576.6 Z",
    style: {
      fill: "#b7bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 588.6 H 155.4 V 599.4 H 144.6 V 588.6 Z",
    style: {
      fill: "#c6cbcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 600.6 H 155.4 V 611.4 H 144.6 V 600.6 Z",
    style: {
      fill: "rgba(222,236,230,0.67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 768.6 H 155.4 V 779.4 H 144.6 V 768.6 Z",
    style: {
      fill: "rgba(225,237,232,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 780.6 H 155.4 V 791.4 H 144.6 V 780.6 Z",
    style: {
      fill: "#c1c5c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 792.6 H 155.4 V 803.4 H 144.6 V 792.6 Z",
    style: {
      fill: "#b4b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 804.6 H 155.4 V 815.4 H 144.6 V 804.6 Z",
    style: {
      fill: "#a9aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 816.6 H 155.4 V 827.4 H 144.6 V 816.6 Z",
    style: {
      fill: "#a4aab1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 828.6 H 155.4 V 839.4 H 144.6 V 828.6 Z",
    style: {
      fill: "#a7acb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 840.6 H 155.4 V 851.4 H 144.6 V 840.6 Z",
    style: {
      fill: "rgba(172,178,178,0.17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 1008.6 H 155.4 V 1019.4 H 144.6 V 1008.6 Z",
    style: {
      fill: "rgba(185,198,198,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 1020.6 H 155.4 V 1031.4 H 144.6 V 1020.6 Z",
    style: {
      fill: "#afb7b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 1032.6 H 155.4 V 1043.4 H 144.6 V 1032.6 Z",
    style: {
      fill: "#a7adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 1044.6 H 155.4 V 1055.4 H 144.6 V 1044.6 Z",
    style: {
      fill: "#a2a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 1056.6 H 155.4 V 1067.4 H 144.6 V 1056.6 Z",
    style: {
      fill: "#a1a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 1068.6 H 155.4 V 1079.4 H 144.6 V 1068.6 Z",
    style: {
      fill: "#a5abb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 1080.6 H 155.4 V 1091.4 H 144.6 V 1080.6 Z",
    style: {
      fill: "rgba(171,178,179,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144.6 1116.6 H 155.4 V 1127.4 H 144.6 V 1116.6 Z",
    style: {
      fill: "rgba(182,182,182,0.03)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 516.6 H 167.4 V 527.4 H 156.6 V 516.6 Z",
    style: {
      fill: "rgba(240,245,246,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 528.6 H 167.4 V 539.4 H 156.6 V 528.6 Z",
    style: {
      fill: "#c6c9cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 540.6 H 167.4 V 551.4 H 156.6 V 540.6 Z",
    style: {
      fill: "#b8bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 552.6 H 167.4 V 563.4 H 156.6 V 552.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 564.6 H 167.4 V 575.4 H 156.6 V 564.6 Z",
    style: {
      fill: "#b7bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 576.6 H 167.4 V 587.4 H 156.6 V 576.6 Z",
    style: {
      fill: "#c4cacb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 588.6 H 167.4 V 599.4 H 156.6 V 588.6 Z",
    style: {
      fill: "rgba(223,236,230,0.56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 756.6 H 167.4 V 767.4 H 156.6 V 756.6 Z",
    style: {
      fill: "rgba(223,237,232,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 768.6 H 167.4 V 779.4 H 156.6 V 768.6 Z",
    style: {
      fill: "#c0c4c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 780.6 H 167.4 V 791.4 H 156.6 V 780.6 Z",
    style: {
      fill: "#b4b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 792.6 H 167.4 V 803.4 H 156.6 V 792.6 Z",
    style: {
      fill: "#aab0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 804.6 H 167.4 V 815.4 H 156.6 V 804.6 Z",
    style: {
      fill: "#a6abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 816.6 H 167.4 V 827.4 H 156.6 V 816.6 Z",
    style: {
      fill: "#a8adb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 828.6 H 167.4 V 839.4 H 156.6 V 828.6 Z",
    style: {
      fill: "rgba(177,187,187,0.29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 996.6 H 167.4 V 1007.4 H 156.6 V 996.6 Z",
    style: {
      fill: "rgba(170,198,198,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 1008.6 H 167.4 V 1019.4 H 156.6 V 1008.6 Z",
    style: {
      fill: "rgba(172,179,180,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 1020.6 H 167.4 V 1031.4 H 156.6 V 1020.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 1032.6 H 167.4 V 1043.4 H 156.6 V 1032.6 Z",
    style: {
      fill: "#a2a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 1044.6 H 167.4 V 1055.4 H 156.6 V 1044.6 Z",
    style: {
      fill: "#a2a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 1056.6 H 167.4 V 1067.4 H 156.6 V 1056.6 Z",
    style: {
      fill: "#a6acb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 1068.6 H 167.4 V 1079.4 H 156.6 V 1068.6 Z",
    style: {
      fill: "rgba(173,181,182,0.88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 156.6 1116.6 H 167.4 V 1127.4 H 156.6 V 1116.6 Z",
    style: {
      fill: "rgba(191,191,191,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 504.6 H 179.4 V 515.4 H 168.6 V 504.6 Z",
    style: {
      fill: "rgba(241,248,249,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 516.6 H 179.4 V 527.4 H 168.6 V 516.6 Z",
    style: {
      fill: "#c6c9cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 528.6 H 179.4 V 539.4 H 168.6 V 528.6 Z",
    style: {
      fill: "#b8bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 540.6 H 179.4 V 551.4 H 168.6 V 540.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 552.6 H 179.4 V 563.4 H 168.6 V 552.6 Z",
    style: {
      fill: "#b7bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 564.6 H 179.4 V 575.4 H 168.6 V 564.6 Z",
    style: {
      fill: "#c3c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 576.6 H 179.4 V 587.4 H 168.6 V 576.6 Z",
    style: {
      fill: "rgba(223,235,231,0.49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 744.6 H 179.4 V 755.4 H 168.6 V 744.6 Z",
    style: {
      fill: "rgba(221,235,230,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 756.6 H 179.4 V 767.4 H 168.6 V 756.6 Z",
    style: {
      fill: "#bfc4c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 768.6 H 179.4 V 779.4 H 168.6 V 768.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 780.6 H 179.4 V 791.4 H 168.6 V 780.6 Z",
    style: {
      fill: "#aab0b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 792.6 H 179.4 V 803.4 H 168.6 V 792.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 804.6 H 179.4 V 815.4 H 168.6 V 804.6 Z",
    style: {
      fill: "#a9afb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 816.6 H 179.4 V 827.4 H 168.6 V 816.6 Z",
    style: {
      fill: "rgba(180,192,192,0.49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 984.6 H 179.4 V 995.4 H 168.6 V 984.6 Z",
    style: {
      fill: "rgba(184,196,196,0.17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 996.6 H 179.4 V 1007.4 H 168.6 V 996.6 Z",
    style: {
      fill: "rgba(169,174,178,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 1008.6 H 179.4 V 1019.4 H 168.6 V 1008.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 1020.6 H 179.4 V 1031.4 H 168.6 V 1020.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 1032.6 H 179.4 V 1043.4 H 168.6 V 1032.6 Z",
    style: {
      fill: "#a3a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 1044.6 H 179.4 V 1055.4 H 168.6 V 1044.6 Z",
    style: {
      fill: "#a7adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 1056.6 H 179.4 V 1067.4 H 168.6 V 1056.6 Z",
    style: {
      fill: "rgba(175,183,185,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 168.6 1116.6 H 179.4 V 1127.4 H 168.6 V 1116.6 Z",
    style: {
      fill: "rgba(191,191,191,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 480.6 H 191.4 V 491.4 H 180.6 V 480.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 492.6 H 191.4 V 503.4 H 180.6 V 492.6 Z",
    style: {
      fill: "rgba(221,225,225,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 504.6 H 191.4 V 515.4 H 180.6 V 504.6 Z",
    style: {
      fill: "#c4c8cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 516.6 H 191.4 V 527.4 H 180.6 V 516.6 Z",
    style: {
      fill: "#b7bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 528.6 H 191.4 V 539.4 H 180.6 V 528.6 Z",
    style: {
      fill: "#b1b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 540.6 H 191.4 V 551.4 H 180.6 V 540.6 Z",
    style: {
      fill: "#b6bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 552.6 H 191.4 V 563.4 H 180.6 V 552.6 Z",
    style: {
      fill: "#c3c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 564.6 H 191.4 V 575.4 H 180.6 V 564.6 Z",
    style: {
      fill: "rgba(223,234,230,0.68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 732.6 H 191.4 V 743.4 H 180.6 V 732.6 Z",
    style: {
      fill: "rgba(222,236,230,0.91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 744.6 H 191.4 V 755.4 H 180.6 V 744.6 Z",
    style: {
      fill: "#bfc2c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 756.6 H 191.4 V 767.4 H 180.6 V 756.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 768.6 H 191.4 V 779.4 H 180.6 V 768.6 Z",
    style: {
      fill: "#aab0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 780.6 H 191.4 V 791.4 H 180.6 V 780.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 792.6 H 191.4 V 803.4 H 180.6 V 792.6 Z",
    style: {
      fill: "#abb0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 804.6 H 191.4 V 815.4 H 180.6 V 804.6 Z",
    style: {
      fill: "rgba(182,196,196,0.76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 972.6 H 191.4 V 983.4 H 180.6 V 972.6 Z",
    style: {
      fill: "rgba(191,191,191,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 984.6 H 191.4 V 995.4 H 180.6 V 984.6 Z",
    style: {
      fill: "rgba(169,174,177,0.92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 996.6 H 191.4 V 1007.4 H 180.6 V 996.6 Z",
    style: {
      fill: "#a3a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 1008.6 H 191.4 V 1019.4 H 180.6 V 1008.6 Z",
    style: {
      fill: "#a1a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 1020.6 H 191.4 V 1031.4 H 180.6 V 1020.6 Z",
    style: {
      fill: "#a2a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 1032.6 H 191.4 V 1043.4 H 180.6 V 1032.6 Z",
    style: {
      fill: "#a7adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 1044.6 H 191.4 V 1055.4 H 180.6 V 1044.6 Z",
    style: {
      fill: "rgba(177,186,188,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 180.6 1116.6 H 191.4 V 1127.4 H 180.6 V 1116.6 Z",
    style: {
      fill: "rgba(170,170,170,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 480.6 H 203.4 V 491.4 H 192.6 V 480.6 Z",
    style: {
      fill: "rgba(221,225,226,0.86)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 492.6 H 203.4 V 503.4 H 192.6 V 492.6 Z",
    style: {
      fill: "#c3c7cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 504.6 H 203.4 V 515.4 H 192.6 V 504.6 Z",
    style: {
      fill: "#b6bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 516.6 H 203.4 V 527.4 H 192.6 V 516.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 528.6 H 203.4 V 539.4 H 192.6 V 528.6 Z",
    style: {
      fill: "#b7bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 540.6 H 203.4 V 551.4 H 192.6 V 540.6 Z",
    style: {
      fill: "#c2c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 552.6 H 203.4 V 563.4 H 192.6 V 552.6 Z",
    style: {
      fill: "rgba(224,236,230,0.73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 720.6 H 203.4 V 731.4 H 192.6 V 720.6 Z",
    style: {
      fill: "rgba(224,235,230,0.92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 732.6 H 203.4 V 743.4 H 192.6 V 732.6 Z",
    style: {
      fill: "#bfc2c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 744.6 H 203.4 V 755.4 H 192.6 V 744.6 Z",
    style: {
      fill: "#b2b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 756.6 H 203.4 V 767.4 H 192.6 V 756.6 Z",
    style: {
      fill: "#a9aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 768.6 H 203.4 V 779.4 H 192.6 V 768.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 780.6 H 203.4 V 791.4 H 192.6 V 780.6 Z",
    style: {
      fill: "#abb1b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 792.6 H 203.4 V 803.4 H 192.6 V 792.6 Z",
    style: {
      fill: "rgba(184,196,195,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 960.6 H 203.4 V 971.4 H 192.6 V 960.6 Z",
    style: {
      fill: "rgba(182,200,200,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 972.6 H 203.4 V 983.4 H 192.6 V 972.6 Z",
    style: {
      fill: "rgba(169,175,178,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 984.6 H 203.4 V 995.4 H 192.6 V 984.6 Z",
    style: {
      fill: "#a3a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 996.6 H 203.4 V 1007.4 H 192.6 V 996.6 Z",
    style: {
      fill: "#a0a5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 1008.6 H 203.4 V 1019.4 H 192.6 V 1008.6 Z",
    style: {
      fill: "#a1a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 1020.6 H 203.4 V 1031.4 H 192.6 V 1020.6 Z",
    style: {
      fill: "#a7adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.6 1032.6 H 203.4 V 1043.4 H 192.6 V 1032.6 Z",
    style: {
      fill: "rgba(177,188,188,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 456.6 H 215.4 V 467.4 H 204.6 V 456.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 468.6 H 215.4 V 479.4 H 204.6 V 468.6 Z",
    style: {
      fill: "rgba(230,235,236,0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 480.6 H 215.4 V 491.4 H 204.6 V 480.6 Z",
    style: {
      fill: "#c4c7cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 492.6 H 215.4 V 503.4 H 204.6 V 492.6 Z",
    style: {
      fill: "#b6bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 504.6 H 215.4 V 515.4 H 204.6 V 504.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 516.6 H 215.4 V 527.4 H 204.6 V 516.6 Z",
    style: {
      fill: "#b8bdc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 528.6 H 215.4 V 539.4 H 204.6 V 528.6 Z",
    style: {
      fill: "#c5cacc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 540.6 H 215.4 V 551.4 H 204.6 V 540.6 Z",
    style: {
      fill: "rgba(223,236,231,0.72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 708.6 H 215.4 V 719.4 H 204.6 V 708.6 Z",
    style: {
      fill: "rgba(223,237,230,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 720.6 H 215.4 V 731.4 H 204.6 V 720.6 Z",
    style: {
      fill: "#bfc2c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 732.6 H 215.4 V 743.4 H 204.6 V 732.6 Z",
    style: {
      fill: "#b2b6bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 744.6 H 215.4 V 755.4 H 204.6 V 744.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 756.6 H 215.4 V 767.4 H 204.6 V 756.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 768.6 H 215.4 V 779.4 H 204.6 V 768.6 Z",
    style: {
      fill: "#abb0b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 780.6 H 215.4 V 791.4 H 204.6 V 780.6 Z",
    style: {
      fill: "rgba(184,197,195,0.85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 948.6 H 215.4 V 959.4 H 204.6 V 948.6 Z",
    style: {
      fill: "rgba(186,200,193,0.15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 960.6 H 215.4 V 971.4 H 204.6 V 960.6 Z",
    style: {
      fill: "rgba(170,177,179,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 972.6 H 215.4 V 983.4 H 204.6 V 972.6 Z",
    style: {
      fill: "#a3a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 984.6 H 215.4 V 995.4 H 204.6 V 984.6 Z",
    style: {
      fill: "#9fa6ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 996.6 H 215.4 V 1007.4 H 204.6 V 996.6 Z",
    style: {
      fill: "#a0a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 1008.6 H 215.4 V 1019.4 H 204.6 V 1008.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 204.6 1020.6 H 215.4 V 1031.4 H 204.6 V 1020.6 Z",
    style: {
      fill: "rgba(176,186,187,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 456.6 H 227.4 V 467.4 H 216.6 V 456.6 Z",
    style: {
      fill: "rgba(239,245,246,0.92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 468.6 H 227.4 V 479.4 H 216.6 V 468.6 Z",
    style: {
      fill: "#c6c9cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 480.6 H 227.4 V 491.4 H 216.6 V 480.6 Z",
    style: {
      fill: "#b7bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 492.6 H 227.4 V 503.4 H 216.6 V 492.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 504.6 H 227.4 V 515.4 H 216.6 V 504.6 Z",
    style: {
      fill: "#b9bdc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 516.6 H 227.4 V 527.4 H 216.6 V 516.6 Z",
    style: {
      fill: "rgba(205,213,212,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 528.6 H 227.4 V 539.4 H 216.6 V 528.6 Z",
    style: {
      fill: "rgba(225,237,232,0.71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 696.6 H 227.4 V 707.4 H 216.6 V 696.6 Z",
    style: {
      fill: "rgba(224,238,232,0.88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 708.6 H 227.4 V 719.4 H 216.6 V 708.6 Z",
    style: {
      fill: "#c0c3c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 720.6 H 227.4 V 731.4 H 216.6 V 720.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 732.6 H 227.4 V 743.4 H 216.6 V 732.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 744.6 H 227.4 V 755.4 H 216.6 V 744.6 Z",
    style: {
      fill: "#a6abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 756.6 H 227.4 V 767.4 H 216.6 V 756.6 Z",
    style: {
      fill: "#aaafb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 768.6 H 227.4 V 779.4 H 216.6 V 768.6 Z",
    style: {
      fill: "rgba(184,196,196,0.76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 936.6 H 227.4 V 947.4 H 216.6 V 936.6 Z",
    style: {
      fill: "rgba(184,201,196,0.24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 948.6 H 227.4 V 959.4 H 216.6 V 948.6 Z",
    style: {
      fill: "rgba(172,178,181,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 960.6 H 227.4 V 971.4 H 216.6 V 960.6 Z",
    style: {
      fill: "#a4a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 972.6 H 227.4 V 983.4 H 216.6 V 972.6 Z",
    style: {
      fill: "#9fa5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 984.6 H 227.4 V 995.4 H 216.6 V 984.6 Z",
    style: {
      fill: "#9fa5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 996.6 H 227.4 V 1007.4 H 216.6 V 996.6 Z",
    style: {
      fill: "#a4aab1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216.6 1008.6 H 227.4 V 1019.4 H 216.6 V 1008.6 Z",
    style: {
      fill: "rgba(173,181,184,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 444.6 H 239.4 V 455.4 H 228.6 V 444.6 Z",
    style: {
      fill: "rgba(238,244,245,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 456.6 H 239.4 V 467.4 H 228.6 V 456.6 Z",
    style: {
      fill: "#c7cacf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 468.6 H 239.4 V 479.4 H 228.6 V 468.6 Z",
    style: {
      fill: "#b9bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 480.6 H 239.4 V 491.4 H 228.6 V 480.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 492.6 H 239.4 V 503.4 H 228.6 V 492.6 Z",
    style: {
      fill: "#b9bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 504.6 H 239.4 V 515.4 H 228.6 V 504.6 Z",
    style: {
      fill: "rgba(204,212,211,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 516.6 H 239.4 V 527.4 H 228.6 V 516.6 Z",
    style: {
      fill: "rgba(224,236,231,0.58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 684.6 H 239.4 V 695.4 H 228.6 V 684.6 Z",
    style: {
      fill: "rgba(223,236,231,0.91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 696.6 H 239.4 V 707.4 H 228.6 V 696.6 Z",
    style: {
      fill: "#c0c4c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 708.6 H 239.4 V 719.4 H 228.6 V 708.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 720.6 H 239.4 V 731.4 H 228.6 V 720.6 Z",
    style: {
      fill: "#a9aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 732.6 H 239.4 V 743.4 H 228.6 V 732.6 Z",
    style: {
      fill: "#a6abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 744.6 H 239.4 V 755.4 H 228.6 V 744.6 Z",
    style: {
      fill: "#a9aeb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 756.6 H 239.4 V 767.4 H 228.6 V 756.6 Z",
    style: {
      fill: "rgba(182,195,193,0.6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 924.6 H 239.4 V 935.4 H 228.6 V 924.6 Z",
    style: {
      fill: "rgba(185,202,197,0.24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 936.6 H 239.4 V 947.4 H 228.6 V 936.6 Z",
    style: {
      fill: "#aeb5b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 948.6 H 239.4 V 959.4 H 228.6 V 948.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 960.6 H 239.4 V 971.4 H 228.6 V 960.6 Z",
    style: {
      fill: "#a0a6ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 972.6 H 239.4 V 983.4 H 228.6 V 972.6 Z",
    style: {
      fill: "#9fa5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 984.6 H 239.4 V 995.4 H 228.6 V 984.6 Z",
    style: {
      fill: "#a3a8af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 228.6 996.6 H 239.4 V 1007.4 H 228.6 V 996.6 Z",
    style: {
      fill: "rgba(172,180,181,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 420.6 H 251.4 V 431.4 H 240.6 V 420.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 432.6 H 251.4 V 443.4 H 240.6 V 432.6 Z",
    style: {
      fill: "rgba(239,244,246,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 444.6 H 251.4 V 455.4 H 240.6 V 444.6 Z",
    style: {
      fill: "#c7cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 456.6 H 251.4 V 467.4 H 240.6 V 456.6 Z",
    style: {
      fill: "#b9bec5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 468.6 H 251.4 V 479.4 H 240.6 V 468.6 Z",
    style: {
      fill: "#b3b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 480.6 H 251.4 V 491.4 H 240.6 V 480.6 Z",
    style: {
      fill: "#b9bec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 492.6 H 251.4 V 503.4 H 240.6 V 492.6 Z",
    style: {
      fill: "#c7cdcd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 504.6 H 251.4 V 515.4 H 240.6 V 504.6 Z",
    style: {
      fill: "rgba(223,236,231,0.38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 672.6 H 251.4 V 683.4 H 240.6 V 672.6 Z",
    style: {
      fill: "rgba(224,237,232,0.91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 684.6 H 251.4 V 695.4 H 240.6 V 684.6 Z",
    style: {
      fill: "#c0c4c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 696.6 H 251.4 V 707.4 H 240.6 V 696.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 708.6 H 251.4 V 719.4 H 240.6 V 708.6 Z",
    style: {
      fill: "#aaafb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 720.6 H 251.4 V 731.4 H 240.6 V 720.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 732.6 H 251.4 V 743.4 H 240.6 V 732.6 Z",
    style: {
      fill: "#a9aeb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 744.6 H 251.4 V 755.4 H 240.6 V 744.6 Z",
    style: {
      fill: "rgba(181,195,193,0.75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 912.6 H 251.4 V 923.4 H 240.6 V 912.6 Z",
    style: {
      fill: "rgba(184,200,196,0.25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 924.6 H 251.4 V 935.4 H 240.6 V 924.6 Z",
    style: {
      fill: "#adb4b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 936.6 H 251.4 V 947.4 H 240.6 V 936.6 Z",
    style: {
      fill: "#a6adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 948.6 H 251.4 V 959.4 H 240.6 V 948.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 960.6 H 251.4 V 971.4 H 240.6 V 960.6 Z",
    style: {
      fill: "#a0a7ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 972.6 H 251.4 V 983.4 H 240.6 V 972.6 Z",
    style: {
      fill: "#a4a9b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 240.6 984.6 H 251.4 V 995.4 H 240.6 V 984.6 Z",
    style: {
      fill: "rgba(171,180,182,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 420.6 H 263.4 V 431.4 H 252.6 V 420.6 Z",
    style: {
      fill: "rgba(233,239,240,0.94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 432.6 H 263.4 V 443.4 H 252.6 V 432.6 Z",
    style: {
      fill: "#c6c8cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 444.6 H 263.4 V 455.4 H 252.6 V 444.6 Z",
    style: {
      fill: "#b8bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 456.6 H 263.4 V 467.4 H 252.6 V 456.6 Z",
    style: {
      fill: "#b3b8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 468.6 H 263.4 V 479.4 H 252.6 V 468.6 Z",
    style: {
      fill: "#b9bec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 480.6 H 263.4 V 491.4 H 252.6 V 480.6 Z",
    style: {
      fill: "#c7cdcd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 492.6 H 263.4 V 503.4 H 252.6 V 492.6 Z",
    style: {
      fill: "rgba(227,238,232,0.53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 660.6 H 263.4 V 671.4 H 252.6 V 660.6 Z",
    style: {
      fill: "rgba(223,236,231,0.88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 672.6 H 263.4 V 683.4 H 252.6 V 672.6 Z",
    style: {
      fill: "#c0c4c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 684.6 H 263.4 V 695.4 H 252.6 V 684.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 696.6 H 263.4 V 707.4 H 252.6 V 696.6 Z",
    style: {
      fill: "#aab0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 708.6 H 263.4 V 719.4 H 252.6 V 708.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 720.6 H 263.4 V 731.4 H 252.6 V 720.6 Z",
    style: {
      fill: "#aab0b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 732.6 H 263.4 V 743.4 H 252.6 V 732.6 Z",
    style: {
      fill: "rgba(182,195,194,0.74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 900.6 H 263.4 V 911.4 H 252.6 V 900.6 Z",
    style: {
      fill: "rgba(186,197,197,0.27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 912.6 H 263.4 V 923.4 H 252.6 V 912.6 Z",
    style: {
      fill: "#adb4b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 924.6 H 263.4 V 935.4 H 252.6 V 924.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 936.6 H 263.4 V 947.4 H 252.6 V 936.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 948.6 H 263.4 V 959.4 H 252.6 V 948.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 960.6 H 263.4 V 971.4 H 252.6 V 960.6 Z",
    style: {
      fill: "#a5abb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 252.6 972.6 H 263.4 V 983.4 H 252.6 V 972.6 Z",
    style: {
      fill: "rgba(173,181,183,0.81)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 396.6 H 275.4 V 407.4 H 264.6 V 396.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 408.6 H 275.4 V 419.4 H 264.6 V 408.6 Z",
    style: {
      fill: "rgba(236,241,242,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 420.6 H 275.4 V 431.4 H 264.6 V 420.6 Z",
    style: {
      fill: "#c5c8cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 432.6 H 275.4 V 443.4 H 264.6 V 432.6 Z",
    style: {
      fill: "#b8bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 444.6 H 275.4 V 455.4 H 264.6 V 444.6 Z",
    style: {
      fill: "#b2b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 456.6 H 275.4 V 467.4 H 264.6 V 456.6 Z",
    style: {
      fill: "#b9bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 468.6 H 275.4 V 479.4 H 264.6 V 468.6 Z",
    style: {
      fill: "#c8cece"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 480.6 H 275.4 V 491.4 H 264.6 V 480.6 Z",
    style: {
      fill: "rgba(226,237,233,0.45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 648.6 H 275.4 V 659.4 H 264.6 V 648.6 Z",
    style: {
      fill: "rgba(221,235,230,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 660.6 H 275.4 V 671.4 H 264.6 V 660.6 Z",
    style: {
      fill: "#bfc3c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 672.6 H 275.4 V 683.4 H 264.6 V 672.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 684.6 H 275.4 V 695.4 H 264.6 V 684.6 Z",
    style: {
      fill: "#aab0b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 696.6 H 275.4 V 707.4 H 264.6 V 696.6 Z",
    style: {
      fill: "#a8aeb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 708.6 H 275.4 V 719.4 H 264.6 V 708.6 Z",
    style: {
      fill: "#acb1b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 720.6 H 275.4 V 731.4 H 264.6 V 720.6 Z",
    style: {
      fill: "rgba(182,195,194,0.54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 888.6 H 275.4 V 899.4 H 264.6 V 888.6 Z",
    style: {
      fill: "rgba(179,193,193,0.15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 900.6 H 275.4 V 911.4 H 264.6 V 900.6 Z",
    style: {
      fill: "#abb1b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 912.6 H 275.4 V 923.4 H 264.6 V 912.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 924.6 H 275.4 V 935.4 H 264.6 V 924.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 936.6 H 275.4 V 947.4 H 264.6 V 936.6 Z",
    style: {
      fill: "#a3a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 948.6 H 275.4 V 959.4 H 264.6 V 948.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.6 960.6 H 275.4 V 971.4 H 264.6 V 960.6 Z",
    style: {
      fill: "rgba(175,184,186,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 384.6 H 287.4 V 395.4 H 276.6 V 384.6 Z",
    style: {
      fill: "rgba(255,255,255,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 396.6 H 287.4 V 407.4 H 276.6 V 396.6 Z",
    style: {
      fill: "rgba(234,239,240,0.82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 408.6 H 287.4 V 419.4 H 276.6 V 408.6 Z",
    style: {
      fill: "#c6c9cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 420.6 H 287.4 V 431.4 H 276.6 V 420.6 Z",
    style: {
      fill: "#b7bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 432.6 H 287.4 V 443.4 H 276.6 V 432.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 444.6 H 287.4 V 455.4 H 276.6 V 444.6 Z",
    style: {
      fill: "#b8bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 456.6 H 287.4 V 467.4 H 276.6 V 456.6 Z",
    style: {
      fill: "#c8cdcd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 468.6 H 287.4 V 479.4 H 276.6 V 468.6 Z",
    style: {
      fill: "rgba(228,237,237,0.11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 636.6 H 287.4 V 647.4 H 276.6 V 636.6 Z",
    style: {
      fill: "rgba(222,237,232,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 648.6 H 287.4 V 659.4 H 276.6 V 648.6 Z",
    style: {
      fill: "#bec2c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 660.6 H 287.4 V 671.4 H 276.6 V 660.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 672.6 H 287.4 V 683.4 H 276.6 V 672.6 Z",
    style: {
      fill: "#aab0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 684.6 H 287.4 V 695.4 H 276.6 V 684.6 Z",
    style: {
      fill: "#a8aeb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 696.6 H 287.4 V 707.4 H 276.6 V 696.6 Z",
    style: {
      fill: "#acb2b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 708.6 H 287.4 V 719.4 H 276.6 V 708.6 Z",
    style: {
      fill: "rgba(185,198,197,0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 876.6 H 287.4 V 887.4 H 276.6 V 876.6 Z",
    style: {
      fill: "rgba(181,195,195,0.15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 888.6 H 287.4 V 899.4 H 276.6 V 888.6 Z",
    style: {
      fill: "#a9afb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 900.6 H 287.4 V 911.4 H 276.6 V 900.6 Z",
    style: {
      fill: "#a3a9b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 912.6 H 287.4 V 923.4 H 276.6 V 912.6 Z",
    style: {
      fill: "#a1a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 924.6 H 287.4 V 935.4 H 276.6 V 924.6 Z",
    style: {
      fill: "#a2a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 936.6 H 287.4 V 947.4 H 276.6 V 936.6 Z",
    style: {
      fill: "#a7adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 276.6 948.6 H 287.4 V 959.4 H 276.6 V 948.6 Z",
    style: {
      fill: "rgba(179,188,190,0.53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 372.6 H 299.4 V 383.4 H 288.6 V 372.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 384.6 H 299.4 V 395.4 H 288.6 V 384.6 Z",
    style: {
      fill: "rgba(239,242,242,0.79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 396.6 H 299.4 V 407.4 H 288.6 V 396.6 Z",
    style: {
      fill: "#c6cacf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 408.6 H 299.4 V 419.4 H 288.6 V 408.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 420.6 H 299.4 V 431.4 H 288.6 V 420.6 Z",
    style: {
      fill: "#b3b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 432.6 H 299.4 V 443.4 H 288.6 V 432.6 Z",
    style: {
      fill: "#b9bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 444.6 H 299.4 V 455.4 H 288.6 V 444.6 Z",
    style: {
      fill: "#c7cccd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 456.6 H 299.4 V 467.4 H 288.6 V 456.6 Z",
    style: {
      fill: "rgba(227,241,234,0.14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 624.6 H 299.4 V 635.4 H 288.6 V 624.6 Z",
    style: {
      fill: "rgba(223,236,232,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 636.6 H 299.4 V 647.4 H 288.6 V 636.6 Z",
    style: {
      fill: "#bec2c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 648.6 H 299.4 V 659.4 H 288.6 V 648.6 Z",
    style: {
      fill: "#b1b6bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 660.6 H 299.4 V 671.4 H 288.6 V 660.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 672.6 H 299.4 V 683.4 H 288.6 V 672.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 684.6 H 299.4 V 695.4 H 288.6 V 684.6 Z",
    style: {
      fill: "#acb1b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 696.6 H 299.4 V 707.4 H 288.6 V 696.6 Z",
    style: {
      fill: "rgba(184,197,196,0.76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 864.6 H 299.4 V 875.4 H 288.6 V 864.6 Z",
    style: {
      fill: "rgba(182,196,196,0.22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 876.6 H 299.4 V 887.4 H 288.6 V 876.6 Z",
    style: {
      fill: "#aab0b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 888.6 H 299.4 V 899.4 H 288.6 V 888.6 Z",
    style: {
      fill: "#a3a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 900.6 H 299.4 V 911.4 H 288.6 V 900.6 Z",
    style: {
      fill: "#9fa5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 912.6 H 299.4 V 923.4 H 288.6 V 912.6 Z",
    style: {
      fill: "#a1a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 924.6 H 299.4 V 935.4 H 288.6 V 924.6 Z",
    style: {
      fill: "#a6acb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 288.6 936.6 H 299.4 V 947.4 H 288.6 V 936.6 Z",
    style: {
      fill: "rgba(178,189,189,0.55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 372.6 H 311.4 V 383.4 H 300.6 V 372.6 Z",
    style: {
      fill: "rgba(237,241,242,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 384.6 H 311.4 V 395.4 H 300.6 V 384.6 Z",
    style: {
      fill: "#c7cacf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 396.6 H 311.4 V 407.4 H 300.6 V 396.6 Z",
    style: {
      fill: "#b9bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 408.6 H 311.4 V 419.4 H 300.6 V 408.6 Z",
    style: {
      fill: "#b4b9c1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 420.6 H 311.4 V 431.4 H 300.6 V 420.6 Z",
    style: {
      fill: "#b9bec3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 432.6 H 311.4 V 443.4 H 300.6 V 432.6 Z",
    style: {
      fill: "#c8cdce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 444.6 H 311.4 V 455.4 H 300.6 V 444.6 Z",
    style: {
      fill: "rgba(229,242,235,0.15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 612.6 H 311.4 V 623.4 H 300.6 V 612.6 Z",
    style: {
      fill: "rgba(223,237,232,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 624.6 H 311.4 V 635.4 H 300.6 V 624.6 Z",
    style: {
      fill: "#c0c4c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 636.6 H 311.4 V 647.4 H 300.6 V 636.6 Z",
    style: {
      fill: "#b2b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 648.6 H 311.4 V 659.4 H 300.6 V 648.6 Z",
    style: {
      fill: "#a8adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 660.6 H 311.4 V 671.4 H 300.6 V 660.6 Z",
    style: {
      fill: "#a6acb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 672.6 H 311.4 V 683.4 H 300.6 V 672.6 Z",
    style: {
      fill: "#abb0b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 684.6 H 311.4 V 695.4 H 300.6 V 684.6 Z",
    style: {
      fill: "rgba(184,198,195,0.77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 852.6 H 311.4 V 863.4 H 300.6 V 852.6 Z",
    style: {
      fill: "rgba(184,201,197,0.29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 864.6 H 311.4 V 875.4 H 300.6 V 864.6 Z",
    style: {
      fill: "#abb1b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 876.6 H 311.4 V 887.4 H 300.6 V 876.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 888.6 H 311.4 V 899.4 H 300.6 V 888.6 Z",
    style: {
      fill: "#9fa6ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 900.6 H 311.4 V 911.4 H 300.6 V 900.6 Z",
    style: {
      fill: "#9fa5ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 912.6 H 311.4 V 923.4 H 300.6 V 912.6 Z",
    style: {
      fill: "#a4aab1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300.6 924.6 H 311.4 V 935.4 H 300.6 V 924.6 Z",
    style: {
      fill: "rgba(175,185,187,0.85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 348.6 H 323.4 V 359.4 H 312.6 V 348.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 360.6 H 323.4 V 371.4 H 312.6 V 360.6 Z",
    style: {
      fill: "rgba(236,240,242,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 372.6 H 323.4 V 383.4 H 312.6 V 372.6 Z",
    style: {
      fill: "#c6cacf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 384.6 H 323.4 V 395.4 H 312.6 V 384.6 Z",
    style: {
      fill: "#b9bec5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 396.6 H 323.4 V 407.4 H 312.6 V 396.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 408.6 H 323.4 V 419.4 H 312.6 V 408.6 Z",
    style: {
      fill: "#babfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 420.6 H 323.4 V 431.4 H 312.6 V 420.6 Z",
    style: {
      fill: "#cad0cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 432.6 H 323.4 V 443.4 H 312.6 V 432.6 Z",
    style: {
      fill: "rgba(231,239,231,0.13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 600.6 H 323.4 V 611.4 H 312.6 V 600.6 Z",
    style: {
      fill: "rgba(225,238,233,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 612.6 H 323.4 V 623.4 H 312.6 V 612.6 Z",
    style: {
      fill: "#c3c8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 624.6 H 323.4 V 635.4 H 312.6 V 624.6 Z",
    style: {
      fill: "#b3b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 636.6 H 323.4 V 647.4 H 312.6 V 636.6 Z",
    style: {
      fill: "#a8adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 648.6 H 323.4 V 659.4 H 312.6 V 648.6 Z",
    style: {
      fill: "#a6abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 660.6 H 323.4 V 671.4 H 312.6 V 660.6 Z",
    style: {
      fill: "#aaafb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 672.6 H 323.4 V 683.4 H 312.6 V 672.6 Z",
    style: {
      fill: "rgba(183,194,194,0.53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 840.6 H 323.4 V 851.4 H 312.6 V 840.6 Z",
    style: {
      fill: "rgba(184,197,195,0.55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 852.6 H 323.4 V 863.4 H 312.6 V 852.6 Z",
    style: {
      fill: "#abb1b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 864.6 H 323.4 V 875.4 H 312.6 V 864.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 876.6 H 323.4 V 887.4 H 312.6 V 876.6 Z",
    style: {
      fill: "#9fa6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 888.6 H 323.4 V 899.4 H 312.6 V 888.6 Z",
    style: {
      fill: "#9ea5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 900.6 H 323.4 V 911.4 H 312.6 V 900.6 Z",
    style: {
      fill: "#a1a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 312.6 912.6 H 323.4 V 923.4 H 312.6 V 912.6 Z",
    style: {
      fill: "rgba(169,172,176,0.27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 336.6 H 335.4 V 347.4 H 324.6 V 336.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 348.6 H 335.4 V 359.4 H 324.6 V 348.6 Z",
    style: {
      fill: "rgba(233,237,239,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 360.6 H 335.4 V 371.4 H 324.6 V 360.6 Z",
    style: {
      fill: "#c6c9cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 372.6 H 335.4 V 383.4 H 324.6 V 372.6 Z",
    style: {
      fill: "#b9bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 384.6 H 335.4 V 395.4 H 324.6 V 384.6 Z",
    style: {
      fill: "#b4bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 396.6 H 335.4 V 407.4 H 324.6 V 396.6 Z",
    style: {
      fill: "#bbbfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 408.6 H 335.4 V 419.4 H 324.6 V 408.6 Z",
    style: {
      fill: "#ccd2d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 420.6 H 335.4 V 431.4 H 324.6 V 420.6 Z",
    style: {
      fill: "rgba(231,239,239,0.13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 588.6 H 335.4 V 599.4 H 324.6 V 588.6 Z",
    style: {
      fill: "rgba(223,236,232,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 600.6 H 335.4 V 611.4 H 324.6 V 600.6 Z",
    style: {
      fill: "#c5cbcb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 612.6 H 335.4 V 623.4 H 324.6 V 612.6 Z",
    style: {
      fill: "#b3b8bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 624.6 H 335.4 V 635.4 H 324.6 V 624.6 Z",
    style: {
      fill: "#a9aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 636.6 H 335.4 V 647.4 H 324.6 V 636.6 Z",
    style: {
      fill: "#a5aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 648.6 H 335.4 V 659.4 H 324.6 V 648.6 Z",
    style: {
      fill: "#a9aeb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 660.6 H 335.4 V 671.4 H 324.6 V 660.6 Z",
    style: {
      fill: "rgba(182,194,194,0.59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 828.6 H 335.4 V 839.4 H 324.6 V 828.6 Z",
    style: {
      fill: "rgba(182,197,197,0.26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 840.6 H 335.4 V 851.4 H 324.6 V 840.6 Z",
    style: {
      fill: "#abb1b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 852.6 H 335.4 V 863.4 H 324.6 V 852.6 Z",
    style: {
      fill: "#a5abb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 864.6 H 335.4 V 875.4 H 324.6 V 864.6 Z",
    style: {
      fill: "#a0a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 876.6 H 335.4 V 887.4 H 324.6 V 876.6 Z",
    style: {
      fill: "#9ea4ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 888.6 H 335.4 V 899.4 H 324.6 V 888.6 Z",
    style: {
      fill: "#9ea5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 324.6 900.6 H 335.4 V 911.4 H 324.6 V 900.6 Z",
    style: {
      fill: "rgba(164,175,179,0.47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 336.6 H 347.4 V 347.4 H 336.6 V 336.6 Z",
    style: {
      fill: "rgba(232,237,239,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 348.6 H 347.4 V 359.4 H 336.6 V 348.6 Z",
    style: {
      fill: "#c5c8cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 360.6 H 347.4 V 371.4 H 336.6 V 360.6 Z",
    style: {
      fill: "#b8bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 372.6 H 347.4 V 383.4 H 336.6 V 372.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 384.6 H 347.4 V 395.4 H 336.6 V 384.6 Z",
    style: {
      fill: "#bbbfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 396.6 H 347.4 V 407.4 H 336.6 V 396.6 Z",
    style: {
      fill: "#cbd0d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 408.6 H 347.4 V 419.4 H 336.6 V 408.6 Z",
    style: {
      fill: "rgba(230,239,233,0.31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 576.6 H 347.4 V 587.4 H 336.6 V 576.6 Z",
    style: {
      fill: "rgba(222,235,231,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 588.6 H 347.4 V 599.4 H 336.6 V 588.6 Z",
    style: {
      fill: "#bfc3c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 600.6 H 347.4 V 611.4 H 336.6 V 600.6 Z",
    style: {
      fill: "#b2b8bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 612.6 H 347.4 V 623.4 H 336.6 V 612.6 Z",
    style: {
      fill: "#a9aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 624.6 H 347.4 V 635.4 H 336.6 V 624.6 Z",
    style: {
      fill: "#a5aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 636.6 H 347.4 V 647.4 H 336.6 V 636.6 Z",
    style: {
      fill: "#a8adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 648.6 H 347.4 V 659.4 H 336.6 V 648.6 Z",
    style: {
      fill: "rgba(179,192,192,0.32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 816.6 H 347.4 V 827.4 H 336.6 V 816.6 Z",
    style: {
      fill: "rgba(183,197,194,0.36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 828.6 H 347.4 V 839.4 H 336.6 V 828.6 Z",
    style: {
      fill: "#abb0b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 840.6 H 347.4 V 851.4 H 336.6 V 840.6 Z",
    style: {
      fill: "#a5abb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 852.6 H 347.4 V 863.4 H 336.6 V 852.6 Z",
    style: {
      fill: "#a1a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 864.6 H 347.4 V 875.4 H 336.6 V 864.6 Z",
    style: {
      fill: "#9fa6b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 876.6 H 347.4 V 887.4 H 336.6 V 876.6 Z",
    style: {
      fill: "#9ea5af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 888.6 H 347.4 V 899.4 H 336.6 V 888.6 Z",
    style: {
      fill: "#9ea5af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 900.6 H 347.4 V 911.4 H 336.6 V 900.6 Z",
    style: {
      fill: "#a1a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.6 912.6 H 347.4 V 923.4 H 336.6 V 912.6 Z",
    style: {
      fill: "rgba(163,173,173,0.1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 312.6 H 359.4 V 323.4 H 348.6 V 312.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 324.6 H 359.4 V 335.4 H 348.6 V 324.6 Z",
    style: {
      fill: "rgba(236,240,242,0.82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 336.6 H 359.4 V 347.4 H 348.6 V 336.6 Z",
    style: {
      fill: "#c6c9cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 348.6 H 359.4 V 359.4 H 348.6 V 348.6 Z",
    style: {
      fill: "#b8bcc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 360.6 H 359.4 V 371.4 H 348.6 V 360.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 372.6 H 359.4 V 383.4 H 348.6 V 372.6 Z",
    style: {
      fill: "#babfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 384.6 H 359.4 V 395.4 H 348.6 V 384.6 Z",
    style: {
      fill: "#cbd1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 396.6 H 359.4 V 407.4 H 348.6 V 396.6 Z",
    style: {
      fill: "rgba(229,242,233,0.23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 552.6 H 359.4 V 563.4 H 348.6 V 552.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 564.6 H 359.4 V 575.4 H 348.6 V 564.6 Z",
    style: {
      fill: "rgba(223,236,232,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 576.6 H 359.4 V 587.4 H 348.6 V 576.6 Z",
    style: {
      fill: "#bec3c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 588.6 H 359.4 V 599.4 H 348.6 V 588.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 600.6 H 359.4 V 611.4 H 348.6 V 600.6 Z",
    style: {
      fill: "#a9aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 612.6 H 359.4 V 623.4 H 348.6 V 612.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 624.6 H 359.4 V 635.4 H 348.6 V 624.6 Z",
    style: {
      fill: "#a8adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 636.6 H 359.4 V 647.4 H 348.6 V 636.6 Z",
    style: {
      fill: "rgba(175,186,186,0.58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 804.6 H 359.4 V 815.4 H 348.6 V 804.6 Z",
    style: {
      fill: "rgba(188,201,201,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 816.6 H 359.4 V 827.4 H 348.6 V 816.6 Z",
    style: {
      fill: "#aaafb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 828.6 H 359.4 V 839.4 H 348.6 V 828.6 Z",
    style: {
      fill: "#a5aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 840.6 H 359.4 V 851.4 H 348.6 V 840.6 Z",
    style: {
      fill: "#a2a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 852.6 H 359.4 V 863.4 H 348.6 V 852.6 Z",
    style: {
      fill: "#a2a8b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 864.6 H 359.4 V 875.4 H 348.6 V 864.6 Z",
    style: {
      fill: "#a2a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 876.6 H 359.4 V 887.4 H 348.6 V 876.6 Z",
    style: {
      fill: "#a1a7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 888.6 H 359.4 V 899.4 H 348.6 V 888.6 Z",
    style: {
      fill: "#9fa6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 900.6 H 359.4 V 911.4 H 348.6 V 900.6 Z",
    style: {
      fill: "#9fa6b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 912.6 H 359.4 V 923.4 H 348.6 V 912.6 Z",
    style: {
      fill: "#a3a9b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 348.6 924.6 H 359.4 V 935.4 H 348.6 V 924.6 Z",
    style: {
      fill: "rgba(174,174,174,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 300.6 H 371.4 V 311.4 H 360.6 V 300.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 312.6 H 371.4 V 323.4 H 360.6 V 312.6 Z",
    style: {
      fill: "rgba(239,243,245,0.83)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 324.6 H 371.4 V 335.4 H 360.6 V 324.6 Z",
    style: {
      fill: "#c6c9cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 336.6 H 371.4 V 347.4 H 360.6 V 336.6 Z",
    style: {
      fill: "#b8bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 348.6 H 371.4 V 359.4 H 360.6 V 348.6 Z",
    style: {
      fill: "#b3b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 360.6 H 371.4 V 371.4 H 360.6 V 360.6 Z",
    style: {
      fill: "#babdc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 372.6 H 371.4 V 383.4 H 360.6 V 372.6 Z",
    style: {
      fill: "#cbd1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 384.6 H 371.4 V 395.4 H 360.6 V 384.6 Z",
    style: {
      fill: "rgba(227,239,234,0.43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 552.6 H 371.4 V 563.4 H 360.6 V 552.6 Z",
    style: {
      fill: "rgba(221,234,230,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 564.6 H 371.4 V 575.4 H 360.6 V 564.6 Z",
    style: {
      fill: "#bdc2c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 576.6 H 371.4 V 587.4 H 360.6 V 576.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 588.6 H 371.4 V 599.4 H 360.6 V 588.6 Z",
    style: {
      fill: "#a9afb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 600.6 H 371.4 V 611.4 H 360.6 V 600.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 612.6 H 371.4 V 623.4 H 360.6 V 612.6 Z",
    style: {
      fill: "#aaafb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 624.6 H 371.4 V 635.4 H 360.6 V 624.6 Z",
    style: {
      fill: "rgba(178,189,189,0.36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 792.6 H 371.4 V 803.4 H 360.6 V 792.6 Z",
    style: {
      fill: "rgba(179,204,204,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 804.6 H 371.4 V 815.4 H 360.6 V 804.6 Z",
    style: {
      fill: "#a9aeb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 816.6 H 371.4 V 827.4 H 360.6 V 816.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 828.6 H 371.4 V 839.4 H 360.6 V 828.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 840.6 H 371.4 V 851.4 H 360.6 V 840.6 Z",
    style: {
      fill: "#a4aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 852.6 H 371.4 V 863.4 H 360.6 V 852.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 864.6 H 371.4 V 875.4 H 360.6 V 864.6 Z",
    style: {
      fill: "#afbbbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 876.6 H 371.4 V 887.4 H 360.6 V 876.6 Z",
    style: {
      fill: "#a7adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 888.6 H 371.4 V 899.4 H 360.6 V 888.6 Z",
    style: {
      fill: "#a3a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 900.6 H 371.4 V 911.4 H 360.6 V 900.6 Z",
    style: {
      fill: "#9fa6b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 912.6 H 371.4 V 923.4 H 360.6 V 912.6 Z",
    style: {
      fill: "#9fa5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 924.6 H 371.4 V 935.4 H 360.6 V 924.6 Z",
    style: {
      fill: "#a3a9b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 360.6 936.6 H 371.4 V 947.4 H 360.6 V 936.6 Z",
    style: {
      fill: "rgba(172,184,184,0.34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 288.6 H 383.4 V 299.4 H 372.6 V 288.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 300.6 H 383.4 V 311.4 H 372.6 V 300.6 Z",
    style: {
      fill: "rgba(241,245,247,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 312.6 H 383.4 V 323.4 H 372.6 V 312.6 Z",
    style: {
      fill: "#c7cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 324.6 H 383.4 V 335.4 H 372.6 V 324.6 Z",
    style: {
      fill: "#b8bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 336.6 H 383.4 V 347.4 H 372.6 V 336.6 Z",
    style: {
      fill: "#b3b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 348.6 H 383.4 V 359.4 H 372.6 V 348.6 Z",
    style: {
      fill: "#b9bdc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 360.6 H 383.4 V 371.4 H 372.6 V 360.6 Z",
    style: {
      fill: "#cbd1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 372.6 H 383.4 V 383.4 H 372.6 V 372.6 Z",
    style: {
      fill: "rgba(229,242,235,0.15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 540.6 H 383.4 V 551.4 H 372.6 V 540.6 Z",
    style: {
      fill: "rgba(218,230,227,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 552.6 H 383.4 V 563.4 H 372.6 V 552.6 Z",
    style: {
      fill: "#bcc0c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 564.6 H 383.4 V 575.4 H 372.6 V 564.6 Z",
    style: {
      fill: "#b0b5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 576.6 H 383.4 V 587.4 H 372.6 V 576.6 Z",
    style: {
      fill: "#a9afb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 588.6 H 383.4 V 599.4 H 372.6 V 588.6 Z",
    style: {
      fill: "#a8aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 600.6 H 383.4 V 611.4 H 372.6 V 600.6 Z",
    style: {
      fill: "#abb1b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 612.6 H 383.4 V 623.4 H 372.6 V 612.6 Z",
    style: {
      fill: "rgba(183,197,195,0.45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 780.6 H 383.4 V 791.4 H 372.6 V 780.6 Z",
    style: {
      fill: "rgba(185,195,195,0.3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 792.6 H 383.4 V 803.4 H 372.6 V 792.6 Z",
    style: {
      fill: "rgba(170,177,181,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 804.6 H 383.4 V 815.4 H 372.6 V 804.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 816.6 H 383.4 V 827.4 H 372.6 V 816.6 Z",
    style: {
      fill: "#a1a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 828.6 H 383.4 V 839.4 H 372.6 V 828.6 Z",
    style: {
      fill: "#a3aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 840.6 H 383.4 V 851.4 H 372.6 V 840.6 Z",
    style: {
      fill: "#a9afb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 852.6 H 383.4 V 863.4 H 372.6 V 852.6 Z",
    style: {
      fill: "rgba(181,194,193,0.88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 876.6 H 383.4 V 887.4 H 372.6 V 876.6 Z",
    style: {
      fill: "rgba(182,196,193,0.55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 888.6 H 383.4 V 899.4 H 372.6 V 888.6 Z",
    style: {
      fill: "#a8aeb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 900.6 H 383.4 V 911.4 H 372.6 V 900.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 912.6 H 383.4 V 923.4 H 372.6 V 912.6 Z",
    style: {
      fill: "#9ea5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 924.6 H 383.4 V 935.4 H 372.6 V 924.6 Z",
    style: {
      fill: "#a0a6ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 936.6 H 383.4 V 947.4 H 372.6 V 936.6 Z",
    style: {
      fill: "#a5abb1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372.6 948.6 H 383.4 V 959.4 H 372.6 V 948.6 Z",
    style: {
      fill: "rgba(177,187,187,0.38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 288.6 H 395.4 V 299.4 H 384.6 V 288.6 Z",
    style: {
      fill: "rgba(244,247,249,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 300.6 H 395.4 V 311.4 H 384.6 V 300.6 Z",
    style: {
      fill: "#c8cbcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 312.6 H 395.4 V 323.4 H 384.6 V 312.6 Z",
    style: {
      fill: "#b9bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 324.6 H 395.4 V 335.4 H 384.6 V 324.6 Z",
    style: {
      fill: "#b3b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 336.6 H 395.4 V 347.4 H 384.6 V 336.6 Z",
    style: {
      fill: "#b9bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 348.6 H 395.4 V 359.4 H 384.6 V 348.6 Z",
    style: {
      fill: "#cad0d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 360.6 H 395.4 V 371.4 H 384.6 V 360.6 Z",
    style: {
      fill: "rgba(230,242,236,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 516.6 H 395.4 V 527.4 H 384.6 V 516.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 528.6 H 395.4 V 539.4 H 384.6 V 528.6 Z",
    style: {
      fill: "#dce9e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 540.6 H 395.4 V 551.4 H 384.6 V 540.6 Z",
    style: {
      fill: "#bcc0c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 552.6 H 395.4 V 563.4 H 384.6 V 552.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 564.6 H 395.4 V 575.4 H 384.6 V 564.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 576.6 H 395.4 V 587.4 H 384.6 V 576.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 588.6 H 395.4 V 599.4 H 384.6 V 588.6 Z",
    style: {
      fill: "#acb2b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 600.6 H 395.4 V 611.4 H 384.6 V 600.6 Z",
    style: {
      fill: "rgba(184,199,196,0.67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 768.6 H 395.4 V 779.4 H 384.6 V 768.6 Z",
    style: {
      fill: "rgba(184,198,196,0.42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 780.6 H 395.4 V 791.4 H 384.6 V 780.6 Z",
    style: {
      fill: "rgba(171,177,182,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 792.6 H 395.4 V 803.4 H 384.6 V 792.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 804.6 H 395.4 V 815.4 H 384.6 V 804.6 Z",
    style: {
      fill: "#a1a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 816.6 H 395.4 V 827.4 H 384.6 V 816.6 Z",
    style: {
      fill: "#a3a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 828.6 H 395.4 V 839.4 H 384.6 V 828.6 Z",
    style: {
      fill: "#a9afb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 840.6 H 395.4 V 851.4 H 384.6 V 840.6 Z",
    style: {
      fill: "rgba(181,195,194,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 888.6 H 395.4 V 899.4 H 384.6 V 888.6 Z",
    style: {
      fill: "rgba(179,189,189,0.11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 900.6 H 395.4 V 911.4 H 384.6 V 900.6 Z",
    style: {
      fill: "#a6acb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 912.6 H 395.4 V 923.4 H 384.6 V 912.6 Z",
    style: {
      fill: "#a1a6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 924.6 H 395.4 V 935.4 H 384.6 V 924.6 Z",
    style: {
      fill: "#9ea5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 936.6 H 395.4 V 947.4 H 384.6 V 936.6 Z",
    style: {
      fill: "#a1a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 948.6 H 395.4 V 959.4 H 384.6 V 948.6 Z",
    style: {
      fill: "#a7acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 384.6 960.6 H 395.4 V 971.4 H 384.6 V 960.6 Z",
    style: {
      fill: "rgba(179,192,192,0.54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 276.6 H 407.4 V 287.4 H 396.6 V 276.6 Z",
    style: {
      fill: "rgba(249,253,253,0.94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 288.6 H 407.4 V 299.4 H 396.6 V 288.6 Z",
    style: {
      fill: "#c9ccd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 300.6 H 407.4 V 311.4 H 396.6 V 300.6 Z",
    style: {
      fill: "#babfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 312.6 H 407.4 V 323.4 H 396.6 V 312.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 324.6 H 407.4 V 335.4 H 396.6 V 324.6 Z",
    style: {
      fill: "#b8bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 336.6 H 407.4 V 347.4 H 396.6 V 336.6 Z",
    style: {
      fill: "#c7cdcd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 348.6 H 407.4 V 359.4 H 396.6 V 348.6 Z",
    style: {
      fill: "rgba(230,239,239,0.12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 516.6 H 407.4 V 527.4 H 396.6 V 516.6 Z",
    style: {
      fill: "rgba(217,230,226,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 528.6 H 407.4 V 539.4 H 396.6 V 528.6 Z",
    style: {
      fill: "#bcbfc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 540.6 H 407.4 V 551.4 H 396.6 V 540.6 Z",
    style: {
      fill: "#afb4ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 552.6 H 407.4 V 563.4 H 396.6 V 552.6 Z",
    style: {
      fill: "#a7acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 564.6 H 407.4 V 575.4 H 396.6 V 564.6 Z",
    style: {
      fill: "#a6abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 576.6 H 407.4 V 587.4 H 396.6 V 576.6 Z",
    style: {
      fill: "#abb1b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 588.6 H 407.4 V 599.4 H 396.6 V 588.6 Z",
    style: {
      fill: "rgba(185,198,197,0.69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 756.6 H 407.4 V 767.4 H 396.6 V 756.6 Z",
    style: {
      fill: "rgba(183,195,194,0.67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 768.6 H 407.4 V 779.4 H 396.6 V 768.6 Z",
    style: {
      fill: "#abb1b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 780.6 H 407.4 V 791.4 H 396.6 V 780.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 792.6 H 407.4 V 803.4 H 396.6 V 792.6 Z",
    style: {
      fill: "#a2a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 804.6 H 407.4 V 815.4 H 396.6 V 804.6 Z",
    style: {
      fill: "#a3aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 816.6 H 407.4 V 827.4 H 396.6 V 816.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 828.6 H 407.4 V 839.4 H 396.6 V 828.6 Z",
    style: {
      fill: "rgba(181,193,193,0.77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 900.6 H 407.4 V 911.4 H 396.6 V 900.6 Z",
    style: {
      fill: "rgba(164,182,182,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 912.6 H 407.4 V 923.4 H 396.6 V 912.6 Z",
    style: {
      fill: "#a6acb1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 924.6 H 407.4 V 935.4 H 396.6 V 924.6 Z",
    style: {
      fill: "#a1a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 936.6 H 407.4 V 947.4 H 396.6 V 936.6 Z",
    style: {
      fill: "#9fa6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 948.6 H 407.4 V 959.4 H 396.6 V 948.6 Z",
    style: {
      fill: "#a2a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 960.6 H 407.4 V 971.4 H 396.6 V 960.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 396.6 972.6 H 407.4 V 983.4 H 396.6 V 972.6 Z",
    style: {
      fill: "rgba(181,193,193,0.24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 264.6 H 419.4 V 275.4 H 408.6 V 264.6 Z",
    style: {
      fill: "rgba(248,252,252,0.67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 276.6 H 419.4 V 287.4 H 408.6 V 276.6 Z",
    style: {
      fill: "#cbced2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 288.6 H 419.4 V 299.4 H 408.6 V 288.6 Z",
    style: {
      fill: "#bcc0c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 300.6 H 419.4 V 311.4 H 408.6 V 300.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 312.6 H 419.4 V 323.4 H 408.6 V 312.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 324.6 H 419.4 V 335.4 H 408.6 V 324.6 Z",
    style: {
      fill: "#c5c9ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 336.6 H 419.4 V 347.4 H 408.6 V 336.6 Z",
    style: {
      fill: "rgba(224,236,236,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 492.6 H 419.4 V 503.4 H 408.6 V 492.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 504.6 H 419.4 V 515.4 H 408.6 V 504.6 Z",
    style: {
      fill: "rgba(219,232,228,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 516.6 H 419.4 V 527.4 H 408.6 V 516.6 Z",
    style: {
      fill: "#bbbfc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 528.6 H 419.4 V 539.4 H 408.6 V 528.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 540.6 H 419.4 V 551.4 H 408.6 V 540.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 552.6 H 419.4 V 563.4 H 408.6 V 552.6 Z",
    style: {
      fill: "#a5abb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 564.6 H 419.4 V 575.4 H 408.6 V 564.6 Z",
    style: {
      fill: "#a9aeb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 576.6 H 419.4 V 587.4 H 408.6 V 576.6 Z",
    style: {
      fill: "rgba(185,193,193,0.11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 744.6 H 419.4 V 755.4 H 408.6 V 744.6 Z",
    style: {
      fill: "rgba(181,193,192,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 756.6 H 419.4 V 767.4 H 408.6 V 756.6 Z",
    style: {
      fill: "#aab0b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 768.6 H 419.4 V 779.4 H 408.6 V 768.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 780.6 H 419.4 V 791.4 H 408.6 V 780.6 Z",
    style: {
      fill: "#a2a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 792.6 H 419.4 V 803.4 H 408.6 V 792.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 804.6 H 419.4 V 815.4 H 408.6 V 804.6 Z",
    style: {
      fill: "#a9afb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 816.6 H 419.4 V 827.4 H 408.6 V 816.6 Z",
    style: {
      fill: "rgba(179,189,189,0.75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 912.6 H 419.4 V 923.4 H 408.6 V 912.6 Z",
    style: {
      fill: "rgba(170,191,191,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 924.6 H 419.4 V 935.4 H 408.6 V 924.6 Z",
    style: {
      fill: "#a7adb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 936.6 H 419.4 V 947.4 H 408.6 V 936.6 Z",
    style: {
      fill: "#a2a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 948.6 H 419.4 V 959.4 H 408.6 V 948.6 Z",
    style: {
      fill: "#a1a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 960.6 H 419.4 V 971.4 H 408.6 V 960.6 Z",
    style: {
      fill: "#a3aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 972.6 H 419.4 V 983.4 H 408.6 V 972.6 Z",
    style: {
      fill: "#a8aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 408.6 984.6 H 419.4 V 995.4 H 408.6 V 984.6 Z",
    style: {
      fill: "rgba(181,194,194,0.33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 252.6 H 431.4 V 263.4 H 420.6 V 252.6 Z",
    style: {
      fill: "rgba(255,255,255,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 264.6 H 431.4 V 275.4 H 420.6 V 264.6 Z",
    style: {
      fill: "#d0d3d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 276.6 H 431.4 V 287.4 H 420.6 V 276.6 Z",
    style: {
      fill: "#bec2c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 288.6 H 431.4 V 299.4 H 420.6 V 288.6 Z",
    style: {
      fill: "#b4b9c1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 300.6 H 431.4 V 311.4 H 420.6 V 300.6 Z",
    style: {
      fill: "#b7bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 312.6 H 431.4 V 323.4 H 420.6 V 312.6 Z",
    style: {
      fill: "#c3c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 324.6 H 431.4 V 335.4 H 420.6 V 324.6 Z",
    style: {
      fill: "rgba(226,237,231,0.68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 492.6 H 431.4 V 503.4 H 420.6 V 492.6 Z",
    style: {
      fill: "#dae5e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 504.6 H 431.4 V 515.4 H 420.6 V 504.6 Z",
    style: {
      fill: "#bcbfc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 516.6 H 431.4 V 527.4 H 420.6 V 516.6 Z",
    style: {
      fill: "#aeb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 528.6 H 431.4 V 539.4 H 420.6 V 528.6 Z",
    style: {
      fill: "#a6abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 540.6 H 431.4 V 551.4 H 420.6 V 540.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 552.6 H 431.4 V 563.4 H 420.6 V 552.6 Z",
    style: {
      fill: "#a8adb1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 564.6 H 431.4 V 575.4 H 420.6 V 564.6 Z",
    style: {
      fill: "rgba(185,197,197,0.09)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 732.6 H 431.4 V 743.4 H 420.6 V 732.6 Z",
    style: {
      fill: "rgba(181,193,192,0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 744.6 H 431.4 V 755.4 H 420.6 V 744.6 Z",
    style: {
      fill: "#a9afb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 756.6 H 431.4 V 767.4 H 420.6 V 756.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 768.6 H 431.4 V 779.4 H 420.6 V 768.6 Z",
    style: {
      fill: "#a2a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 780.6 H 431.4 V 791.4 H 420.6 V 780.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 792.6 H 431.4 V 803.4 H 420.6 V 792.6 Z",
    style: {
      fill: "rgba(169,175,182,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 804.6 H 431.4 V 815.4 H 420.6 V 804.6 Z",
    style: {
      fill: "rgba(180,193,193,0.58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 924.6 H 431.4 V 935.4 H 420.6 V 924.6 Z",
    style: {
      fill: "rgba(178,190,190,0.17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 936.6 H 431.4 V 947.4 H 420.6 V 936.6 Z",
    style: {
      fill: "#a9aeb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 948.6 H 431.4 V 959.4 H 420.6 V 948.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 960.6 H 431.4 V 971.4 H 420.6 V 960.6 Z",
    style: {
      fill: "#a2a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 972.6 H 431.4 V 983.4 H 420.6 V 972.6 Z",
    style: {
      fill: "#a3aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 984.6 H 431.4 V 995.4 H 420.6 V 984.6 Z",
    style: {
      fill: "#a8aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 420.6 996.6 H 431.4 V 1007.4 H 420.6 V 996.6 Z",
    style: {
      fill: "rgba(180,193,193,0.62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 252.6 H 443.4 V 263.4 H 432.6 V 252.6 Z",
    style: {
      fill: "rgba(226,230,231,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 264.6 H 443.4 V 275.4 H 432.6 V 264.6 Z",
    style: {
      fill: "#c2c6cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 276.6 H 443.4 V 287.4 H 432.6 V 276.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 288.6 H 443.4 V 299.4 H 432.6 V 288.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 300.6 H 443.4 V 311.4 H 432.6 V 300.6 Z",
    style: {
      fill: "#c2c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 312.6 H 443.4 V 323.4 H 432.6 V 312.6 Z",
    style: {
      fill: "rgba(225,237,232,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 468.6 H 443.4 V 479.4 H 432.6 V 468.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 480.6 H 443.4 V 491.4 H 432.6 V 480.6 Z",
    style: {
      fill: "#dae6e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 492.6 H 443.4 V 503.4 H 432.6 V 492.6 Z",
    style: {
      fill: "#bcc0c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 504.6 H 443.4 V 515.4 H 432.6 V 504.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 516.6 H 443.4 V 527.4 H 432.6 V 516.6 Z",
    style: {
      fill: "#a5abb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 528.6 H 443.4 V 539.4 H 432.6 V 528.6 Z",
    style: {
      fill: "#a2a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 540.6 H 443.4 V 551.4 H 432.6 V 540.6 Z",
    style: {
      fill: "#a5abae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 552.6 H 443.4 V 563.4 H 432.6 V 552.6 Z",
    style: {
      fill: "rgba(179,192,189,0.38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 600.6 H 443.4 V 611.4 H 432.6 V 600.6 Z",
    style: {
      fill: "rgba(170,212,212,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 612.6 H 443.4 V 623.4 H 432.6 V 612.6 Z",
    style: {
      fill: "rgba(204,204,204,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 624.6 H 443.4 V 635.4 H 432.6 V 624.6 Z",
    style: {
      fill: "rgba(198,198,198,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 636.6 H 443.4 V 647.4 H 432.6 V 636.6 Z",
    style: {
      fill: "rgba(191,191,191,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 648.6 H 443.4 V 659.4 H 432.6 V 648.6 Z",
    style: {
      fill: "rgba(191,191,191,0.03)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 720.6 H 443.4 V 731.4 H 432.6 V 720.6 Z",
    style: {
      fill: "rgba(181,193,192,0.63)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 732.6 H 443.4 V 743.4 H 432.6 V 732.6 Z",
    style: {
      fill: "#a8aeb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 744.6 H 443.4 V 755.4 H 432.6 V 744.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 756.6 H 443.4 V 767.4 H 432.6 V 756.6 Z",
    style: {
      fill: "#a2a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 768.6 H 443.4 V 779.4 H 432.6 V 768.6 Z",
    style: {
      fill: "#a5acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 780.6 H 443.4 V 791.4 H 432.6 V 780.6 Z",
    style: {
      fill: "rgba(170,177,182,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 792.6 H 443.4 V 803.4 H 432.6 V 792.6 Z",
    style: {
      fill: "rgba(181,195,193,0.5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 936.6 H 443.4 V 947.4 H 432.6 V 936.6 Z",
    style: {
      fill: "rgba(181,195,195,0.3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 948.6 H 443.4 V 959.4 H 432.6 V 948.6 Z",
    style: {
      fill: "#aab0b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 960.6 H 443.4 V 971.4 H 432.6 V 960.6 Z",
    style: {
      fill: "#a5acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 972.6 H 443.4 V 983.4 H 432.6 V 972.6 Z",
    style: {
      fill: "#a2a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 984.6 H 443.4 V 995.4 H 432.6 V 984.6 Z",
    style: {
      fill: "#a3aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 996.6 H 443.4 V 1007.4 H 432.6 V 996.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 432.6 1008.6 H 443.4 V 1019.4 H 432.6 V 1008.6 Z",
    style: {
      fill: "rgba(177,188,191,0.79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 240.6 H 455.4 V 251.4 H 444.6 V 240.6 Z",
    style: {
      fill: "rgba(255,255,255,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 252.6 H 455.4 V 263.4 H 444.6 V 252.6 Z",
    style: {
      fill: "#c9ccd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 264.6 H 455.4 V 275.4 H 444.6 V 264.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 276.6 H 455.4 V 287.4 H 444.6 V 276.6 Z",
    style: {
      fill: "#b3b8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 288.6 H 455.4 V 299.4 H 444.6 V 288.6 Z",
    style: {
      fill: "#bdc1c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 300.6 H 455.4 V 311.4 H 444.6 V 300.6 Z",
    style: {
      fill: "rgba(220,231,228,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 456.6 H 455.4 V 467.4 H 444.6 V 456.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 468.6 H 455.4 V 479.4 H 444.6 V 468.6 Z",
    style: {
      fill: "#dbe7e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 480.6 H 455.4 V 491.4 H 444.6 V 480.6 Z",
    style: {
      fill: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 492.6 H 455.4 V 503.4 H 444.6 V 492.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 504.6 H 455.4 V 515.4 H 444.6 V 504.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 516.6 H 455.4 V 527.4 H 444.6 V 516.6 Z",
    style: {
      fill: "#9fa6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 528.6 H 455.4 V 539.4 H 444.6 V 528.6 Z",
    style: {
      fill: "#a0a6ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 540.6 H 455.4 V 551.4 H 444.6 V 540.6 Z",
    style: {
      fill: "#aab8bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 552.6 H 455.4 V 563.4 H 444.6 V 552.6 Z",
    style: {
      fill: "rgba(169,179,181,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 564.6 H 455.4 V 575.4 H 444.6 V 564.6 Z",
    style: {
      fill: "rgba(168,173,176,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 576.6 H 455.4 V 587.4 H 444.6 V 576.6 Z",
    style: {
      fill: "#a8aeb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 588.6 H 455.4 V 599.4 H 444.6 V 588.6 Z",
    style: {
      fill: "#a8aeb1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 600.6 H 455.4 V 611.4 H 444.6 V 600.6 Z",
    style: {
      fill: "#a8aeb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 612.6 H 455.4 V 623.4 H 444.6 V 612.6 Z",
    style: {
      fill: "#a9aeb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 624.6 H 455.4 V 635.4 H 444.6 V 624.6 Z",
    style: {
      fill: "#a9afb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 636.6 H 455.4 V 647.4 H 444.6 V 636.6 Z",
    style: {
      fill: "rgba(170,176,182,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 648.6 H 455.4 V 659.4 H 444.6 V 648.6 Z",
    style: {
      fill: "rgba(171,177,182,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 660.6 H 455.4 V 671.4 H 444.6 V 660.6 Z",
    style: {
      fill: "rgba(172,179,183,0.91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 672.6 H 455.4 V 683.4 H 444.6 V 672.6 Z",
    style: {
      fill: "rgba(172,182,185,0.82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 684.6 H 455.4 V 695.4 H 444.6 V 684.6 Z",
    style: {
      fill: "rgba(176,189,189,0.45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 696.6 H 455.4 V 707.4 H 444.6 V 696.6 Z",
    style: {
      fill: "rgba(180,188,188,0.24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 708.6 H 455.4 V 719.4 H 444.6 V 708.6 Z",
    style: {
      fill: "rgba(178,192,192,0.84)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 720.6 H 455.4 V 731.4 H 444.6 V 720.6 Z",
    style: {
      fill: "#a7adb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 732.6 H 455.4 V 743.4 H 444.6 V 732.6 Z",
    style: {
      fill: "#a3a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 744.6 H 455.4 V 755.4 H 444.6 V 744.6 Z",
    style: {
      fill: "#a1a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 756.6 H 455.4 V 767.4 H 444.6 V 756.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 768.6 H 455.4 V 779.4 H 444.6 V 768.6 Z",
    style: {
      fill: "rgba(171,177,182,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 780.6 H 455.4 V 791.4 H 444.6 V 780.6 Z",
    style: {
      fill: "rgba(185,197,195,0.51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 948.6 H 455.4 V 959.4 H 444.6 V 948.6 Z",
    style: {
      fill: "rgba(184,198,196,0.58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 960.6 H 455.4 V 971.4 H 444.6 V 960.6 Z",
    style: {
      fill: "#abb1b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 972.6 H 455.4 V 983.4 H 444.6 V 972.6 Z",
    style: {
      fill: "#a5acb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 984.6 H 455.4 V 995.4 H 444.6 V 984.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 996.6 H 455.4 V 1007.4 H 444.6 V 996.6 Z",
    style: {
      fill: "#a2a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 1008.6 H 455.4 V 1019.4 H 444.6 V 1008.6 Z",
    style: {
      fill: "#a6acb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 444.6 1020.6 H 455.4 V 1031.4 H 444.6 V 1020.6 Z",
    style: {
      fill: "rgba(174,184,186,0.69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 240.6 H 467.4 V 251.4 H 456.6 V 240.6 Z",
    style: {
      fill: "rgba(224,228,229,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 252.6 H 467.4 V 263.4 H 456.6 V 252.6 Z",
    style: {
      fill: "#bfc3c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 264.6 H 467.4 V 275.4 H 456.6 V 264.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 276.6 H 467.4 V 287.4 H 456.6 V 276.6 Z",
    style: {
      fill: "#b7bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 288.6 H 467.4 V 299.4 H 456.6 V 288.6 Z",
    style: {
      fill: "rgba(207,215,214,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 300.6 H 467.4 V 311.4 H 456.6 V 300.6 Z",
    style: {
      fill: "rgba(227,240,232,0.4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 444.6 H 467.4 V 455.4 H 456.6 V 444.6 Z",
    style: {
      fill: "rgba(227,238,232,0.18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 456.6 H 467.4 V 467.4 H 456.6 V 456.6 Z",
    style: {
      fill: "#dbe6e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 468.6 H 467.4 V 479.4 H 456.6 V 468.6 Z",
    style: {
      fill: "#bdc2c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 480.6 H 467.4 V 491.4 H 456.6 V 480.6 Z",
    style: {
      fill: "#b0b5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 492.6 H 467.4 V 503.4 H 456.6 V 492.6 Z",
    style: {
      fill: "#a5acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 504.6 H 467.4 V 515.4 H 456.6 V 504.6 Z",
    style: {
      fill: "#9fa6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 516.6 H 467.4 V 527.4 H 456.6 V 516.6 Z",
    style: {
      fill: "#9ea4ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 528.6 H 467.4 V 539.4 H 456.6 V 528.6 Z",
    style: {
      fill: "#9ea5af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 540.6 H 467.4 V 551.4 H 456.6 V 540.6 Z",
    style: {
      fill: "#a1a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 552.6 H 467.4 V 563.4 H 456.6 V 552.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 564.6 H 467.4 V 575.4 H 456.6 V 564.6 Z",
    style: {
      fill: "#a3a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 576.6 H 467.4 V 587.4 H 456.6 V 576.6 Z",
    style: {
      fill: "#a3a9b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 588.6 H 467.4 V 599.4 H 456.6 V 588.6 Z",
    style: {
      fill: "#a4aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 600.6 H 467.4 V 611.4 H 456.6 V 600.6 Z",
    style: {
      fill: "#a4aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 612.6 H 467.4 V 623.4 H 456.6 V 612.6 Z",
    style: {
      fill: "#a4aab4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 624.6 H 467.4 V 635.4 H 456.6 V 624.6 Z",
    style: {
      fill: "#a5abb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 636.6 H 467.4 V 647.4 H 456.6 V 636.6 Z",
    style: {
      fill: "#a5abb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 648.6 H 467.4 V 659.4 H 456.6 V 648.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 660.6 H 467.4 V 671.4 H 456.6 V 660.6 Z",
    style: {
      fill: "#a4abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 672.6 H 467.4 V 683.4 H 456.6 V 672.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 684.6 H 467.4 V 695.4 H 456.6 V 684.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 696.6 H 467.4 V 707.4 H 456.6 V 696.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 708.6 H 467.4 V 719.4 H 456.6 V 708.6 Z",
    style: {
      fill: "#a4a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 720.6 H 467.4 V 731.4 H 456.6 V 720.6 Z",
    style: {
      fill: "#a1a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 732.6 H 467.4 V 743.4 H 456.6 V 732.6 Z",
    style: {
      fill: "#9fa6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 744.6 H 467.4 V 755.4 H 456.6 V 744.6 Z",
    style: {
      fill: "#a2a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 756.6 H 467.4 V 767.4 H 456.6 V 756.6 Z",
    style: {
      fill: "#a8afb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 768.6 H 467.4 V 779.4 H 456.6 V 768.6 Z",
    style: {
      fill: "rgba(184,196,194,0.39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 960.6 H 467.4 V 971.4 H 456.6 V 960.6 Z",
    style: {
      fill: "rgba(184,198,196,0.56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 972.6 H 467.4 V 983.4 H 456.6 V 972.6 Z",
    style: {
      fill: "#abb1b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 984.6 H 467.4 V 995.4 H 456.6 V 984.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 996.6 H 467.4 V 1007.4 H 456.6 V 996.6 Z",
    style: {
      fill: "#a1a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 1008.6 H 467.4 V 1019.4 H 456.6 V 1008.6 Z",
    style: {
      fill: "#a1a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 1020.6 H 467.4 V 1031.4 H 456.6 V 1020.6 Z",
    style: {
      fill: "#a5aab1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 456.6 1032.6 H 467.4 V 1043.4 H 456.6 V 1032.6 Z",
    style: {
      fill: "rgba(173,181,183,0.58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 228.6 H 479.4 V 239.4 H 468.6 V 228.6 Z",
    style: {
      fill: "rgba(255,255,255,0.11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 240.6 H 479.4 V 251.4 H 468.6 V 240.6 Z",
    style: {
      fill: "#cacdd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 252.6 H 479.4 V 263.4 H 468.6 V 252.6 Z",
    style: {
      fill: "#b7bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 264.6 H 479.4 V 275.4 H 468.6 V 264.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 276.6 H 479.4 V 287.4 H 468.6 V 276.6 Z",
    style: {
      fill: "#bfc4c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 288.6 H 479.4 V 299.4 H 468.6 V 288.6 Z",
    style: {
      fill: "rgba(223,236,231,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 432.6 H 479.4 V 443.4 H 468.6 V 432.6 Z",
    style: {
      fill: "rgba(212,255,212,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 444.6 H 479.4 V 455.4 H 468.6 V 444.6 Z",
    style: {
      fill: "#dae5e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 456.6 H 479.4 V 467.4 H 468.6 V 456.6 Z",
    style: {
      fill: "#bdc2c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 468.6 H 479.4 V 479.4 H 468.6 V 468.6 Z",
    style: {
      fill: "#b0b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 480.6 H 479.4 V 491.4 H 468.6 V 480.6 Z",
    style: {
      fill: "#a6adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 492.6 H 479.4 V 503.4 H 468.6 V 492.6 Z",
    style: {
      fill: "#a1a8b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 504.6 H 479.4 V 515.4 H 468.6 V 504.6 Z",
    style: {
      fill: "#a0a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 516.6 H 479.4 V 527.4 H 468.6 V 516.6 Z",
    style: {
      fill: "#a0a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 528.6 H 479.4 V 539.4 H 468.6 V 528.6 Z",
    style: {
      fill: "#a3a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 540.6 H 479.4 V 551.4 H 468.6 V 540.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 552.6 H 479.4 V 563.4 H 468.6 V 552.6 Z",
    style: {
      fill: "#a7aeb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 564.6 H 479.4 V 575.4 H 468.6 V 564.6 Z",
    style: {
      fill: "#a9afb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 576.6 H 479.4 V 587.4 H 468.6 V 576.6 Z",
    style: {
      fill: "#abb0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 588.6 H 479.4 V 599.4 H 468.6 V 588.6 Z",
    style: {
      fill: "#acb0b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 600.6 H 479.4 V 611.4 H 468.6 V 600.6 Z",
    style: {
      fill: "#acb1ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 612.6 H 479.4 V 623.4 H 468.6 V 612.6 Z",
    style: {
      fill: "#adb2bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 624.6 H 479.4 V 635.4 H 468.6 V 624.6 Z",
    style: {
      fill: "#acb2bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 636.6 H 479.4 V 647.4 H 468.6 V 636.6 Z",
    style: {
      fill: "#acb2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 648.6 H 479.4 V 659.4 H 468.6 V 648.6 Z",
    style: {
      fill: "#aab0b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 660.6 H 479.4 V 671.4 H 468.6 V 660.6 Z",
    style: {
      fill: "#a8aeb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 672.6 H 479.4 V 683.4 H 468.6 V 672.6 Z",
    style: {
      fill: "#a6acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 684.6 H 479.4 V 695.4 H 468.6 V 684.6 Z",
    style: {
      fill: "#a4aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 696.6 H 479.4 V 707.4 H 468.6 V 696.6 Z",
    style: {
      fill: "#a2a8b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 708.6 H 479.4 V 719.4 H 468.6 V 708.6 Z",
    style: {
      fill: "#a0a7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 720.6 H 479.4 V 731.4 H 468.6 V 720.6 Z",
    style: {
      fill: "#9fa5af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 732.6 H 479.4 V 743.4 H 468.6 V 732.6 Z",
    style: {
      fill: "#9fa6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 744.6 H 479.4 V 755.4 H 468.6 V 744.6 Z",
    style: {
      fill: "rgba(165,176,180,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 756.6 H 479.4 V 767.4 H 468.6 V 756.6 Z",
    style: {
      fill: "rgba(176,189,191,0.67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 972.6 H 479.4 V 983.4 H 468.6 V 972.6 Z",
    style: {
      fill: "rgba(185,198,196,0.53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 984.6 H 479.4 V 995.4 H 468.6 V 984.6 Z",
    style: {
      fill: "#aab0b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 996.6 H 479.4 V 1007.4 H 468.6 V 996.6 Z",
    style: {
      fill: "#a4a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 1008.6 H 479.4 V 1019.4 H 468.6 V 1008.6 Z",
    style: {
      fill: "#a0a6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 1020.6 H 479.4 V 1031.4 H 468.6 V 1020.6 Z",
    style: {
      fill: "#a0a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 1032.6 H 479.4 V 1043.4 H 468.6 V 1032.6 Z",
    style: {
      fill: "#a4aab1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 468.6 1044.6 H 479.4 V 1055.4 H 468.6 V 1044.6 Z",
    style: {
      fill: "rgba(176,184,186,0.59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 228.6 H 491.4 V 239.4 H 480.6 V 228.6 Z",
    style: {
      fill: "rgba(233,237,238,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 240.6 H 491.4 V 251.4 H 480.6 V 240.6 Z",
    style: {
      fill: "#c2c6cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 252.6 H 491.4 V 263.4 H 480.6 V 252.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 264.6 H 491.4 V 275.4 H 480.6 V 264.6 Z",
    style: {
      fill: "#b6bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 276.6 H 491.4 V 287.4 H 480.6 V 276.6 Z",
    style: {
      fill: "rgba(202,208,208,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 288.6 H 491.4 V 299.4 H 480.6 V 288.6 Z",
    style: {
      fill: "rgba(204,255,255,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 420.6 H 491.4 V 431.4 H 480.6 V 420.6 Z",
    style: {
      fill: "rgba(204,255,255,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 432.6 H 491.4 V 443.4 H 480.6 V 432.6 Z",
    style: {
      fill: "rgba(216,227,225,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 444.6 H 491.4 V 455.4 H 480.6 V 444.6 Z",
    style: {
      fill: "#bcc1c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 456.6 H 491.4 V 467.4 H 480.6 V 456.6 Z",
    style: {
      fill: "#b0b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 468.6 H 491.4 V 479.4 H 480.6 V 468.6 Z",
    style: {
      fill: "#a8aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 480.6 H 491.4 V 491.4 H 480.6 V 480.6 Z",
    style: {
      fill: "#a4abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 492.6 H 491.4 V 503.4 H 480.6 V 492.6 Z",
    style: {
      fill: "#a5acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 504.6 H 491.4 V 515.4 H 480.6 V 504.6 Z",
    style: {
      fill: "#a8aeb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 516.6 H 491.4 V 527.4 H 480.6 V 516.6 Z",
    style: {
      fill: "#acb1b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 528.6 H 491.4 V 539.4 H 480.6 V 528.6 Z",
    style: {
      fill: "#b0b4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 540.6 H 491.4 V 551.4 H 480.6 V 540.6 Z",
    style: {
      fill: "#b4b8bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 552.6 H 491.4 V 563.4 H 480.6 V 552.6 Z",
    style: {
      fill: "#b7bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 564.6 H 491.4 V 575.4 H 480.6 V 564.6 Z",
    style: {
      fill: "#babec2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 576.6 H 491.4 V 587.4 H 480.6 V 576.6 Z",
    style: {
      fill: "#bbbfc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 588.6 H 491.4 V 599.4 H 480.6 V 588.6 Z",
    style: {
      fill: "#bdc0c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 600.6 H 491.4 V 611.4 H 480.6 V 600.6 Z",
    style: {
      fill: "#bdc1c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 612.6 H 491.4 V 623.4 H 480.6 V 612.6 Z",
    style: {
      fill: "#bec2c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 624.6 H 491.4 V 635.4 H 480.6 V 624.6 Z",
    style: {
      fill: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 636.6 H 491.4 V 647.4 H 480.6 V 636.6 Z",
    style: {
      fill: "#bec2c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 648.6 H 491.4 V 659.4 H 480.6 V 648.6 Z",
    style: {
      fill: "#bbc0c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 660.6 H 491.4 V 671.4 H 480.6 V 660.6 Z",
    style: {
      fill: "#b7bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 672.6 H 491.4 V 683.4 H 480.6 V 672.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 684.6 H 491.4 V 695.4 H 480.6 V 684.6 Z",
    style: {
      fill: "#aeb3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 696.6 H 491.4 V 707.4 H 480.6 V 696.6 Z",
    style: {
      fill: "#aaafb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 708.6 H 491.4 V 719.4 H 480.6 V 708.6 Z",
    style: {
      fill: "#a6abb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 720.6 H 491.4 V 731.4 H 480.6 V 720.6 Z",
    style: {
      fill: "#a2a8b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 732.6 H 491.4 V 743.4 H 480.6 V 732.6 Z",
    style: {
      fill: "#a1a7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 744.6 H 491.4 V 755.4 H 480.6 V 744.6 Z",
    style: {
      fill: "#a2a8b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 756.6 H 491.4 V 767.4 H 480.6 V 756.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 768.6 H 491.4 V 779.4 H 480.6 V 768.6 Z",
    style: {
      fill: "rgba(172,180,183,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 780.6 H 491.4 V 791.4 H 480.6 V 780.6 Z",
    style: {
      fill: "rgba(183,196,193,0.37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 984.6 H 491.4 V 995.4 H 480.6 V 984.6 Z",
    style: {
      fill: "rgba(183,196,194,0.46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 996.6 H 491.4 V 1007.4 H 480.6 V 996.6 Z",
    style: {
      fill: "#a9afb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 1008.6 H 491.4 V 1019.4 H 480.6 V 1008.6 Z",
    style: {
      fill: "#a3a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 1020.6 H 491.4 V 1031.4 H 480.6 V 1020.6 Z",
    style: {
      fill: "#a0a6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 1032.6 H 491.4 V 1043.4 H 480.6 V 1032.6 Z",
    style: {
      fill: "#a1a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 1044.6 H 491.4 V 1055.4 H 480.6 V 1044.6 Z",
    style: {
      fill: "#a7acb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 480.6 1056.6 H 491.4 V 1067.4 H 480.6 V 1056.6 Z",
    style: {
      fill: "rgba(178,190,190,0.83)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 216.6 H 503.4 V 227.4 H 492.6 V 216.6 Z",
    style: {
      fill: "rgba(255,255,255,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 228.6 H 503.4 V 239.4 H 492.6 V 228.6 Z",
    style: {
      fill: "#d4d7d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 240.6 H 503.4 V 251.4 H 492.6 V 240.6 Z",
    style: {
      fill: "#babfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 252.6 H 503.4 V 263.4 H 492.6 V 252.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 264.6 H 503.4 V 275.4 H 492.6 V 264.6 Z",
    style: {
      fill: "#bcc0c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 276.6 H 503.4 V 287.4 H 492.6 V 276.6 Z",
    style: {
      fill: "rgba(221,234,229,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 420.6 H 503.4 V 431.4 H 492.6 V 420.6 Z",
    style: {
      fill: "rgba(213,225,222,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 432.6 H 503.4 V 443.4 H 492.6 V 432.6 Z",
    style: {
      fill: "#bbc0c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 444.6 H 503.4 V 455.4 H 492.6 V 444.6 Z",
    style: {
      fill: "#b0b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 456.6 H 503.4 V 467.4 H 492.6 V 456.6 Z",
    style: {
      fill: "#a9afb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 468.6 H 503.4 V 479.4 H 492.6 V 468.6 Z",
    style: {
      fill: "#a8aeb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 480.6 H 503.4 V 491.4 H 492.6 V 480.6 Z",
    style: {
      fill: "#acb2bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 492.6 H 503.4 V 503.4 H 492.6 V 492.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 504.6 H 503.4 V 515.4 H 492.6 V 504.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 516.6 H 503.4 V 527.4 H 492.6 V 516.6 Z",
    style: {
      fill: "#bdc1c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 528.6 H 503.4 V 539.4 H 492.6 V 528.6 Z",
    style: {
      fill: "#c8d0d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 540.6 H 503.4 V 551.4 H 492.6 V 540.6 Z",
    style: {
      fill: "#d5e1df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 552.6 H 503.4 V 563.4 H 492.6 V 552.6 Z",
    style: {
      fill: "rgba(221,236,228,0.47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 564.6 H 503.4 V 575.4 H 492.6 V 564.6 Z",
    style: {
      fill: "rgba(223,238,232,0.67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 576.6 H 503.4 V 587.4 H 492.6 V 576.6 Z",
    style: {
      fill: "rgba(223,235,229,0.5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 588.6 H 503.4 V 599.4 H 492.6 V 588.6 Z",
    style: {
      fill: "rgba(225,237,231,0.17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 600.6 H 503.4 V 611.4 H 492.6 V 600.6 Z",
    style: {
      fill: "rgba(220,234,227,0.14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 612.6 H 503.4 V 623.4 H 492.6 V 612.6 Z",
    style: {
      fill: "rgba(225,237,231,0.33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 624.6 H 503.4 V 635.4 H 492.6 V 624.6 Z",
    style: {
      fill: "rgba(225,237,229,0.62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 636.6 H 503.4 V 647.4 H 492.6 V 636.6 Z",
    style: {
      fill: "rgba(225,237,231,0.72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 648.6 H 503.4 V 659.4 H 492.6 V 648.6 Z",
    style: {
      fill: "rgba(224,237,231,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 660.6 H 503.4 V 671.4 H 492.6 V 660.6 Z",
    style: {
      fill: "#dbe9e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 672.6 H 503.4 V 683.4 H 492.6 V 672.6 Z",
    style: {
      fill: "#c9cfd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 684.6 H 503.4 V 695.4 H 492.6 V 684.6 Z",
    style: {
      fill: "#c0c4c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 696.6 H 503.4 V 707.4 H 492.6 V 696.6 Z",
    style: {
      fill: "#babfc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 708.6 H 503.4 V 719.4 H 492.6 V 708.6 Z",
    style: {
      fill: "#b5b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 720.6 H 503.4 V 731.4 H 492.6 V 720.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 732.6 H 503.4 V 743.4 H 492.6 V 732.6 Z",
    style: {
      fill: "#aaafb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 744.6 H 503.4 V 755.4 H 492.6 V 744.6 Z",
    style: {
      fill: "#a7acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 756.6 H 503.4 V 767.4 H 492.6 V 756.6 Z",
    style: {
      fill: "#a5acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 768.6 H 503.4 V 779.4 H 492.6 V 768.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 780.6 H 503.4 V 791.4 H 492.6 V 780.6 Z",
    style: {
      fill: "#aab0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 792.6 H 503.4 V 803.4 H 492.6 V 792.6 Z",
    style: {
      fill: "rgba(177,185,189,0.85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 804.6 H 503.4 V 815.4 H 492.6 V 804.6 Z",
    style: {
      fill: "rgba(184,201,196,0.24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 996.6 H 503.4 V 1007.4 H 492.6 V 996.6 Z",
    style: {
      fill: "rgba(181,194,194,0.39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 1008.6 H 503.4 V 1019.4 H 492.6 V 1008.6 Z",
    style: {
      fill: "#a8aeb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 1020.6 H 503.4 V 1031.4 H 492.6 V 1020.6 Z",
    style: {
      fill: "#a3a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 1032.6 H 503.4 V 1043.4 H 492.6 V 1032.6 Z",
    style: {
      fill: "#a0a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 1044.6 H 503.4 V 1055.4 H 492.6 V 1044.6 Z",
    style: {
      fill: "#a2a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 1056.6 H 503.4 V 1067.4 H 492.6 V 1056.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 1068.6 H 503.4 V 1079.4 H 492.6 V 1068.6 Z",
    style: {
      fill: "rgba(179,192,193,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 492.6 1116.6 H 503.4 V 1127.4 H 492.6 V 1116.6 Z",
    style: {
      fill: "rgba(127,127,127,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 216.6 H 515.4 V 227.4 H 504.6 V 216.6 Z",
    style: {
      fill: "rgba(248,252,252,0.88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 228.6 H 515.4 V 239.4 H 504.6 V 228.6 Z",
    style: {
      fill: "#c7cacf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 240.6 H 515.4 V 251.4 H 504.6 V 240.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 252.6 H 515.4 V 263.4 H 504.6 V 252.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 264.6 H 515.4 V 275.4 H 504.6 V 264.6 Z",
    style: {
      fill: "#c4c9cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 408.6 H 515.4 V 419.4 H 504.6 V 408.6 Z",
    style: {
      fill: "#d7e3e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 420.6 H 515.4 V 431.4 H 504.6 V 420.6 Z",
    style: {
      fill: "#bbbfc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 432.6 H 515.4 V 443.4 H 504.6 V 432.6 Z",
    style: {
      fill: "#b0b4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 444.6 H 515.4 V 455.4 H 504.6 V 444.6 Z",
    style: {
      fill: "#aab0b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 456.6 H 515.4 V 467.4 H 504.6 V 456.6 Z",
    style: {
      fill: "#acb2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 468.6 H 515.4 V 479.4 H 504.6 V 468.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 480.6 H 515.4 V 491.4 H 504.6 V 480.6 Z",
    style: {
      fill: "#bcc0c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 492.6 H 515.4 V 503.4 H 504.6 V 492.6 Z",
    style: {
      fill: "#c7cdcd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 504.6 H 515.4 V 515.4 H 504.6 V 504.6 Z",
    style: {
      fill: "rgba(221,233,228,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 516.6 H 515.4 V 527.4 H 504.6 V 516.6 Z",
    style: {
      fill: "rgba(223,238,233,0.41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 684.6 H 515.4 V 695.4 H 504.6 V 684.6 Z",
    style: {
      fill: "rgba(221,236,229,0.27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 696.6 H 515.4 V 707.4 H 504.6 V 696.6 Z",
    style: {
      fill: "rgba(222,235,232,0.4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 708.6 H 515.4 V 719.4 H 504.6 V 708.6 Z",
    style: {
      fill: "rgba(213,225,221,0.79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 720.6 H 515.4 V 731.4 H 504.6 V 720.6 Z",
    style: {
      fill: "rgba(193,197,198,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 732.6 H 515.4 V 743.4 H 504.6 V 732.6 Z",
    style: {
      fill: "#bbbfc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 744.6 H 515.4 V 755.4 H 504.6 V 744.6 Z",
    style: {
      fill: "#b4b9be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 756.6 H 515.4 V 767.4 H 504.6 V 756.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 768.6 H 515.4 V 779.4 H 504.6 V 768.6 Z",
    style: {
      fill: "#aab0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 780.6 H 515.4 V 791.4 H 504.6 V 780.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 792.6 H 515.4 V 803.4 H 504.6 V 792.6 Z",
    style: {
      fill: "#a9afb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 804.6 H 515.4 V 815.4 H 504.6 V 804.6 Z",
    style: {
      fill: "#adb5b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 816.6 H 515.4 V 827.4 H 504.6 V 816.6 Z",
    style: {
      fill: "rgba(185,199,197,0.41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 1008.6 H 515.4 V 1019.4 H 504.6 V 1008.6 Z",
    style: {
      fill: "rgba(182,182,182,0.08)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 1020.6 H 515.4 V 1031.4 H 504.6 V 1020.6 Z",
    style: {
      fill: "#a8aeb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 1032.6 H 515.4 V 1043.4 H 504.6 V 1032.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 1044.6 H 515.4 V 1055.4 H 504.6 V 1044.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 1056.6 H 515.4 V 1067.4 H 504.6 V 1056.6 Z",
    style: {
      fill: "#a3aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 1068.6 H 515.4 V 1079.4 H 504.6 V 1068.6 Z",
    style: {
      fill: "#a9afb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 1080.6 H 515.4 V 1091.4 H 504.6 V 1080.6 Z",
    style: {
      fill: "rgba(178,189,191,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 504.6 1116.6 H 515.4 V 1127.4 H 504.6 V 1116.6 Z",
    style: {
      fill: "rgba(170,170,170,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 204.6 H 527.4 V 215.4 H 516.6 V 204.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 216.6 H 527.4 V 227.4 H 516.6 V 216.6 Z",
    style: {
      fill: "rgba(233,237,238,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 228.6 H 527.4 V 239.4 H 516.6 V 228.6 Z",
    style: {
      fill: "#c0c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 240.6 H 527.4 V 251.4 H 516.6 V 240.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 252.6 H 527.4 V 263.4 H 516.6 V 252.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 264.6 H 527.4 V 275.4 H 516.6 V 264.6 Z",
    style: {
      fill: "rgba(215,227,224,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 396.6 H 527.4 V 407.4 H 516.6 V 396.6 Z",
    style: {
      fill: "rgba(218,232,228,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 408.6 H 527.4 V 419.4 H 516.6 V 408.6 Z",
    style: {
      fill: "#bcc0c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 420.6 H 527.4 V 431.4 H 516.6 V 420.6 Z",
    style: {
      fill: "#b0b4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 432.6 H 527.4 V 443.4 H 516.6 V 432.6 Z",
    style: {
      fill: "#abb1b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 444.6 H 527.4 V 455.4 H 516.6 V 444.6 Z",
    style: {
      fill: "#afb5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 456.6 H 527.4 V 467.4 H 516.6 V 456.6 Z",
    style: {
      fill: "#b9bec3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 468.6 H 527.4 V 479.4 H 516.6 V 468.6 Z",
    style: {
      fill: "#c7cccd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 480.6 H 527.4 V 491.4 H 516.6 V 480.6 Z",
    style: {
      fill: "rgba(225,237,232,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 492.6 H 527.4 V 503.4 H 516.6 V 492.6 Z",
    style: {
      fill: "rgba(225,240,240,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 720.6 H 527.4 V 731.4 H 516.6 V 720.6 Z",
    style: {
      fill: "rgba(227,236,236,0.11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 732.6 H 527.4 V 743.4 H 516.6 V 732.6 Z",
    style: {
      fill: "rgba(221,234,230,0.94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 744.6 H 527.4 V 755.4 H 516.6 V 744.6 Z",
    style: {
      fill: "rgba(207,218,216,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 756.6 H 527.4 V 767.4 H 516.6 V 756.6 Z",
    style: {
      fill: "#c3cacb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 768.6 H 527.4 V 779.4 H 516.6 V 768.6 Z",
    style: {
      fill: "#b6bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 780.6 H 527.4 V 791.4 H 516.6 V 780.6 Z",
    style: {
      fill: "#adb3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 792.6 H 527.4 V 803.4 H 516.6 V 792.6 Z",
    style: {
      fill: "#a8adb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 804.6 H 527.4 V 815.4 H 516.6 V 804.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 816.6 H 527.4 V 827.4 H 516.6 V 816.6 Z",
    style: {
      fill: "#abb1b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 828.6 H 527.4 V 839.4 H 516.6 V 828.6 Z",
    style: {
      fill: "rgba(180,192,192,0.49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 1020.6 H 527.4 V 1031.4 H 516.6 V 1020.6 Z",
    style: {
      fill: "rgba(181,196,193,0.35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 1032.6 H 527.4 V 1043.4 H 516.6 V 1032.6 Z",
    style: {
      fill: "#aab0b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 1044.6 H 527.4 V 1055.4 H 516.6 V 1044.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 1056.6 H 527.4 V 1067.4 H 516.6 V 1056.6 Z",
    style: {
      fill: "#a3a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 1068.6 H 527.4 V 1079.4 H 516.6 V 1068.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 1080.6 H 527.4 V 1091.4 H 516.6 V 1080.6 Z",
    style: {
      fill: "#a8afb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 516.6 1092.6 H 527.4 V 1103.4 H 516.6 V 1092.6 Z",
    style: {
      fill: "rgba(176,187,189,0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 204.6 H 539.4 V 215.4 H 528.6 V 204.6 Z",
    style: {
      fill: "rgba(255,255,255,0.12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 216.6 H 539.4 V 227.4 H 528.6 V 216.6 Z",
    style: {
      fill: "#cfd2d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 228.6 H 539.4 V 239.4 H 528.6 V 228.6 Z",
    style: {
      fill: "#b9bec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 240.6 H 539.4 V 251.4 H 528.6 V 240.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 252.6 H 539.4 V 263.4 H 528.6 V 252.6 Z",
    style: {
      fill: "#bdc2c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 264.6 H 539.4 V 275.4 H 528.6 V 264.6 Z",
    style: {
      fill: "rgba(223,238,231,0.69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 384.6 H 539.4 V 395.4 H 528.6 V 384.6 Z",
    style: {
      fill: "rgba(223,236,231,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 396.6 H 539.4 V 407.4 H 528.6 V 396.6 Z",
    style: {
      fill: "#bfc2c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 408.6 H 539.4 V 419.4 H 528.6 V 408.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 420.6 H 539.4 V 431.4 H 528.6 V 420.6 Z",
    style: {
      fill: "#acb1b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 432.6 H 539.4 V 443.4 H 528.6 V 432.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 444.6 H 539.4 V 455.4 H 528.6 V 444.6 Z",
    style: {
      fill: "#bcc0c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 456.6 H 539.4 V 467.4 H 528.6 V 456.6 Z",
    style: {
      fill: "#d6e1df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 468.6 H 539.4 V 479.4 H 528.6 V 468.6 Z",
    style: {
      fill: "rgba(225,238,232,0.47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 744.6 H 539.4 V 755.4 H 528.6 V 744.6 Z",
    style: {
      fill: "rgba(227,227,227,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 756.6 H 539.4 V 767.4 H 528.6 V 756.6 Z",
    style: {
      fill: "rgba(221,234,230,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 768.6 H 539.4 V 779.4 H 528.6 V 768.6 Z",
    style: {
      fill: "rgba(206,215,214,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 780.6 H 539.4 V 791.4 H 528.6 V 780.6 Z",
    style: {
      fill: "#babec3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 792.6 H 539.4 V 803.4 H 528.6 V 792.6 Z",
    style: {
      fill: "#afb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 804.6 H 539.4 V 815.4 H 528.6 V 804.6 Z",
    style: {
      fill: "#a8aeb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 816.6 H 539.4 V 827.4 H 528.6 V 816.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 828.6 H 539.4 V 839.4 H 528.6 V 828.6 Z",
    style: {
      fill: "#a8adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 840.6 H 539.4 V 851.4 H 528.6 V 840.6 Z",
    style: {
      fill: "rgba(176,186,186,0.42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 1032.6 H 539.4 V 1043.4 H 528.6 V 1032.6 Z",
    style: {
      fill: "rgba(183,197,195,0.42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 1044.6 H 539.4 V 1055.4 H 528.6 V 1044.6 Z",
    style: {
      fill: "#acb2b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 1056.6 H 539.4 V 1067.4 H 528.6 V 1056.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 1068.6 H 539.4 V 1079.4 H 528.6 V 1068.6 Z",
    style: {
      fill: "#a2a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 1080.6 H 539.4 V 1091.4 H 528.6 V 1080.6 Z",
    style: {
      fill: "#a3aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 1092.6 H 539.4 V 1103.4 H 528.6 V 1092.6 Z",
    style: {
      fill: "#a6adb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 528.6 1104.6 H 539.4 V 1115.4 H 528.6 V 1104.6 Z",
    style: {
      fill: "rgba(167,175,179,0.58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 204.6 H 551.4 V 215.4 H 540.6 V 204.6 Z",
    style: {
      fill: "rgba(250,255,255,0.64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 216.6 H 551.4 V 227.4 H 540.6 V 216.6 Z",
    style: {
      fill: "#c6cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 228.6 H 551.4 V 239.4 H 540.6 V 228.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 240.6 H 551.4 V 251.4 H 540.6 V 240.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 252.6 H 551.4 V 263.4 H 540.6 V 252.6 Z",
    style: {
      fill: "#c6cccd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 264.6 H 551.4 V 275.4 H 540.6 V 264.6 Z",
    style: {
      fill: "rgba(221,238,238,0.06)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 372.6 H 551.4 V 383.4 H 540.6 V 372.6 Z",
    style: {
      fill: "rgba(227,239,233,0.64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 384.6 H 551.4 V 395.4 H 540.6 V 384.6 Z",
    style: {
      fill: "#c3c6c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 396.6 H 551.4 V 407.4 H 540.6 V 396.6 Z",
    style: {
      fill: "#b4b8be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 408.6 H 551.4 V 419.4 H 540.6 V 408.6 Z",
    style: {
      fill: "#adb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 420.6 H 551.4 V 431.4 H 540.6 V 420.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 432.6 H 551.4 V 443.4 H 540.6 V 432.6 Z",
    style: {
      fill: "#bec1c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 444.6 H 551.4 V 455.4 H 540.6 V 444.6 Z",
    style: {
      fill: "rgba(221,233,229,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 768.6 H 551.4 V 779.4 H 540.6 V 768.6 Z",
    style: {
      fill: "rgba(225,240,233,0.4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 780.6 H 551.4 V 791.4 H 540.6 V 780.6 Z",
    style: {
      fill: "#d5e0de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 792.6 H 551.4 V 803.4 H 540.6 V 792.6 Z",
    style: {
      fill: "#bcc1c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 804.6 H 551.4 V 815.4 H 540.6 V 804.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 816.6 H 551.4 V 827.4 H 540.6 V 816.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 828.6 H 551.4 V 839.4 H 540.6 V 828.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 840.6 H 551.4 V 851.4 H 540.6 V 840.6 Z",
    style: {
      fill: "#a6acb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 852.6 H 551.4 V 863.4 H 540.6 V 852.6 Z",
    style: {
      fill: "rgba(174,183,184,0.83)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 1044.6 H 551.4 V 1055.4 H 540.6 V 1044.6 Z",
    style: {
      fill: "rgba(185,198,196,0.56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 1056.6 H 551.4 V 1067.4 H 540.6 V 1056.6 Z",
    style: {
      fill: "#abb1b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 1068.6 H 551.4 V 1079.4 H 540.6 V 1068.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 1080.6 H 551.4 V 1091.4 H 540.6 V 1080.6 Z",
    style: {
      fill: "#a1a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 1092.6 H 551.4 V 1103.4 H 540.6 V 1092.6 Z",
    style: {
      fill: "#a0a7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 540.6 1104.6 H 551.4 V 1115.4 H 540.6 V 1104.6 Z",
    style: {
      fill: "rgba(157,164,172,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 204.6 H 563.4 V 215.4 H 552.6 V 204.6 Z",
    style: {
      fill: "rgba(229,233,235,0.84)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 216.6 H 563.4 V 227.4 H 552.6 V 216.6 Z",
    style: {
      fill: "#c0c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 228.6 H 563.4 V 239.4 H 552.6 V 228.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 240.6 H 563.4 V 251.4 H 552.6 V 240.6 Z",
    style: {
      fill: "#b6bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 252.6 H 563.4 V 263.4 H 552.6 V 252.6 Z",
    style: {
      fill: "#d4e0dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 360.6 H 563.4 V 371.4 H 552.6 V 360.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 372.6 H 563.4 V 383.4 H 552.6 V 372.6 Z",
    style: {
      fill: "#d0d7d7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 384.6 H 563.4 V 395.4 H 552.6 V 384.6 Z",
    style: {
      fill: "#b9bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 396.6 H 563.4 V 407.4 H 552.6 V 396.6 Z",
    style: {
      fill: "#afb4ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 408.6 H 563.4 V 419.4 H 552.6 V 408.6 Z",
    style: {
      fill: "#b2b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 420.6 H 563.4 V 431.4 H 552.6 V 420.6 Z",
    style: {
      fill: "#bec1c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 432.6 H 563.4 V 443.4 H 552.6 V 432.6 Z",
    style: {
      fill: "rgba(221,233,228,0.81)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 780.6 H 563.4 V 791.4 H 552.6 V 780.6 Z",
    style: {
      fill: "rgba(220,243,232,0.09)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 792.6 H 563.4 V 803.4 H 552.6 V 792.6 Z",
    style: {
      fill: "rgba(221,234,230,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 804.6 H 563.4 V 815.4 H 552.6 V 804.6 Z",
    style: {
      fill: "#bec3c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 816.6 H 563.4 V 827.4 H 552.6 V 816.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 828.6 H 563.4 V 839.4 H 552.6 V 828.6 Z",
    style: {
      fill: "#a8adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 840.6 H 563.4 V 851.4 H 552.6 V 840.6 Z",
    style: {
      fill: "#a3a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 852.6 H 563.4 V 863.4 H 552.6 V 852.6 Z",
    style: {
      fill: "#a6abb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 864.6 H 563.4 V 875.4 H 552.6 V 864.6 Z",
    style: {
      fill: "rgba(174,186,186,0.69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 1056.6 H 563.4 V 1067.4 H 552.6 V 1056.6 Z",
    style: {
      fill: "rgba(182,195,194,0.7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 1068.6 H 563.4 V 1079.4 H 552.6 V 1068.6 Z",
    style: {
      fill: "#aab0b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 1080.6 H 563.4 V 1091.4 H 552.6 V 1080.6 Z",
    style: {
      fill: "#a3aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 1092.6 H 563.4 V 1103.4 H 552.6 V 1092.6 Z",
    style: {
      fill: "#9ea5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 552.6 1104.6 H 563.4 V 1115.4 H 552.6 V 1104.6 Z",
    style: {
      fill: "#99a0aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 204.6 H 575.4 V 215.4 H 564.6 V 204.6 Z",
    style: {
      fill: "rgba(214,217,219,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 216.6 H 575.4 V 227.4 H 564.6 V 216.6 Z",
    style: {
      fill: "#bbbfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 228.6 H 575.4 V 239.4 H 564.6 V 228.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 240.6 H 575.4 V 251.4 H 564.6 V 240.6 Z",
    style: {
      fill: "#babec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 252.6 H 575.4 V 263.4 H 564.6 V 252.6 Z",
    style: {
      fill: "rgba(221,234,229,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 360.6 H 575.4 V 371.4 H 564.6 V 360.6 Z",
    style: {
      fill: "rgba(223,236,231,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 372.6 H 575.4 V 383.4 H 564.6 V 372.6 Z",
    style: {
      fill: "#bec2c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 384.6 H 575.4 V 395.4 H 564.6 V 384.6 Z",
    style: {
      fill: "#b1b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 396.6 H 575.4 V 407.4 H 564.6 V 396.6 Z",
    style: {
      fill: "#b0b5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 408.6 H 575.4 V 419.4 H 564.6 V 408.6 Z",
    style: {
      fill: "#bbbfc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 420.6 H 575.4 V 431.4 H 564.6 V 420.6 Z",
    style: {
      fill: "rgba(221,234,230,0.91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 792.6 H 575.4 V 803.4 H 564.6 V 792.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 804.6 H 575.4 V 815.4 H 564.6 V 804.6 Z",
    style: {
      fill: "rgba(223,236,231,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 816.6 H 575.4 V 827.4 H 564.6 V 816.6 Z",
    style: {
      fill: "#c0c4c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 828.6 H 575.4 V 839.4 H 564.6 V 828.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 840.6 H 575.4 V 851.4 H 564.6 V 840.6 Z",
    style: {
      fill: "#a7adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 852.6 H 575.4 V 863.4 H 564.6 V 852.6 Z",
    style: {
      fill: "#a3a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 864.6 H 575.4 V 875.4 H 564.6 V 864.6 Z",
    style: {
      fill: "#a6abb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 876.6 H 575.4 V 887.4 H 564.6 V 876.6 Z",
    style: {
      fill: "rgba(175,183,184,0.69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 1068.6 H 575.4 V 1079.4 H 564.6 V 1068.6 Z",
    style: {
      fill: "rgba(181,194,192,0.46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 1080.6 H 575.4 V 1091.4 H 564.6 V 1080.6 Z",
    style: {
      fill: "#a9afb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 1092.6 H 575.4 V 1103.4 H 564.6 V 1092.6 Z",
    style: {
      fill: "#a1a7af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.6 1104.6 H 575.4 V 1115.4 H 564.6 V 1104.6 Z",
    style: {
      fill: "rgba(153,160,169,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 204.6 H 587.4 V 215.4 H 576.6 V 204.6 Z",
    style: {
      fill: "#cfd1d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 216.6 H 587.4 V 227.4 H 576.6 V 216.6 Z",
    style: {
      fill: "#b8bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 228.6 H 587.4 V 239.4 H 576.6 V 228.6 Z",
    style: {
      fill: "#b0b5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 240.6 H 587.4 V 251.4 H 576.6 V 240.6 Z",
    style: {
      fill: "#bcc0c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 252.6 H 587.4 V 263.4 H 576.6 V 252.6 Z",
    style: {
      fill: "rgba(224,237,231,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 348.6 H 587.4 V 359.4 H 576.6 V 348.6 Z",
    style: {
      fill: "rgba(229,240,235,0.2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 360.6 H 587.4 V 371.4 H 576.6 V 360.6 Z",
    style: {
      fill: "#c8cece"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 372.6 H 587.4 V 383.4 H 576.6 V 372.6 Z",
    style: {
      fill: "#b6bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 384.6 H 587.4 V 395.4 H 576.6 V 384.6 Z",
    style: {
      fill: "#afb5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 396.6 H 587.4 V 407.4 H 576.6 V 396.6 Z",
    style: {
      fill: "#b7bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 408.6 H 587.4 V 419.4 H 576.6 V 408.6 Z",
    style: {
      fill: "#d1dbd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 816.6 H 587.4 V 827.4 H 576.6 V 816.6 Z",
    style: {
      fill: "rgba(221,234,229,0.85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 828.6 H 587.4 V 839.4 H 576.6 V 828.6 Z",
    style: {
      fill: "#c0c4c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 840.6 H 587.4 V 851.4 H 576.6 V 840.6 Z",
    style: {
      fill: "#b2b6bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 852.6 H 587.4 V 863.4 H 576.6 V 852.6 Z",
    style: {
      fill: "#a7acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 864.6 H 587.4 V 875.4 H 576.6 V 864.6 Z",
    style: {
      fill: "#a4a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 876.6 H 587.4 V 887.4 H 576.6 V 876.6 Z",
    style: {
      fill: "#a8adb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 888.6 H 587.4 V 899.4 H 576.6 V 888.6 Z",
    style: {
      fill: "rgba(180,193,191,0.56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 1080.6 H 587.4 V 1091.4 H 576.6 V 1080.6 Z",
    style: {
      fill: "rgba(183,195,195,0.35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 1092.6 H 587.4 V 1103.4 H 576.6 V 1092.6 Z",
    style: {
      fill: "rgba(167,172,177,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 576.6 1104.6 H 587.4 V 1115.4 H 576.6 V 1104.6 Z",
    style: {
      fill: "rgba(158,164,171,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 204.6 H 599.4 V 215.4 H 588.6 V 204.6 Z",
    style: {
      fill: "#cccecf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 216.6 H 599.4 V 227.4 H 588.6 V 216.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 228.6 H 599.4 V 239.4 H 588.6 V 228.6 Z",
    style: {
      fill: "#b0b5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 240.6 H 599.4 V 251.4 H 588.6 V 240.6 Z",
    style: {
      fill: "#bec1c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 252.6 H 599.4 V 263.4 H 588.6 V 252.6 Z",
    style: {
      fill: "rgba(225,240,234,0.33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 348.6 H 599.4 V 359.4 H 588.6 V 348.6 Z",
    style: {
      fill: "rgba(222,235,231,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 360.6 H 599.4 V 371.4 H 588.6 V 360.6 Z",
    style: {
      fill: "#bcc0c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 372.6 H 599.4 V 383.4 H 588.6 V 372.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 384.6 H 599.4 V 395.4 H 588.6 V 384.6 Z",
    style: {
      fill: "#b3b8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 396.6 H 599.4 V 407.4 H 588.6 V 396.6 Z",
    style: {
      fill: "#c0c4c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 408.6 H 599.4 V 419.4 H 588.6 V 408.6 Z",
    style: {
      fill: "rgba(224,237,232,0.39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 828.6 H 599.4 V 839.4 H 588.6 V 828.6 Z",
    style: {
      fill: "rgba(220,234,228,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 840.6 H 599.4 V 851.4 H 588.6 V 840.6 Z",
    style: {
      fill: "#bfc4c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 852.6 H 599.4 V 863.4 H 588.6 V 852.6 Z",
    style: {
      fill: "#b1b5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 864.6 H 599.4 V 875.4 H 588.6 V 864.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 876.6 H 599.4 V 887.4 H 588.6 V 876.6 Z",
    style: {
      fill: "#a5aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 888.6 H 599.4 V 899.4 H 588.6 V 888.6 Z",
    style: {
      fill: "rgba(171,179,181,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 900.6 H 599.4 V 911.4 H 588.6 V 900.6 Z",
    style: {
      fill: "rgba(187,198,198,0.18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 1092.6 H 599.4 V 1103.4 H 588.6 V 1092.6 Z",
    style: {
      fill: "rgba(183,192,192,0.22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 588.6 1104.6 H 599.4 V 1115.4 H 588.6 V 1104.6 Z",
    style: {
      fill: "rgba(165,169,174,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 192.6 H 611.4 V 203.4 H 600.6 V 192.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 204.6 H 611.4 V 215.4 H 600.6 V 204.6 Z",
    style: {
      fill: "#c9cbcd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 216.6 H 611.4 V 227.4 H 600.6 V 216.6 Z",
    style: {
      fill: "#b4b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 228.6 H 611.4 V 239.4 H 600.6 V 228.6 Z",
    style: {
      fill: "#b0b4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 240.6 H 611.4 V 251.4 H 600.6 V 240.6 Z",
    style: {
      fill: "#bfc2c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 252.6 H 611.4 V 263.4 H 600.6 V 252.6 Z",
    style: {
      fill: "rgba(228,237,232,0.22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 336.6 H 611.4 V 347.4 H 600.6 V 336.6 Z",
    style: {
      fill: "rgba(235,235,235,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 348.6 H 611.4 V 359.4 H 600.6 V 348.6 Z",
    style: {
      fill: "#c5cbcc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 360.6 H 611.4 V 371.4 H 600.6 V 360.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 372.6 H 611.4 V 383.4 H 600.6 V 372.6 Z",
    style: {
      fill: "#b0b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 384.6 H 611.4 V 395.4 H 600.6 V 384.6 Z",
    style: {
      fill: "#babfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 396.6 H 611.4 V 407.4 H 600.6 V 396.6 Z",
    style: {
      fill: "rgba(219,232,228,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 516.6 H 611.4 V 527.4 H 600.6 V 516.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 528.6 H 611.4 V 539.4 H 600.6 V 528.6 Z",
    style: {
      fill: "rgba(230,242,230,0.08)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 540.6 H 611.4 V 551.4 H 600.6 V 540.6 Z",
    style: {
      fill: "rgba(232,243,232,0.09)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 552.6 H 611.4 V 563.4 H 600.6 V 552.6 Z",
    style: {
      fill: "rgba(226,237,230,0.84)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 564.6 H 611.4 V 575.4 H 600.6 V 564.6 Z",
    style: {
      fill: "rgba(225,237,231,0.78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 576.6 H 611.4 V 587.4 H 600.6 V 576.6 Z",
    style: {
      fill: "rgba(225,236,229,0.72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 588.6 H 611.4 V 599.4 H 600.6 V 588.6 Z",
    style: {
      fill: "rgba(227,234,234,0.14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 600.6 H 611.4 V 611.4 H 600.6 V 600.6 Z",
    style: {
      fill: "rgba(230,242,230,0.08)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 612.6 H 611.4 V 623.4 H 600.6 V 612.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 840.6 H 611.4 V 851.4 H 600.6 V 840.6 Z",
    style: {
      fill: "rgba(220,235,231,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 852.6 H 611.4 V 863.4 H 600.6 V 852.6 Z",
    style: {
      fill: "#bdc1c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 864.6 H 611.4 V 875.4 H 600.6 V 864.6 Z",
    style: {
      fill: "#aeb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 876.6 H 611.4 V 887.4 H 600.6 V 876.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 888.6 H 611.4 V 899.4 H 600.6 V 888.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 900.6 H 611.4 V 911.4 H 600.6 V 900.6 Z",
    style: {
      fill: "rgba(179,191,191,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 912.6 H 611.4 V 923.4 H 600.6 V 912.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 600.6 1104.6 H 611.4 V 1115.4 H 600.6 V 1104.6 Z",
    style: {
      fill: "rgba(180,180,180,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 192.6 H 623.4 V 203.4 H 612.6 V 192.6 Z",
    style: {
      fill: "rgba(255,255,255,0.14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 204.6 H 623.4 V 215.4 H 612.6 V 204.6 Z",
    style: {
      fill: "#c7c9cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 216.6 H 623.4 V 227.4 H 612.6 V 216.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 228.6 H 623.4 V 239.4 H 612.6 V 228.6 Z",
    style: {
      fill: "#b0b4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 240.6 H 623.4 V 251.4 H 612.6 V 240.6 Z",
    style: {
      fill: "#bfc3c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 252.6 H 623.4 V 263.4 H 612.6 V 252.6 Z",
    style: {
      fill: "rgba(223,237,232,0.22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 336.6 H 623.4 V 347.4 H 612.6 V 336.6 Z",
    style: {
      fill: "rgba(220,233,228,0.85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 348.6 H 623.4 V 359.4 H 612.6 V 348.6 Z",
    style: {
      fill: "#bbc0c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 360.6 H 623.4 V 371.4 H 612.6 V 360.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 372.6 H 623.4 V 383.4 H 612.6 V 372.6 Z",
    style: {
      fill: "#b3b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 384.6 H 623.4 V 395.4 H 612.6 V 384.6 Z",
    style: {
      fill: "#c2c6c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 396.6 H 623.4 V 407.4 H 612.6 V 396.6 Z",
    style: {
      fill: "rgba(225,238,230,0.36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 492.6 H 623.4 V 503.4 H 612.6 V 492.6 Z",
    style: {
      fill: "rgba(226,239,232,0.44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 504.6 H 623.4 V 515.4 H 612.6 V 504.6 Z",
    style: {
      fill: "rgba(221,233,230,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 516.6 H 623.4 V 527.4 H 612.6 V 516.6 Z",
    style: {
      fill: "rgba(210,219,217,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 528.6 H 623.4 V 539.4 H 612.6 V 528.6 Z",
    style: {
      fill: "rgba(199,204,205,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 540.6 H 623.4 V 551.4 H 612.6 V 540.6 Z",
    style: {
      fill: "rgba(193,197,200,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 552.6 H 623.4 V 563.4 H 612.6 V 552.6 Z",
    style: {
      fill: "#bdc1c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 564.6 H 623.4 V 575.4 H 612.6 V 564.6 Z",
    style: {
      fill: "#bcc0c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 576.6 H 623.4 V 587.4 H 612.6 V 576.6 Z",
    style: {
      fill: "#bcc0c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 588.6 H 623.4 V 599.4 H 612.6 V 588.6 Z",
    style: {
      fill: "#bdc0c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 600.6 H 623.4 V 611.4 H 612.6 V 600.6 Z",
    style: {
      fill: "#bec2c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 612.6 H 623.4 V 623.4 H 612.6 V 612.6 Z",
    style: {
      fill: "#c1c5c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 624.6 H 623.4 V 635.4 H 612.6 V 624.6 Z",
    style: {
      fill: "rgba(203,210,210,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 636.6 H 623.4 V 647.4 H 612.6 V 636.6 Z",
    style: {
      fill: "rgba(219,231,227,0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 648.6 H 623.4 V 659.4 H 612.6 V 648.6 Z",
    style: {
      fill: "rgba(219,219,219,0.03)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 840.6 H 623.4 V 851.4 H 612.6 V 840.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 852.6 H 623.4 V 863.4 H 612.6 V 852.6 Z",
    style: {
      fill: "#d4dfdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 864.6 H 623.4 V 875.4 H 612.6 V 864.6 Z",
    style: {
      fill: "#b9bdc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 876.6 H 623.4 V 887.4 H 612.6 V 876.6 Z",
    style: {
      fill: "#acb1b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 888.6 H 623.4 V 899.4 H 612.6 V 888.6 Z",
    style: {
      fill: "#a6acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 900.6 H 623.4 V 911.4 H 612.6 V 900.6 Z",
    style: {
      fill: "#aab0b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 612.6 912.6 H 623.4 V 923.4 H 612.6 V 912.6 Z",
    style: {
      fill: "rgba(182,195,194,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 192.6 H 635.4 V 203.4 H 624.6 V 192.6 Z",
    style: {
      fill: "rgba(255,255,255,0.17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 204.6 H 635.4 V 215.4 H 624.6 V 204.6 Z",
    style: {
      fill: "#c7cacd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 216.6 H 635.4 V 227.4 H 624.6 V 216.6 Z",
    style: {
      fill: "#b3b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 228.6 H 635.4 V 239.4 H 624.6 V 228.6 Z",
    style: {
      fill: "#b0b4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 240.6 H 635.4 V 251.4 H 624.6 V 240.6 Z",
    style: {
      fill: "#c0c5c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 252.6 H 635.4 V 263.4 H 624.6 V 252.6 Z",
    style: {
      fill: "rgba(225,235,230,0.2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 336.6 H 635.4 V 347.4 H 624.6 V 336.6 Z",
    style: {
      fill: "rgba(199,204,205,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 348.6 H 635.4 V 359.4 H 624.6 V 348.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 360.6 H 635.4 V 371.4 H 624.6 V 360.6 Z",
    style: {
      fill: "#aeb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 372.6 H 635.4 V 383.4 H 624.6 V 372.6 Z",
    style: {
      fill: "#b9bec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 384.6 H 635.4 V 395.4 H 624.6 V 384.6 Z",
    style: {
      fill: "#d9e5e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 396.6 H 635.4 V 407.4 H 624.6 V 396.6 Z",
    style: {
      fill: "rgba(233,244,233,0.09)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 468.6 H 635.4 V 479.4 H 624.6 V 468.6 Z",
    style: {
      fill: "rgba(222,236,231,0.58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 480.6 H 635.4 V 491.4 H 624.6 V 480.6 Z",
    style: {
      fill: "rgba(212,222,219,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 492.6 H 635.4 V 503.4 H 624.6 V 492.6 Z",
    style: {
      fill: "#c3c7ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 504.6 H 635.4 V 515.4 H 624.6 V 504.6 Z",
    style: {
      fill: "#bcc0c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 516.6 H 635.4 V 527.4 H 624.6 V 516.6 Z",
    style: {
      fill: "#b8bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 528.6 H 635.4 V 539.4 H 624.6 V 528.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 540.6 H 635.4 V 551.4 H 624.6 V 540.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 552.6 H 635.4 V 563.4 H 624.6 V 552.6 Z",
    style: {
      fill: "#b1b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 564.6 H 635.4 V 575.4 H 624.6 V 564.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 576.6 H 635.4 V 587.4 H 624.6 V 576.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 588.6 H 635.4 V 599.4 H 624.6 V 588.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 600.6 H 635.4 V 611.4 H 624.6 V 600.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 612.6 H 635.4 V 623.4 H 624.6 V 612.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 624.6 H 635.4 V 635.4 H 624.6 V 624.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 636.6 H 635.4 V 647.4 H 624.6 V 636.6 Z",
    style: {
      fill: "#babec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 648.6 H 635.4 V 659.4 H 624.6 V 648.6 Z",
    style: {
      fill: "#c1c5c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 660.6 H 635.4 V 671.4 H 624.6 V 660.6 Z",
    style: {
      fill: "rgba(218,230,226,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 672.6 H 635.4 V 683.4 H 624.6 V 672.6 Z",
    style: {
      fill: "rgba(221,238,232,0.3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 852.6 H 635.4 V 863.4 H 624.6 V 852.6 Z",
    style: {
      fill: "rgba(225,240,230,0.2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 864.6 H 635.4 V 875.4 H 624.6 V 864.6 Z",
    style: {
      fill: "#c6ccce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 876.6 H 635.4 V 887.4 H 624.6 V 876.6 Z",
    style: {
      fill: "#b6bac0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 888.6 H 635.4 V 899.4 H 624.6 V 888.6 Z",
    style: {
      fill: "#aab0b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 900.6 H 635.4 V 911.4 H 624.6 V 900.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 912.6 H 635.4 V 923.4 H 624.6 V 912.6 Z",
    style: {
      fill: "#abb1b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 624.6 924.6 H 635.4 V 935.4 H 624.6 V 924.6 Z",
    style: {
      fill: "rgba(182,182,182,0.03)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 192.6 H 647.4 V 203.4 H 636.6 V 192.6 Z",
    style: {
      fill: "rgba(255,255,255,0.23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 204.6 H 647.4 V 215.4 H 636.6 V 204.6 Z",
    style: {
      fill: "#c8cacd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 216.6 H 647.4 V 227.4 H 636.6 V 216.6 Z",
    style: {
      fill: "#b3b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 228.6 H 647.4 V 239.4 H 636.6 V 228.6 Z",
    style: {
      fill: "#b0b4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 240.6 H 647.4 V 251.4 H 636.6 V 240.6 Z",
    style: {
      fill: "#bfc2c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 252.6 H 647.4 V 263.4 H 636.6 V 252.6 Z",
    style: {
      fill: "rgba(227,236,232,0.22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 324.6 H 647.4 V 335.4 H 636.6 V 324.6 Z",
    style: {
      fill: "rgba(255,255,255,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 336.6 H 647.4 V 347.4 H 636.6 V 336.6 Z",
    style: {
      fill: "#bec2c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 348.6 H 647.4 V 359.4 H 636.6 V 348.6 Z",
    style: {
      fill: "#b0b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 360.6 H 647.4 V 371.4 H 636.6 V 360.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 372.6 H 647.4 V 383.4 H 636.6 V 372.6 Z",
    style: {
      fill: "#bfc4c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 384.6 H 647.4 V 395.4 H 636.6 V 384.6 Z",
    style: {
      fill: "rgba(224,237,231,0.85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 444.6 H 647.4 V 455.4 H 636.6 V 444.6 Z",
    style: {
      fill: "rgba(224,238,231,0.29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 456.6 H 647.4 V 467.4 H 636.6 V 456.6 Z",
    style: {
      fill: "rgba(209,219,217,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 468.6 H 647.4 V 479.4 H 636.6 V 468.6 Z",
    style: {
      fill: "#c0c4c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 480.6 H 647.4 V 491.4 H 636.6 V 480.6 Z",
    style: {
      fill: "#b9bec3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 492.6 H 647.4 V 503.4 H 636.6 V 492.6 Z",
    style: {
      fill: "#b5bac0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 504.6 H 647.4 V 515.4 H 636.6 V 504.6 Z",
    style: {
      fill: "#b3b8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 516.6 H 647.4 V 527.4 H 636.6 V 516.6 Z",
    style: {
      fill: "#b3b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 528.6 H 647.4 V 539.4 H 636.6 V 528.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 540.6 H 647.4 V 551.4 H 636.6 V 540.6 Z",
    style: {
      fill: "#b7bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 552.6 H 647.4 V 563.4 H 636.6 V 552.6 Z",
    style: {
      fill: "#b8bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 564.6 H 647.4 V 575.4 H 636.6 V 564.6 Z",
    style: {
      fill: "#b8bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 576.6 H 647.4 V 587.4 H 636.6 V 576.6 Z",
    style: {
      fill: "#b8bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 588.6 H 647.4 V 599.4 H 636.6 V 588.6 Z",
    style: {
      fill: "#b6bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 600.6 H 647.4 V 611.4 H 636.6 V 600.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 612.6 H 647.4 V 623.4 H 636.6 V 612.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 624.6 H 647.4 V 635.4 H 636.6 V 624.6 Z",
    style: {
      fill: "#afb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 636.6 H 647.4 V 647.4 H 636.6 V 636.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 648.6 H 647.4 V 659.4 H 636.6 V 648.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 660.6 H 647.4 V 671.4 H 636.6 V 660.6 Z",
    style: {
      fill: "#b9bec2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 672.6 H 647.4 V 683.4 H 636.6 V 672.6 Z",
    style: {
      fill: "#c4c8ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 684.6 H 647.4 V 695.4 H 636.6 V 684.6 Z",
    style: {
      fill: "rgba(221,234,230,0.67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 696.6 H 647.4 V 707.4 H 636.6 V 696.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 864.6 H 647.4 V 875.4 H 636.6 V 864.6 Z",
    style: {
      fill: "rgba(226,238,232,0.78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 876.6 H 647.4 V 887.4 H 636.6 V 876.6 Z",
    style: {
      fill: "#c2c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 888.6 H 647.4 V 899.4 H 636.6 V 888.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 900.6 H 647.4 V 911.4 H 636.6 V 900.6 Z",
    style: {
      fill: "#a8aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 912.6 H 647.4 V 923.4 H 636.6 V 912.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 636.6 924.6 H 647.4 V 935.4 H 636.6 V 924.6 Z",
    style: {
      fill: "rgba(173,180,183,0.97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 192.6 H 659.4 V 203.4 H 648.6 V 192.6 Z",
    style: {
      fill: "rgba(249,255,255,0.18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 204.6 H 659.4 V 215.4 H 648.6 V 204.6 Z",
    style: {
      fill: "#cacccf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 216.6 H 659.4 V 227.4 H 648.6 V 216.6 Z",
    style: {
      fill: "#b4b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 228.6 H 659.4 V 239.4 H 648.6 V 228.6 Z",
    style: {
      fill: "#afb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 240.6 H 659.4 V 251.4 H 648.6 V 240.6 Z",
    style: {
      fill: "#bec1c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 252.6 H 659.4 V 263.4 H 648.6 V 252.6 Z",
    style: {
      fill: "rgba(228,237,232,0.22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 324.6 H 659.4 V 335.4 H 648.6 V 324.6 Z",
    style: {
      fill: "rgba(219,231,227,0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 336.6 H 659.4 V 347.4 H 648.6 V 336.6 Z",
    style: {
      fill: "#babec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 348.6 H 659.4 V 359.4 H 648.6 V 348.6 Z",
    style: {
      fill: "#aeb3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 360.6 H 659.4 V 371.4 H 648.6 V 360.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 372.6 H 659.4 V 383.4 H 648.6 V 372.6 Z",
    style: {
      fill: "#c9d0d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 384.6 H 659.4 V 395.4 H 648.6 V 384.6 Z",
    style: {
      fill: "rgba(225,240,225,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 432.6 H 659.4 V 443.4 H 648.6 V 432.6 Z",
    style: {
      fill: "rgba(225,238,232,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 444.6 H 659.4 V 455.4 H 648.6 V 444.6 Z",
    style: {
      fill: "#c4c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 456.6 H 659.4 V 467.4 H 648.6 V 456.6 Z",
    style: {
      fill: "#b9bdc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 468.6 H 659.4 V 479.4 H 648.6 V 468.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 480.6 H 659.4 V 491.4 H 648.6 V 480.6 Z",
    style: {
      fill: "#b3b8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 492.6 H 659.4 V 503.4 H 648.6 V 492.6 Z",
    style: {
      fill: "#b7bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 504.6 H 659.4 V 515.4 H 648.6 V 504.6 Z",
    style: {
      fill: "#bcc1c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 516.6 H 659.4 V 527.4 H 648.6 V 516.6 Z",
    style: {
      fill: "#c2c6cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 528.6 H 659.4 V 539.4 H 648.6 V 528.6 Z",
    style: {
      fill: "#c7cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 540.6 H 659.4 V 551.4 H 648.6 V 540.6 Z",
    style: {
      fill: "#cccfd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 552.6 H 659.4 V 563.4 H 648.6 V 552.6 Z",
    style: {
      fill: "rgba(213,216,218,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 564.6 H 659.4 V 575.4 H 648.6 V 564.6 Z",
    style: {
      fill: "rgba(212,215,217,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 576.6 H 659.4 V 587.4 H 648.6 V 576.6 Z",
    style: {
      fill: "rgba(209,211,213,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 588.6 H 659.4 V 599.4 H 648.6 V 588.6 Z",
    style: {
      fill: "#ced0d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 600.6 H 659.4 V 611.4 H 648.6 V 600.6 Z",
    style: {
      fill: "#c9cccf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 612.6 H 659.4 V 623.4 H 648.6 V 612.6 Z",
    style: {
      fill: "#c3c5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 624.6 H 659.4 V 635.4 H 648.6 V 624.6 Z",
    style: {
      fill: "#bcbfc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 636.6 H 659.4 V 647.4 H 648.6 V 636.6 Z",
    style: {
      fill: "#b4b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 648.6 H 659.4 V 659.4 H 648.6 V 648.6 Z",
    style: {
      fill: "#afb4ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 660.6 H 659.4 V 671.4 H 648.6 V 660.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 672.6 H 659.4 V 683.4 H 648.6 V 672.6 Z",
    style: {
      fill: "#b4b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 684.6 H 659.4 V 695.4 H 648.6 V 684.6 Z",
    style: {
      fill: "#bdc1c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 696.6 H 659.4 V 707.4 H 648.6 V 696.6 Z",
    style: {
      fill: "#d1dad9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 708.6 H 659.4 V 719.4 H 648.6 V 708.6 Z",
    style: {
      fill: "rgba(229,240,232,0.27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 876.6 H 659.4 V 887.4 H 648.6 V 876.6 Z",
    style: {
      fill: "rgba(219,231,227,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 888.6 H 659.4 V 899.4 H 648.6 V 888.6 Z",
    style: {
      fill: "#bcc1c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 900.6 H 659.4 V 911.4 H 648.6 V 900.6 Z",
    style: {
      fill: "#adb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 912.6 H 659.4 V 923.4 H 648.6 V 912.6 Z",
    style: {
      fill: "#a6acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 924.6 H 659.4 V 935.4 H 648.6 V 924.6 Z",
    style: {
      fill: "#a8aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 648.6 936.6 H 659.4 V 947.4 H 648.6 V 936.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 204.6 H 671.4 V 215.4 H 660.6 V 204.6 Z",
    style: {
      fill: "#cfd2d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 216.6 H 671.4 V 227.4 H 660.6 V 216.6 Z",
    style: {
      fill: "#b6bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 228.6 H 671.4 V 239.4 H 660.6 V 228.6 Z",
    style: {
      fill: "#afb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 240.6 H 671.4 V 251.4 H 660.6 V 240.6 Z",
    style: {
      fill: "#bfc5c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 252.6 H 671.4 V 263.4 H 660.6 V 252.6 Z",
    style: {
      fill: "rgba(223,236,231,0.69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 324.6 H 671.4 V 335.4 H 660.6 V 324.6 Z",
    style: {
      fill: "rgba(211,219,217,0.92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 336.6 H 671.4 V 347.4 H 660.6 V 336.6 Z",
    style: {
      fill: "#b7bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 348.6 H 671.4 V 359.4 H 660.6 V 348.6 Z",
    style: {
      fill: "#adb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 360.6 H 671.4 V 371.4 H 660.6 V 360.6 Z",
    style: {
      fill: "#b5bac0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 372.6 H 671.4 V 383.4 H 660.6 V 372.6 Z",
    style: {
      fill: "rgba(206,214,213,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 420.6 H 671.4 V 431.4 H 660.6 V 420.6 Z",
    style: {
      fill: "rgba(225,238,233,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 432.6 H 671.4 V 443.4 H 660.6 V 432.6 Z",
    style: {
      fill: "#c2c6c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 444.6 H 671.4 V 455.4 H 660.6 V 444.6 Z",
    style: {
      fill: "#b7bbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 456.6 H 671.4 V 467.4 H 660.6 V 456.6 Z",
    style: {
      fill: "#b1b5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 468.6 H 671.4 V 479.4 H 660.6 V 468.6 Z",
    style: {
      fill: "#b4b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 480.6 H 671.4 V 491.4 H 660.6 V 480.6 Z",
    style: {
      fill: "#bdc1c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 492.6 H 671.4 V 503.4 H 660.6 V 492.6 Z",
    style: {
      fill: "#c7cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 504.6 H 671.4 V 515.4 H 660.6 V 504.6 Z",
    style: {
      fill: "rgba(216,219,221,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 516.6 H 671.4 V 527.4 H 660.6 V 516.6 Z",
    style: {
      fill: "#f9fcfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 528.6 H 671.4 V 539.4 H 660.6 V 528.6 Z",
    style: {
      fill: "rgba(254,255,255,0.75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 540.6 H 671.4 V 551.4 H 660.6 V 540.6 Z",
    style: {
      fill: "rgba(254,255,255,0.74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 552.6 H 671.4 V 563.4 H 660.6 V 552.6 Z",
    style: {
      fill: "rgba(255,255,255,0.17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 564.6 H 671.4 V 575.4 H 660.6 V 564.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 576.6 H 671.4 V 587.4 H 660.6 V 576.6 Z",
    style: {
      fill: "rgba(255,255,255,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 588.6 H 671.4 V 599.4 H 660.6 V 588.6 Z",
    style: {
      fill: "rgba(252,255,255,0.31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 600.6 H 671.4 V 611.4 H 660.6 V 600.6 Z",
    style: {
      fill: "rgba(252,255,255,0.62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 612.6 H 671.4 V 623.4 H 660.6 V 612.6 Z",
    style: {
      fill: "rgba(244,249,250,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 624.6 H 671.4 V 635.4 H 660.6 V 624.6 Z",
    style: {
      fill: "#dee3e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 636.6 H 671.4 V 647.4 H 660.6 V 636.6 Z",
    style: {
      fill: "#c8cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 648.6 H 671.4 V 659.4 H 660.6 V 648.6 Z",
    style: {
      fill: "#bec1c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 660.6 H 671.4 V 671.4 H 660.6 V 660.6 Z",
    style: {
      fill: "#b5b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 672.6 H 671.4 V 683.4 H 660.6 V 672.6 Z",
    style: {
      fill: "#b0b4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 684.6 H 671.4 V 695.4 H 660.6 V 684.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 696.6 H 671.4 V 707.4 H 660.6 V 696.6 Z",
    style: {
      fill: "#babfc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 708.6 H 671.4 V 719.4 H 660.6 V 708.6 Z",
    style: {
      fill: "#c8cccd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 720.6 H 671.4 V 731.4 H 660.6 V 720.6 Z",
    style: {
      fill: "rgba(226,240,234,0.34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 876.6 H 671.4 V 887.4 H 660.6 V 876.6 Z",
    style: {
      fill: "rgba(225,238,234,0.24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 888.6 H 671.4 V 899.4 H 660.6 V 888.6 Z",
    style: {
      fill: "rgba(209,219,217,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 900.6 H 671.4 V 911.4 H 660.6 V 900.6 Z",
    style: {
      fill: "#b5bac0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 912.6 H 671.4 V 923.4 H 660.6 V 912.6 Z",
    style: {
      fill: "#a8aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 924.6 H 671.4 V 935.4 H 660.6 V 924.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 660.6 936.6 H 671.4 V 947.4 H 660.6 V 936.6 Z",
    style: {
      fill: "rgba(172,180,182,0.82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 204.6 H 683.4 V 215.4 H 672.6 V 204.6 Z",
    style: {
      fill: "#d3d7d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 216.6 H 683.4 V 227.4 H 672.6 V 216.6 Z",
    style: {
      fill: "#b9bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 228.6 H 683.4 V 239.4 H 672.6 V 228.6 Z",
    style: {
      fill: "#b0b5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 240.6 H 683.4 V 251.4 H 672.6 V 240.6 Z",
    style: {
      fill: "#bdc3c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 252.6 H 683.4 V 263.4 H 672.6 V 252.6 Z",
    style: {
      fill: "rgba(221,233,228,0.83)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 324.6 H 683.4 V 335.4 H 672.6 V 324.6 Z",
    style: {
      fill: "rgba(211,222,219,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 336.6 H 683.4 V 347.4 H 672.6 V 336.6 Z",
    style: {
      fill: "#b5bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 348.6 H 683.4 V 359.4 H 672.6 V 348.6 Z",
    style: {
      fill: "#adb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 360.6 H 683.4 V 371.4 H 672.6 V 360.6 Z",
    style: {
      fill: "#b7bcc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 372.6 H 683.4 V 383.4 H 672.6 V 372.6 Z",
    style: {
      fill: "rgba(217,229,224,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 408.6 H 683.4 V 419.4 H 672.6 V 408.6 Z",
    style: {
      fill: "rgba(227,240,235,0.69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 420.6 H 683.4 V 431.4 H 672.6 V 420.6 Z",
    style: {
      fill: "#c4c8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 432.6 H 683.4 V 443.4 H 672.6 V 432.6 Z",
    style: {
      fill: "#b7bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 444.6 H 683.4 V 455.4 H 672.6 V 444.6 Z",
    style: {
      fill: "#b1b5bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 456.6 H 683.4 V 467.4 H 672.6 V 456.6 Z",
    style: {
      fill: "#b7bbc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 468.6 H 683.4 V 479.4 H 672.6 V 468.6 Z",
    style: {
      fill: "#c3c6ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 480.6 H 683.4 V 491.4 H 672.6 V 480.6 Z",
    style: {
      fill: "rgba(219,223,224,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 492.6 H 683.4 V 503.4 H 672.6 V 492.6 Z",
    style: {
      fill: "rgba(248,251,251,0.27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 636.6 H 683.4 V 647.4 H 672.6 V 636.6 Z",
    style: {
      fill: "rgba(249,255,255,0.36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 648.6 H 683.4 V 659.4 H 672.6 V 648.6 Z",
    style: {
      fill: "rgba(227,232,233,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 660.6 H 683.4 V 671.4 H 672.6 V 660.6 Z",
    style: {
      fill: "#c6c9cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 672.6 H 683.4 V 683.4 H 672.6 V 672.6 Z",
    style: {
      fill: "#bbbec3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 684.6 H 683.4 V 695.4 H 672.6 V 684.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 696.6 H 683.4 V 707.4 H 672.6 V 696.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 708.6 H 683.4 V 719.4 H 672.6 V 708.6 Z",
    style: {
      fill: "#b9bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 720.6 H 683.4 V 731.4 H 672.6 V 720.6 Z",
    style: {
      fill: "#c6cacb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 732.6 H 683.4 V 743.4 H 672.6 V 732.6 Z",
    style: {
      fill: "rgba(227,240,235,0.4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 888.6 H 683.4 V 899.4 H 672.6 V 888.6 Z",
    style: {
      fill: "rgba(222,233,230,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 900.6 H 683.4 V 911.4 H 672.6 V 900.6 Z",
    style: {
      fill: "#bec4c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 912.6 H 683.4 V 923.4 H 672.6 V 912.6 Z",
    style: {
      fill: "#adb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 924.6 H 683.4 V 935.4 H 672.6 V 924.6 Z",
    style: {
      fill: "#a5aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 936.6 H 683.4 V 947.4 H 672.6 V 936.6 Z",
    style: {
      fill: "#a7acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 672.6 948.6 H 683.4 V 959.4 H 672.6 V 948.6 Z",
    style: {
      fill: "rgba(187,187,187,0.06)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 204.6 H 695.4 V 215.4 H 684.6 V 204.6 Z",
    style: {
      fill: "rgba(227,232,234,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 216.6 H 695.4 V 227.4 H 684.6 V 216.6 Z",
    style: {
      fill: "#bec2c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 228.6 H 695.4 V 239.4 H 684.6 V 228.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 240.6 H 695.4 V 251.4 H 684.6 V 240.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 252.6 H 695.4 V 263.4 H 684.6 V 252.6 Z",
    style: {
      fill: "rgba(210,218,217,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 324.6 H 695.4 V 335.4 H 684.6 V 324.6 Z",
    style: {
      fill: "rgba(206,215,213,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 336.6 H 695.4 V 347.4 H 684.6 V 336.6 Z",
    style: {
      fill: "#b4b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 348.6 H 695.4 V 359.4 H 684.6 V 348.6 Z",
    style: {
      fill: "#aeb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 360.6 H 695.4 V 371.4 H 684.6 V 360.6 Z",
    style: {
      fill: "#b9bec2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 372.6 H 695.4 V 383.4 H 684.6 V 372.6 Z",
    style: {
      fill: "rgba(220,232,228,0.51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 396.6 H 695.4 V 407.4 H 684.6 V 396.6 Z",
    style: {
      fill: "rgba(225,240,225,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 408.6 H 695.4 V 419.4 H 684.6 V 408.6 Z",
    style: {
      fill: "#cdd4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 420.6 H 695.4 V 431.4 H 684.6 V 420.6 Z",
    style: {
      fill: "#b9bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 432.6 H 695.4 V 443.4 H 684.6 V 432.6 Z",
    style: {
      fill: "#b1b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 444.6 H 695.4 V 455.4 H 684.6 V 444.6 Z",
    style: {
      fill: "#b7bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 456.6 H 695.4 V 467.4 H 684.6 V 456.6 Z",
    style: {
      fill: "#c5c8cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 468.6 H 695.4 V 479.4 H 684.6 V 468.6 Z",
    style: {
      fill: "rgba(238,243,243,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 480.6 H 695.4 V 491.4 H 684.6 V 480.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 660.6 H 695.4 V 671.4 H 684.6 V 660.6 Z",
    style: {
      fill: "rgba(246,253,253,0.45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 672.6 H 695.4 V 683.4 H 684.6 V 672.6 Z",
    style: {
      fill: "#d1d3d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 684.6 H 695.4 V 695.4 H 684.6 V 684.6 Z",
    style: {
      fill: "#c0c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 696.6 H 695.4 V 707.4 H 684.6 V 696.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 708.6 H 695.4 V 719.4 H 684.6 V 708.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 720.6 H 695.4 V 731.4 H 684.6 V 720.6 Z",
    style: {
      fill: "#b8bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 732.6 H 695.4 V 743.4 H 684.6 V 732.6 Z",
    style: {
      fill: "#c9cfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 744.6 H 695.4 V 755.4 H 684.6 V 744.6 Z",
    style: {
      fill: "rgba(225,238,233,0.23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 888.6 H 695.4 V 899.4 H 684.6 V 888.6 Z",
    style: {
      fill: "rgba(227,255,227,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 900.6 H 695.4 V 911.4 H 684.6 V 900.6 Z",
    style: {
      fill: "#c7cece"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 912.6 H 695.4 V 923.4 H 684.6 V 912.6 Z",
    style: {
      fill: "#b3b8be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 924.6 H 695.4 V 935.4 H 684.6 V 924.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 936.6 H 695.4 V 947.4 H 684.6 V 936.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684.6 948.6 H 695.4 V 959.4 H 684.6 V 948.6 Z",
    style: {
      fill: "rgba(172,180,182,0.9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 204.6 H 707.4 V 215.4 H 696.6 V 204.6 Z",
    style: {
      fill: "rgba(241,246,247,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 216.6 H 707.4 V 227.4 H 696.6 V 216.6 Z",
    style: {
      fill: "#c4c7cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 228.6 H 707.4 V 239.4 H 696.6 V 228.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 240.6 H 707.4 V 251.4 H 696.6 V 240.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 252.6 H 707.4 V 263.4 H 696.6 V 252.6 Z",
    style: {
      fill: "#cbd4d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 324.6 H 707.4 V 335.4 H 696.6 V 324.6 Z",
    style: {
      fill: "#c7cece"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 336.6 H 707.4 V 347.4 H 696.6 V 336.6 Z",
    style: {
      fill: "#b2b8be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 348.6 H 707.4 V 359.4 H 696.6 V 348.6 Z",
    style: {
      fill: "#aeb3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 360.6 H 707.4 V 371.4 H 696.6 V 360.6 Z",
    style: {
      fill: "#bbbfc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 372.6 H 707.4 V 383.4 H 696.6 V 372.6 Z",
    style: {
      fill: "rgba(223,235,230,0.41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 396.6 H 707.4 V 407.4 H 696.6 V 396.6 Z",
    style: {
      fill: "rgba(221,234,230,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 408.6 H 707.4 V 419.4 H 696.6 V 408.6 Z",
    style: {
      fill: "#bcc1c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 420.6 H 707.4 V 431.4 H 696.6 V 420.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 432.6 H 707.4 V 443.4 H 696.6 V 432.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 444.6 H 707.4 V 455.4 H 696.6 V 444.6 Z",
    style: {
      fill: "#c5c8cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 456.6 H 707.4 V 467.4 H 696.6 V 456.6 Z",
    style: {
      fill: "rgba(236,241,241,0.84)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 672.6 H 707.4 V 683.4 H 696.6 V 672.6 Z",
    style: {
      fill: "rgba(255,255,255,0.08)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 684.6 H 707.4 V 695.4 H 696.6 V 684.6 Z",
    style: {
      fill: "#dbdee1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 696.6 H 707.4 V 707.4 H 696.6 V 696.6 Z",
    style: {
      fill: "#c2c5cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 708.6 H 707.4 V 719.4 H 696.6 V 708.6 Z",
    style: {
      fill: "#b4b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 720.6 H 707.4 V 731.4 H 696.6 V 720.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 732.6 H 707.4 V 743.4 H 696.6 V 732.6 Z",
    style: {
      fill: "#babfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 744.6 H 707.4 V 755.4 H 696.6 V 744.6 Z",
    style: {
      fill: "#d4dedd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 756.6 H 707.4 V 767.4 H 696.6 V 756.6 Z",
    style: {
      fill: "rgba(255,255,255,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 900.6 H 707.4 V 911.4 H 696.6 V 900.6 Z",
    style: {
      fill: "rgba(217,229,225,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 912.6 H 707.4 V 923.4 H 696.6 V 912.6 Z",
    style: {
      fill: "#babec2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 924.6 H 707.4 V 935.4 H 696.6 V 924.6 Z",
    style: {
      fill: "#aaafb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 936.6 H 707.4 V 947.4 H 696.6 V 936.6 Z",
    style: {
      fill: "#a4aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 948.6 H 707.4 V 959.4 H 696.6 V 948.6 Z",
    style: {
      fill: "#a9afb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 696.6 960.6 H 707.4 V 971.4 H 696.6 V 960.6 Z",
    style: {
      fill: "rgba(185,185,185,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 204.6 H 719.4 V 215.4 H 708.6 V 204.6 Z",
    style: {
      fill: "rgba(252,255,255,0.62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 216.6 H 719.4 V 227.4 H 708.6 V 216.6 Z",
    style: {
      fill: "#c9ccd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 228.6 H 719.4 V 239.4 H 708.6 V 228.6 Z",
    style: {
      fill: "#b6bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 240.6 H 719.4 V 251.4 H 708.6 V 240.6 Z",
    style: {
      fill: "#b2b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 252.6 H 719.4 V 263.4 H 708.6 V 252.6 Z",
    style: {
      fill: "#c1c6c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 264.6 H 719.4 V 275.4 H 708.6 V 264.6 Z",
    style: {
      fill: "rgba(221,238,238,0.06)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 312.6 H 719.4 V 323.4 H 708.6 V 312.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 324.6 H 719.4 V 335.4 H 708.6 V 324.6 Z",
    style: {
      fill: "#c2c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 336.6 H 719.4 V 347.4 H 708.6 V 336.6 Z",
    style: {
      fill: "#b1b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 348.6 H 719.4 V 359.4 H 708.6 V 348.6 Z",
    style: {
      fill: "#aeb3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 360.6 H 719.4 V 371.4 H 708.6 V 360.6 Z",
    style: {
      fill: "#bbbfc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 372.6 H 719.4 V 383.4 H 708.6 V 372.6 Z",
    style: {
      fill: "rgba(224,238,231,0.29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 384.6 H 719.4 V 395.4 H 708.6 V 384.6 Z",
    style: {
      fill: "rgba(221,238,229,0.12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 396.6 H 719.4 V 407.4 H 708.6 V 396.6 Z",
    style: {
      fill: "#c1c5c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 408.6 H 719.4 V 419.4 H 708.6 V 408.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 420.6 H 719.4 V 431.4 H 708.6 V 420.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 432.6 H 719.4 V 443.4 H 708.6 V 432.6 Z",
    style: {
      fill: "#c0c4ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 444.6 H 719.4 V 455.4 H 708.6 V 444.6 Z",
    style: {
      fill: "rgba(222,226,228,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 684.6 H 719.4 V 695.4 H 708.6 V 684.6 Z",
    style: {
      fill: "rgba(255,255,255,0.22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 696.6 H 719.4 V 707.4 H 708.6 V 696.6 Z",
    style: {
      fill: "#dce0e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 708.6 H 719.4 V 719.4 H 708.6 V 708.6 Z",
    style: {
      fill: "#c0c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 720.6 H 719.4 V 731.4 H 708.6 V 720.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 732.6 H 719.4 V 743.4 H 708.6 V 732.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 744.6 H 719.4 V 755.4 H 708.6 V 744.6 Z",
    style: {
      fill: "#bdc1c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 756.6 H 719.4 V 767.4 H 708.6 V 756.6 Z",
    style: {
      fill: "rgba(222,235,231,0.82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 900.6 H 719.4 V 911.4 H 708.6 V 900.6 Z",
    style: {
      fill: "rgba(223,235,231,0.25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 912.6 H 719.4 V 923.4 H 708.6 V 912.6 Z",
    style: {
      fill: "#c4cacb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 924.6 H 719.4 V 935.4 H 708.6 V 924.6 Z",
    style: {
      fill: "#afb4ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 936.6 H 719.4 V 947.4 H 708.6 V 936.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 948.6 H 719.4 V 959.4 H 708.6 V 948.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 708.6 960.6 H 719.4 V 971.4 H 708.6 V 960.6 Z",
    style: {
      fill: "rgba(181,194,192,0.62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 204.6 H 731.4 V 215.4 H 720.6 V 204.6 Z",
    style: {
      fill: "rgba(255,255,255,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 216.6 H 731.4 V 227.4 H 720.6 V 216.6 Z",
    style: {
      fill: "#d4d7d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 228.6 H 731.4 V 239.4 H 720.6 V 228.6 Z",
    style: {
      fill: "#babfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 240.6 H 731.4 V 251.4 H 720.6 V 240.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 252.6 H 731.4 V 263.4 H 720.6 V 252.6 Z",
    style: {
      fill: "#bbbfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 264.6 H 731.4 V 275.4 H 720.6 V 264.6 Z",
    style: {
      fill: "rgba(223,236,232,0.82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 324.6 H 731.4 V 335.4 H 720.6 V 324.6 Z",
    style: {
      fill: "#c2c7c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 336.6 H 731.4 V 347.4 H 720.6 V 336.6 Z",
    style: {
      fill: "#b1b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 348.6 H 731.4 V 359.4 H 720.6 V 348.6 Z",
    style: {
      fill: "#aeb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 360.6 H 731.4 V 371.4 H 720.6 V 360.6 Z",
    style: {
      fill: "#babec2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 372.6 H 731.4 V 383.4 H 720.6 V 372.6 Z",
    style: {
      fill: "rgba(224,238,231,0.29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 384.6 H 731.4 V 395.4 H 720.6 V 384.6 Z",
    style: {
      fill: "rgba(217,231,226,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 396.6 H 731.4 V 407.4 H 720.6 V 396.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 408.6 H 731.4 V 419.4 H 720.6 V 408.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 420.6 H 731.4 V 431.4 H 720.6 V 420.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 432.6 H 731.4 V 443.4 H 720.6 V 432.6 Z",
    style: {
      fill: "#cdd0d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 444.6 H 731.4 V 455.4 H 720.6 V 444.6 Z",
    style: {
      fill: "rgba(253,254,254,0.82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 696.6 H 731.4 V 707.4 H 720.6 V 696.6 Z",
    style: {
      fill: "rgba(253,255,255,0.51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 708.6 H 731.4 V 719.4 H 720.6 V 708.6 Z",
    style: {
      fill: "#d2d4d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 720.6 H 731.4 V 731.4 H 720.6 V 720.6 Z",
    style: {
      fill: "#bcc0c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 732.6 H 731.4 V 743.4 H 720.6 V 732.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 744.6 H 731.4 V 755.4 H 720.6 V 744.6 Z",
    style: {
      fill: "#b4b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 756.6 H 731.4 V 767.4 H 720.6 V 756.6 Z",
    style: {
      fill: "#c3c7c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 768.6 H 731.4 V 779.4 H 720.6 V 768.6 Z",
    style: {
      fill: "rgba(219,231,231,0.08)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 912.6 H 731.4 V 923.4 H 720.6 V 912.6 Z",
    style: {
      fill: "#d0dbd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 924.6 H 731.4 V 935.4 H 720.6 V 924.6 Z",
    style: {
      fill: "#b5babf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 936.6 H 731.4 V 947.4 H 720.6 V 936.6 Z",
    style: {
      fill: "#a8aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 948.6 H 731.4 V 959.4 H 720.6 V 948.6 Z",
    style: {
      fill: "#a6acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 720.6 960.6 H 731.4 V 971.4 H 720.6 V 960.6 Z",
    style: {
      fill: "rgba(173,181,184,0.94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 204.6 H 743.4 V 215.4 H 732.6 V 204.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 216.6 H 743.4 V 227.4 H 732.6 V 216.6 Z",
    style: {
      fill: "#e7eced"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 228.6 H 743.4 V 239.4 H 732.6 V 228.6 Z",
    style: {
      fill: "#c0c5ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 240.6 H 743.4 V 251.4 H 732.6 V 240.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 252.6 H 743.4 V 263.4 H 732.6 V 252.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 264.6 H 743.4 V 275.4 H 732.6 V 264.6 Z",
    style: {
      fill: "#cdd5d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 324.6 H 743.4 V 335.4 H 732.6 V 324.6 Z",
    style: {
      fill: "#c4cacb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 336.6 H 743.4 V 347.4 H 732.6 V 336.6 Z",
    style: {
      fill: "#b1b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 348.6 H 743.4 V 359.4 H 732.6 V 348.6 Z",
    style: {
      fill: "#adb2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 360.6 H 743.4 V 371.4 H 732.6 V 360.6 Z",
    style: {
      fill: "#b9bec1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 372.6 H 743.4 V 383.4 H 732.6 V 372.6 Z",
    style: {
      fill: "rgba(217,235,229,0.35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 384.6 H 743.4 V 395.4 H 732.6 V 384.6 Z",
    style: {
      fill: "rgba(193,199,199,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 396.6 H 743.4 V 407.4 H 732.6 V 396.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 408.6 H 743.4 V 419.4 H 732.6 V 408.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 420.6 H 743.4 V 431.4 H 732.6 V 420.6 Z",
    style: {
      fill: "#c0c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 432.6 H 743.4 V 443.4 H 732.6 V 432.6 Z",
    style: {
      fill: "rgba(239,243,244,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 444.6 H 743.4 V 455.4 H 732.6 V 444.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 708.6 H 743.4 V 719.4 H 732.6 V 708.6 Z",
    style: {
      fill: "rgba(252,255,255,0.92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 720.6 H 743.4 V 731.4 H 732.6 V 720.6 Z",
    style: {
      fill: "#c9cdd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 732.6 H 743.4 V 743.4 H 732.6 V 732.6 Z",
    style: {
      fill: "#b7bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 744.6 H 743.4 V 755.4 H 732.6 V 744.6 Z",
    style: {
      fill: "#b0b5bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 756.6 H 743.4 V 767.4 H 732.6 V 756.6 Z",
    style: {
      fill: "#b8bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 768.6 H 743.4 V 779.4 H 732.6 V 768.6 Z",
    style: {
      fill: "rgba(214,225,223,0.85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 912.6 H 743.4 V 923.4 H 732.6 V 912.6 Z",
    style: {
      fill: "rgba(221,235,229,0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 924.6 H 743.4 V 935.4 H 732.6 V 924.6 Z",
    style: {
      fill: "#bcc1c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 936.6 H 743.4 V 947.4 H 732.6 V 936.6 Z",
    style: {
      fill: "#acb2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 948.6 H 743.4 V 959.4 H 732.6 V 948.6 Z",
    style: {
      fill: "#a6acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 960.6 H 743.4 V 971.4 H 732.6 V 960.6 Z",
    style: {
      fill: "#aab0b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 732.6 972.6 H 743.4 V 983.4 H 732.6 V 972.6 Z",
    style: {
      fill: "rgba(170,170,170,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 216.6 H 755.4 V 227.4 H 744.6 V 216.6 Z",
    style: {
      fill: "rgba(252,255,255,0.91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 228.6 H 755.4 V 239.4 H 744.6 V 228.6 Z",
    style: {
      fill: "#c8ccd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 240.6 H 755.4 V 251.4 H 744.6 V 240.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 252.6 H 755.4 V 263.4 H 744.6 V 252.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 264.6 H 755.4 V 275.4 H 744.6 V 264.6 Z",
    style: {
      fill: "#bdc1c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 276.6 H 755.4 V 287.4 H 744.6 V 276.6 Z",
    style: {
      fill: "rgba(222,236,231,0.58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 324.6 H 755.4 V 335.4 H 744.6 V 324.6 Z",
    style: {
      fill: "rgba(199,205,205,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 336.6 H 755.4 V 347.4 H 744.6 V 336.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 348.6 H 755.4 V 359.4 H 744.6 V 348.6 Z",
    style: {
      fill: "#acb1ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 360.6 H 755.4 V 371.4 H 744.6 V 360.6 Z",
    style: {
      fill: "#b2b8be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 372.6 H 755.4 V 383.4 H 744.6 V 372.6 Z",
    style: {
      fill: "#d5e6e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 384.6 H 755.4 V 395.4 H 744.6 V 384.6 Z",
    style: {
      fill: "#b6bbbe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 396.6 H 755.4 V 407.4 H 744.6 V 396.6 Z",
    style: {
      fill: "#adb2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 408.6 H 755.4 V 419.4 H 744.6 V 408.6 Z",
    style: {
      fill: "#b3b8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 420.6 H 755.4 V 431.4 H 744.6 V 420.6 Z",
    style: {
      fill: "#c9ccd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 432.6 H 755.4 V 443.4 H 744.6 V 432.6 Z",
    style: {
      fill: "rgba(250,253,253,0.65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 708.6 H 755.4 V 719.4 H 744.6 V 708.6 Z",
    style: {
      fill: "rgba(255,255,255,0.03)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 720.6 H 755.4 V 731.4 H 744.6 V 720.6 Z",
    style: {
      fill: "#eef3f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 732.6 H 755.4 V 743.4 H 744.6 V 732.6 Z",
    style: {
      fill: "#c1c4c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 744.6 H 755.4 V 755.4 H 744.6 V 744.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 756.6 H 755.4 V 767.4 H 744.6 V 756.6 Z",
    style: {
      fill: "#b1b6bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 768.6 H 755.4 V 779.4 H 744.6 V 768.6 Z",
    style: {
      fill: "#bec2c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 780.6 H 755.4 V 791.4 H 744.6 V 780.6 Z",
    style: {
      fill: "rgba(225,237,232,0.56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 912.6 H 755.4 V 923.4 H 744.6 V 912.6 Z",
    style: {
      fill: "rgba(216,235,235,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 924.6 H 755.4 V 935.4 H 744.6 V 924.6 Z",
    style: {
      fill: "#cdd6d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 936.6 H 755.4 V 947.4 H 744.6 V 936.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 948.6 H 755.4 V 959.4 H 744.6 V 948.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 960.6 H 755.4 V 971.4 H 744.6 V 960.6 Z",
    style: {
      fill: "#a8aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744.6 972.6 H 755.4 V 983.4 H 744.6 V 972.6 Z",
    style: {
      fill: "rgba(182,196,194,0.49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 216.6 H 767.4 V 227.4 H 756.6 V 216.6 Z",
    style: {
      fill: "rgba(255,255,255,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 228.6 H 767.4 V 239.4 H 756.6 V 228.6 Z",
    style: {
      fill: "#d5d7d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 240.6 H 767.4 V 251.4 H 756.6 V 240.6 Z",
    style: {
      fill: "#bcc0c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 252.6 H 767.4 V 263.4 H 756.6 V 252.6 Z",
    style: {
      fill: "#b0b5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 264.6 H 767.4 V 275.4 H 756.6 V 264.6 Z",
    style: {
      fill: "#b6bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 276.6 H 767.4 V 287.4 H 756.6 V 276.6 Z",
    style: {
      fill: "rgba(205,212,212,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 324.6 H 767.4 V 335.4 H 756.6 V 324.6 Z",
    style: {
      fill: "rgba(208,217,215,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 336.6 H 767.4 V 347.4 H 756.6 V 336.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 348.6 H 767.4 V 359.4 H 756.6 V 348.6 Z",
    style: {
      fill: "#aab1b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 360.6 H 767.4 V 371.4 H 756.6 V 360.6 Z",
    style: {
      fill: "#abb2ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 372.6 H 767.4 V 383.4 H 756.6 V 372.6 Z",
    style: {
      fill: "#becbd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 384.6 H 767.4 V 395.4 H 756.6 V 384.6 Z",
    style: {
      fill: "#acb2b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 396.6 H 767.4 V 407.4 H 756.6 V 396.6 Z",
    style: {
      fill: "#aab0b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 408.6 H 767.4 V 419.4 H 756.6 V 408.6 Z",
    style: {
      fill: "#b6bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 420.6 H 767.4 V 431.4 H 756.6 V 420.6 Z",
    style: {
      fill: "#ced0d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 432.6 H 767.4 V 443.4 H 756.6 V 432.6 Z",
    style: {
      fill: "rgba(255,255,255,0.03)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 720.6 H 767.4 V 731.4 H 756.6 V 720.6 Z",
    style: {
      fill: "rgba(251,255,255,0.24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 732.6 H 767.4 V 743.4 H 756.6 V 732.6 Z",
    style: {
      fill: "#cdcfd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 744.6 H 767.4 V 755.4 H 756.6 V 744.6 Z",
    style: {
      fill: "#b8bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 756.6 H 767.4 V 767.4 H 756.6 V 756.6 Z",
    style: {
      fill: "#afb3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 768.6 H 767.4 V 779.4 H 756.6 V 768.6 Z",
    style: {
      fill: "#b7bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 780.6 H 767.4 V 791.4 H 756.6 V 780.6 Z",
    style: {
      fill: "rgba(207,215,213,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 924.6 H 767.4 V 935.4 H 756.6 V 924.6 Z",
    style: {
      fill: "#d6e2df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 936.6 H 767.4 V 947.4 H 756.6 V 936.6 Z",
    style: {
      fill: "#b7bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 948.6 H 767.4 V 959.4 H 756.6 V 948.6 Z",
    style: {
      fill: "#a9afb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 960.6 H 767.4 V 971.4 H 756.6 V 960.6 Z",
    style: {
      fill: "#a6adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 756.6 972.6 H 767.4 V 983.4 H 756.6 V 972.6 Z",
    style: {
      fill: "rgba(174,184,184,0.79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 228.6 H 779.4 V 239.4 H 768.6 V 228.6 Z",
    style: {
      fill: "rgba(249,253,253,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 240.6 H 779.4 V 251.4 H 768.6 V 240.6 Z",
    style: {
      fill: "#c5c7cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 252.6 H 779.4 V 263.4 H 768.6 V 252.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 264.6 H 779.4 V 275.4 H 768.6 V 264.6 Z",
    style: {
      fill: "#b1b6bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 276.6 H 779.4 V 287.4 H 768.6 V 276.6 Z",
    style: {
      fill: "#c0c6c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 288.6 H 779.4 V 299.4 H 768.6 V 288.6 Z",
    style: {
      fill: "rgba(218,230,227,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 324.6 H 779.4 V 335.4 H 768.6 V 324.6 Z",
    style: {
      fill: "rgba(220,233,229,0.55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 336.6 H 779.4 V 347.4 H 768.6 V 336.6 Z",
    style: {
      fill: "#babec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 348.6 H 779.4 V 359.4 H 768.6 V 348.6 Z",
    style: {
      fill: "#abb1b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 360.6 H 779.4 V 371.4 H 768.6 V 360.6 Z",
    style: {
      fill: "#a6acb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 372.6 H 779.4 V 383.4 H 768.6 V 372.6 Z",
    style: {
      fill: "#a6acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 384.6 H 779.4 V 395.4 H 768.6 V 384.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 396.6 H 779.4 V 407.4 H 768.6 V 396.6 Z",
    style: {
      fill: "#a8aeb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 408.6 H 779.4 V 419.4 H 768.6 V 408.6 Z",
    style: {
      fill: "#b9bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 420.6 H 779.4 V 431.4 H 768.6 V 420.6 Z",
    style: {
      fill: "#d8dcdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 732.6 H 779.4 V 743.4 H 768.6 V 732.6 Z",
    style: {
      fill: "rgba(240,245,246,0.88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 744.6 H 779.4 V 755.4 H 768.6 V 744.6 Z",
    style: {
      fill: "#c2c5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 756.6 H 779.4 V 767.4 H 768.6 V 756.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 768.6 H 779.4 V 779.4 H 768.6 V 768.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 780.6 H 779.4 V 791.4 H 768.6 V 780.6 Z",
    style: {
      fill: "#bfc3c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 792.6 H 779.4 V 803.4 H 768.6 V 792.6 Z",
    style: {
      fill: "rgba(221,238,229,0.12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 924.6 H 779.4 V 935.4 H 768.6 V 924.6 Z",
    style: {
      fill: "rgba(224,236,231,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 936.6 H 779.4 V 947.4 H 768.6 V 936.6 Z",
    style: {
      fill: "#bbc1c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 948.6 H 779.4 V 959.4 H 768.6 V 948.6 Z",
    style: {
      fill: "#abb1b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 960.6 H 779.4 V 971.4 H 768.6 V 960.6 Z",
    style: {
      fill: "#a5acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 768.6 972.6 H 779.4 V 983.4 H 768.6 V 972.6 Z",
    style: {
      fill: "rgba(170,176,180,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 228.6 H 791.4 V 239.4 H 780.6 V 228.6 Z",
    style: {
      fill: "rgba(251,255,255,0.27)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 240.6 H 791.4 V 251.4 H 780.6 V 240.6 Z",
    style: {
      fill: "#cfd2d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 252.6 H 791.4 V 263.4 H 780.6 V 252.6 Z",
    style: {
      fill: "#babec3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 264.6 H 791.4 V 275.4 H 780.6 V 264.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 276.6 H 791.4 V 287.4 H 780.6 V 276.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 288.6 H 791.4 V 299.4 H 780.6 V 288.6 Z",
    style: {
      fill: "#c8d0d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 300.6 H 791.4 V 311.4 H 780.6 V 300.6 Z",
    style: {
      fill: "rgba(226,238,232,0.35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 324.6 H 791.4 V 335.4 H 780.6 V 324.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 336.6 H 791.4 V 347.4 H 780.6 V 336.6 Z",
    style: {
      fill: "#c0c4c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 348.6 H 791.4 V 359.4 H 780.6 V 348.6 Z",
    style: {
      fill: "#afb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 360.6 H 791.4 V 371.4 H 780.6 V 360.6 Z",
    style: {
      fill: "#a4abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 372.6 H 791.4 V 383.4 H 780.6 V 372.6 Z",
    style: {
      fill: "#a0a7b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 384.6 H 791.4 V 395.4 H 780.6 V 384.6 Z",
    style: {
      fill: "#a1a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 396.6 H 791.4 V 407.4 H 780.6 V 396.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 408.6 H 791.4 V 419.4 H 780.6 V 408.6 Z",
    style: {
      fill: "#bbbfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 420.6 H 791.4 V 431.4 H 780.6 V 420.6 Z",
    style: {
      fill: "rgba(232,238,238,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 732.6 H 791.4 V 743.4 H 780.6 V 732.6 Z",
    style: {
      fill: "rgba(255,255,255,0.08)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 744.6 H 791.4 V 755.4 H 780.6 V 744.6 Z",
    style: {
      fill: "rgba(211,215,216,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 756.6 H 791.4 V 767.4 H 780.6 V 756.6 Z",
    style: {
      fill: "#b7bcc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 768.6 H 791.4 V 779.4 H 780.6 V 768.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 780.6 H 791.4 V 791.4 H 780.6 V 780.6 Z",
    style: {
      fill: "#babec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 792.6 H 791.4 V 803.4 H 780.6 V 792.6 Z",
    style: {
      fill: "rgba(221,234,229,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 924.6 H 791.4 V 935.4 H 780.6 V 924.6 Z",
    style: {
      fill: "rgba(227,241,236,0.21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 936.6 H 791.4 V 947.4 H 780.6 V 936.6 Z",
    style: {
      fill: "#c1c6c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 948.6 H 791.4 V 959.4 H 780.6 V 948.6 Z",
    style: {
      fill: "#aeb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 960.6 H 791.4 V 971.4 H 780.6 V 960.6 Z",
    style: {
      fill: "#a5acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 780.6 972.6 H 791.4 V 983.4 H 780.6 V 972.6 Z",
    style: {
      fill: "#a7adb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 240.6 H 803.4 V 251.4 H 792.6 V 240.6 Z",
    style: {
      fill: "rgba(240,245,246,0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 252.6 H 803.4 V 263.4 H 792.6 V 252.6 Z",
    style: {
      fill: "#c4c8cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 264.6 H 803.4 V 275.4 H 792.6 V 264.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 276.6 H 803.4 V 287.4 H 792.6 V 276.6 Z",
    style: {
      fill: "#afb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 288.6 H 803.4 V 299.4 H 792.6 V 288.6 Z",
    style: {
      fill: "#b8bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 300.6 H 803.4 V 311.4 H 792.6 V 300.6 Z",
    style: {
      fill: "#cdd5d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 312.6 H 803.4 V 323.4 H 792.6 V 312.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 336.6 H 803.4 V 347.4 H 792.6 V 336.6 Z",
    style: {
      fill: "rgba(206,214,214,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 348.6 H 803.4 V 359.4 H 792.6 V 348.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 360.6 H 803.4 V 371.4 H 792.6 V 360.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 372.6 H 803.4 V 383.4 H 792.6 V 372.6 Z",
    style: {
      fill: "#a0a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 384.6 H 803.4 V 395.4 H 792.6 V 384.6 Z",
    style: {
      fill: "#9fa6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 396.6 H 803.4 V 407.4 H 792.6 V 396.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 408.6 H 803.4 V 419.4 H 792.6 V 408.6 Z",
    style: {
      fill: "#bcc0c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 420.6 H 803.4 V 431.4 H 792.6 V 420.6 Z",
    style: {
      fill: "rgba(235,241,242,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 744.6 H 803.4 V 755.4 H 792.6 V 744.6 Z",
    style: {
      fill: "rgba(230,235,236,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 756.6 H 803.4 V 767.4 H 792.6 V 756.6 Z",
    style: {
      fill: "#bfc2c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 768.6 H 803.4 V 779.4 H 792.6 V 768.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 780.6 H 803.4 V 791.4 H 792.6 V 780.6 Z",
    style: {
      fill: "#b5bac1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 792.6 H 803.4 V 803.4 H 792.6 V 792.6 Z",
    style: {
      fill: "#d0dad8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 804.6 H 803.4 V 815.4 H 792.6 V 804.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 924.6 H 803.4 V 935.4 H 792.6 V 924.6 Z",
    style: {
      fill: "rgba(232,232,232,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 936.6 H 803.4 V 947.4 H 792.6 V 936.6 Z",
    style: {
      fill: "#cbd3d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 948.6 H 803.4 V 959.4 H 792.6 V 948.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 960.6 H 803.4 V 971.4 H 792.6 V 960.6 Z",
    style: {
      fill: "#a6acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 972.6 H 803.4 V 983.4 H 792.6 V 972.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 792.6 984.6 H 803.4 V 995.4 H 792.6 V 984.6 Z",
    style: {
      fill: "rgba(178,185,185,0.26)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 252.6 H 815.4 V 263.4 H 804.6 V 252.6 Z",
    style: {
      fill: "#d3d5d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 264.6 H 815.4 V 275.4 H 804.6 V 264.6 Z",
    style: {
      fill: "#bfc3c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 276.6 H 815.4 V 287.4 H 804.6 V 276.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 288.6 H 815.4 V 299.4 H 804.6 V 288.6 Z",
    style: {
      fill: "#b0b5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 300.6 H 815.4 V 311.4 H 804.6 V 300.6 Z",
    style: {
      fill: "#b9bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 312.6 H 815.4 V 323.4 H 804.6 V 312.6 Z",
    style: {
      fill: "#cfd8d7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 324.6 H 815.4 V 335.4 H 804.6 V 324.6 Z",
    style: {
      fill: "rgba(227,227,227,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 336.6 H 815.4 V 347.4 H 804.6 V 336.6 Z",
    style: {
      fill: "rgba(222,237,231,0.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 348.6 H 815.4 V 359.4 H 804.6 V 348.6 Z",
    style: {
      fill: "#babfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 360.6 H 815.4 V 371.4 H 804.6 V 360.6 Z",
    style: {
      fill: "#acb1ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 372.6 H 815.4 V 383.4 H 804.6 V 372.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 384.6 H 815.4 V 395.4 H 804.6 V 384.6 Z",
    style: {
      fill: "#9fa6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 396.6 H 815.4 V 407.4 H 804.6 V 396.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 408.6 H 815.4 V 419.4 H 804.6 V 408.6 Z",
    style: {
      fill: "#bbbfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 420.6 H 815.4 V 431.4 H 804.6 V 420.6 Z",
    style: {
      fill: "rgba(229,234,235,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 744.6 H 815.4 V 755.4 H 804.6 V 744.6 Z",
    style: {
      fill: "rgba(251,255,255,0.45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 756.6 H 815.4 V 767.4 H 804.6 V 756.6 Z",
    style: {
      fill: "#c6c8cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 768.6 H 815.4 V 779.4 H 804.6 V 768.6 Z",
    style: {
      fill: "#b4b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 780.6 H 815.4 V 791.4 H 804.6 V 780.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 792.6 H 815.4 V 803.4 H 804.6 V 792.6 Z",
    style: {
      fill: "#c2c6c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 804.6 H 815.4 V 815.4 H 804.6 V 804.6 Z",
    style: {
      fill: "rgba(225,237,230,0.4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 936.6 H 815.4 V 947.4 H 804.6 V 936.6 Z",
    style: {
      fill: "#d7e3e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 948.6 H 815.4 V 959.4 H 804.6 V 948.6 Z",
    style: {
      fill: "#b5b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 960.6 H 815.4 V 971.4 H 804.6 V 960.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 972.6 H 815.4 V 983.4 H 804.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 804.6 984.6 H 815.4 V 995.4 H 804.6 V 984.6 Z",
    style: {
      fill: "rgba(173,181,183,0.77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 252.6 H 827.4 V 263.4 H 816.6 V 252.6 Z",
    style: {
      fill: "rgba(255,255,255,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 264.6 H 827.4 V 275.4 H 816.6 V 264.6 Z",
    style: {
      fill: "#d0d2d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 276.6 H 827.4 V 287.4 H 816.6 V 276.6 Z",
    style: {
      fill: "#bdc1c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 288.6 H 827.4 V 299.4 H 816.6 V 288.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 300.6 H 827.4 V 311.4 H 816.6 V 300.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 312.6 H 827.4 V 323.4 H 816.6 V 312.6 Z",
    style: {
      fill: "#b8bdc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 324.6 H 827.4 V 335.4 H 816.6 V 324.6 Z",
    style: {
      fill: "#c9d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 336.6 H 827.4 V 347.4 H 816.6 V 336.6 Z",
    style: {
      fill: "rgba(220,235,230,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 348.6 H 827.4 V 359.4 H 816.6 V 348.6 Z",
    style: {
      fill: "#c7d2d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 360.6 H 827.4 V 371.4 H 816.6 V 360.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 372.6 H 827.4 V 383.4 H 816.6 V 372.6 Z",
    style: {
      fill: "#a4aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 384.6 H 827.4 V 395.4 H 816.6 V 384.6 Z",
    style: {
      fill: "#a0a6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 396.6 H 827.4 V 407.4 H 816.6 V 396.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 408.6 H 827.4 V 419.4 H 816.6 V 408.6 Z",
    style: {
      fill: "#b8bcc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 420.6 H 827.4 V 431.4 H 816.6 V 420.6 Z",
    style: {
      fill: "rgba(216,219,220,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 744.6 H 827.4 V 755.4 H 816.6 V 744.6 Z",
    style: {
      fill: "rgba(255,255,255,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 756.6 H 827.4 V 767.4 H 816.6 V 756.6 Z",
    style: {
      fill: "#cfd1d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 768.6 H 827.4 V 779.4 H 816.6 V 768.6 Z",
    style: {
      fill: "#b8bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 780.6 H 827.4 V 791.4 H 816.6 V 780.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 792.6 H 827.4 V 803.4 H 816.6 V 792.6 Z",
    style: {
      fill: "#bdc1c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 804.6 H 827.4 V 815.4 H 816.6 V 804.6 Z",
    style: {
      fill: "rgba(225,237,232,0.74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 936.6 H 827.4 V 947.4 H 816.6 V 936.6 Z",
    style: {
      fill: "rgba(219,232,227,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 948.6 H 827.4 V 959.4 H 816.6 V 948.6 Z",
    style: {
      fill: "#b8bcc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 960.6 H 827.4 V 971.4 H 816.6 V 960.6 Z",
    style: {
      fill: "#a9afb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 972.6 H 827.4 V 983.4 H 816.6 V 972.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 816.6 984.6 H 827.4 V 995.4 H 816.6 V 984.6 Z",
    style: {
      fill: "rgba(171,178,182,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 264.6 H 839.4 V 275.4 H 828.6 V 264.6 Z",
    style: {
      fill: "rgba(255,255,255,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 276.6 H 839.4 V 287.4 H 828.6 V 276.6 Z",
    style: {
      fill: "#ced1d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 288.6 H 839.4 V 299.4 H 828.6 V 288.6 Z",
    style: {
      fill: "#bec2c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 300.6 H 839.4 V 311.4 H 828.6 V 300.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 312.6 H 839.4 V 323.4 H 828.6 V 312.6 Z",
    style: {
      fill: "#b0b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 324.6 H 839.4 V 335.4 H 828.6 V 324.6 Z",
    style: {
      fill: "#b5bac0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 336.6 H 839.4 V 347.4 H 828.6 V 336.6 Z",
    style: {
      fill: "#bbc0c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 348.6 H 839.4 V 359.4 H 828.6 V 348.6 Z",
    style: {
      fill: "#d7e9eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 360.6 H 839.4 V 371.4 H 828.6 V 360.6 Z",
    style: {
      fill: "#afb5ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 372.6 H 839.4 V 383.4 H 828.6 V 372.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 384.6 H 839.4 V 395.4 H 828.6 V 384.6 Z",
    style: {
      fill: "#a0a6b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 396.6 H 839.4 V 407.4 H 828.6 V 396.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 408.6 H 839.4 V 419.4 H 828.6 V 408.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 420.6 H 839.4 V 431.4 H 828.6 V 420.6 Z",
    style: {
      fill: "#cbcdcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 432.6 H 839.4 V 443.4 H 828.6 V 432.6 Z",
    style: {
      fill: "rgba(255,255,255,0.03)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 756.6 H 839.4 V 767.4 H 828.6 V 756.6 Z",
    style: {
      fill: "rgba(224,229,231,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 768.6 H 839.4 V 779.4 H 828.6 V 768.6 Z",
    style: {
      fill: "#bdc2c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 780.6 H 839.4 V 791.4 H 828.6 V 780.6 Z",
    style: {
      fill: "#b1b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 792.6 H 839.4 V 803.4 H 828.6 V 792.6 Z",
    style: {
      fill: "#b8bec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 804.6 H 839.4 V 815.4 H 828.6 V 804.6 Z",
    style: {
      fill: "#d9e4e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 936.6 H 839.4 V 947.4 H 828.6 V 936.6 Z",
    style: {
      fill: "rgba(223,235,231,0.71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 948.6 H 839.4 V 959.4 H 828.6 V 948.6 Z",
    style: {
      fill: "#bbc0c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 960.6 H 839.4 V 971.4 H 828.6 V 960.6 Z",
    style: {
      fill: "#aab0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 972.6 H 839.4 V 983.4 H 828.6 V 972.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 828.6 984.6 H 839.4 V 995.4 H 828.6 V 984.6 Z",
    style: {
      fill: "#aab0b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 276.6 H 851.4 V 287.4 H 840.6 V 276.6 Z",
    style: {
      fill: "rgba(252,255,255,0.37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 288.6 H 851.4 V 299.4 H 840.6 V 288.6 Z",
    style: {
      fill: "#d1d3d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 300.6 H 851.4 V 311.4 H 840.6 V 300.6 Z",
    style: {
      fill: "#c0c3c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 312.6 H 851.4 V 323.4 H 840.6 V 312.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 324.6 H 851.4 V 335.4 H 840.6 V 324.6 Z",
    style: {
      fill: "#afb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 336.6 H 851.4 V 347.4 H 840.6 V 336.6 Z",
    style: {
      fill: "#afb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 348.6 H 851.4 V 359.4 H 840.6 V 348.6 Z",
    style: {
      fill: "#afb5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 360.6 H 851.4 V 371.4 H 840.6 V 360.6 Z",
    style: {
      fill: "#b0bbc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 372.6 H 851.4 V 383.4 H 840.6 V 372.6 Z",
    style: {
      fill: "#a3aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 384.6 H 851.4 V 395.4 H 840.6 V 384.6 Z",
    style: {
      fill: "#9fa6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 396.6 H 851.4 V 407.4 H 840.6 V 396.6 Z",
    style: {
      fill: "#a1a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 408.6 H 851.4 V 419.4 H 840.6 V 408.6 Z",
    style: {
      fill: "#aeb4bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 420.6 H 851.4 V 431.4 H 840.6 V 420.6 Z",
    style: {
      fill: "#c3c7cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 432.6 H 851.4 V 443.4 H 840.6 V 432.6 Z",
    style: {
      fill: "rgba(248,253,255,0.6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 756.6 H 851.4 V 767.4 H 840.6 V 756.6 Z",
    style: {
      fill: "rgba(247,252,252,0.73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 768.6 H 851.4 V 779.4 H 840.6 V 768.6 Z",
    style: {
      fill: "#c2c6cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 780.6 H 851.4 V 791.4 H 840.6 V 780.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 792.6 H 851.4 V 803.4 H 840.6 V 792.6 Z",
    style: {
      fill: "#b5bac2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 804.6 H 851.4 V 815.4 H 840.6 V 804.6 Z",
    style: {
      fill: "#cdd5d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 936.6 H 851.4 V 947.4 H 840.6 V 936.6 Z",
    style: {
      fill: "rgba(224,237,233,0.45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 948.6 H 851.4 V 959.4 H 840.6 V 948.6 Z",
    style: {
      fill: "#bec3c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 960.6 H 851.4 V 971.4 H 840.6 V 960.6 Z",
    style: {
      fill: "#acb2b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 972.6 H 851.4 V 983.4 H 840.6 V 972.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 984.6 H 851.4 V 995.4 H 840.6 V 984.6 Z",
    style: {
      fill: "#a9afb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 840.6 996.6 H 851.4 V 1007.4 H 840.6 V 996.6 Z",
    style: {
      fill: "rgba(185,209,185,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 288.6 H 863.4 V 299.4 H 852.6 V 288.6 Z",
    style: {
      fill: "rgba(252,255,255,0.35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 300.6 H 863.4 V 311.4 H 852.6 V 300.6 Z",
    style: {
      fill: "#d8dadb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 312.6 H 863.4 V 323.4 H 852.6 V 312.6 Z",
    style: {
      fill: "#c3c6cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 324.6 H 863.4 V 335.4 H 852.6 V 324.6 Z",
    style: {
      fill: "#b6bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 336.6 H 863.4 V 347.4 H 852.6 V 336.6 Z",
    style: {
      fill: "#adb2bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 348.6 H 863.4 V 359.4 H 852.6 V 348.6 Z",
    style: {
      fill: "#a8aeb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 360.6 H 863.4 V 371.4 H 852.6 V 360.6 Z",
    style: {
      fill: "#a4aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 372.6 H 863.4 V 383.4 H 852.6 V 372.6 Z",
    style: {
      fill: "#a0a7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 384.6 H 863.4 V 395.4 H 852.6 V 384.6 Z",
    style: {
      fill: "#9ea5ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 396.6 H 863.4 V 407.4 H 852.6 V 396.6 Z",
    style: {
      fill: "#9fa7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 408.6 H 863.4 V 419.4 H 852.6 V 408.6 Z",
    style: {
      fill: "#a8afb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 420.6 H 863.4 V 431.4 H 852.6 V 420.6 Z",
    style: {
      fill: "#bbbfc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 432.6 H 863.4 V 443.4 H 852.6 V 432.6 Z",
    style: {
      fill: "rgba(222,227,228,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 756.6 H 863.4 V 767.4 H 852.6 V 756.6 Z",
    style: {
      fill: "rgba(251,253,253,0.53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 768.6 H 863.4 V 779.4 H 852.6 V 768.6 Z",
    style: {
      fill: "#c7cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 780.6 H 863.4 V 791.4 H 852.6 V 780.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 792.6 H 863.4 V 803.4 H 852.6 V 792.6 Z",
    style: {
      fill: "#b3b8c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 804.6 H 863.4 V 815.4 H 852.6 V 804.6 Z",
    style: {
      fill: "#c2c6c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 816.6 H 863.4 V 827.4 H 852.6 V 816.6 Z",
    style: {
      fill: "rgba(226,233,233,0.14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 936.6 H 863.4 V 947.4 H 852.6 V 936.6 Z",
    style: {
      fill: "rgba(212,255,212,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 948.6 H 863.4 V 959.4 H 852.6 V 948.6 Z",
    style: {
      fill: "rgba(193,199,200,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 960.6 H 863.4 V 971.4 H 852.6 V 960.6 Z",
    style: {
      fill: "#adb3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 972.6 H 863.4 V 983.4 H 852.6 V 972.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 984.6 H 863.4 V 995.4 H 852.6 V 984.6 Z",
    style: {
      fill: "#a8aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 852.6 996.6 H 863.4 V 1007.4 H 852.6 V 996.6 Z",
    style: {
      fill: "rgba(185,193,193,0.11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 300.6 H 875.4 V 311.4 H 864.6 V 300.6 Z",
    style: {
      fill: "rgba(252,255,255,0.29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 312.6 H 875.4 V 323.4 H 864.6 V 312.6 Z",
    style: {
      fill: "#e2e5e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 324.6 H 875.4 V 335.4 H 864.6 V 324.6 Z",
    style: {
      fill: "#c6c9ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 336.6 H 875.4 V 347.4 H 864.6 V 336.6 Z",
    style: {
      fill: "#b9bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 348.6 H 875.4 V 359.4 H 864.6 V 348.6 Z",
    style: {
      fill: "#aeb3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 360.6 H 875.4 V 371.4 H 864.6 V 360.6 Z",
    style: {
      fill: "#a6acb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 372.6 H 875.4 V 383.4 H 864.6 V 372.6 Z",
    style: {
      fill: "#a1a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 384.6 H 875.4 V 395.4 H 864.6 V 384.6 Z",
    style: {
      fill: "#9fa6ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 396.6 H 875.4 V 407.4 H 864.6 V 396.6 Z",
    style: {
      fill: "#9ea6af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 408.6 H 875.4 V 419.4 H 864.6 V 408.6 Z",
    style: {
      fill: "#a4aab4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 420.6 H 875.4 V 431.4 H 864.6 V 420.6 Z",
    style: {
      fill: "#b2b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 432.6 H 875.4 V 443.4 H 864.6 V 432.6 Z",
    style: {
      fill: "#c7cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 444.6 H 875.4 V 455.4 H 864.6 V 444.6 Z",
    style: {
      fill: "rgba(255,255,255,0.22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 756.6 H 875.4 V 767.4 H 864.6 V 756.6 Z",
    style: {
      fill: "rgba(255,255,255,0.15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 768.6 H 875.4 V 779.4 H 864.6 V 768.6 Z",
    style: {
      fill: "#cbced0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 780.6 H 875.4 V 791.4 H 864.6 V 780.6 Z",
    style: {
      fill: "#b6bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 792.6 H 875.4 V 803.4 H 864.6 V 792.6 Z",
    style: {
      fill: "#b1b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 804.6 H 875.4 V 815.4 H 864.6 V 804.6 Z",
    style: {
      fill: "#bfc4c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 816.6 H 875.4 V 827.4 H 864.6 V 816.6 Z",
    style: {
      fill: "rgba(225,238,234,0.47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 948.6 H 875.4 V 959.4 H 864.6 V 948.6 Z",
    style: {
      fill: "rgba(197,204,205,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 960.6 H 875.4 V 971.4 H 864.6 V 960.6 Z",
    style: {
      fill: "#aeb4bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 972.6 H 875.4 V 983.4 H 864.6 V 972.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 984.6 H 875.4 V 995.4 H 864.6 V 984.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.6 996.6 H 875.4 V 1007.4 H 864.6 V 996.6 Z",
    style: {
      fill: "rgba(185,198,191,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 312.6 H 887.4 V 323.4 H 876.6 V 312.6 Z",
    style: {
      fill: "rgba(255,255,255,0.09)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 324.6 H 887.4 V 335.4 H 876.6 V 324.6 Z",
    style: {
      fill: "#f5f9fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 336.6 H 887.4 V 347.4 H 876.6 V 336.6 Z",
    style: {
      fill: "#ccced2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 348.6 H 887.4 V 359.4 H 876.6 V 348.6 Z",
    style: {
      fill: "#bfc2c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 360.6 H 887.4 V 371.4 H 876.6 V 360.6 Z",
    style: {
      fill: "#b3b8be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 372.6 H 887.4 V 383.4 H 876.6 V 372.6 Z",
    style: {
      fill: "#aab0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 384.6 H 887.4 V 395.4 H 876.6 V 384.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 396.6 H 887.4 V 407.4 H 876.6 V 396.6 Z",
    style: {
      fill: "#a1a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 408.6 H 887.4 V 419.4 H 876.6 V 408.6 Z",
    style: {
      fill: "#a2a8b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 420.6 H 887.4 V 431.4 H 876.6 V 420.6 Z",
    style: {
      fill: "#abb1b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 432.6 H 887.4 V 443.4 H 876.6 V 432.6 Z",
    style: {
      fill: "#bdc1c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 444.6 H 887.4 V 455.4 H 876.6 V 444.6 Z",
    style: {
      fill: "rgba(215,218,221,0.92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 456.6 H 887.4 V 467.4 H 876.6 V 456.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 756.6 H 887.4 V 767.4 H 876.6 V 756.6 Z",
    style: {
      fill: "rgba(255,255,255,0.09)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 768.6 H 887.4 V 779.4 H 876.6 V 768.6 Z",
    style: {
      fill: "#cfd2d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 780.6 H 887.4 V 791.4 H 876.6 V 780.6 Z",
    style: {
      fill: "#b8bdc4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 792.6 H 887.4 V 803.4 H 876.6 V 792.6 Z",
    style: {
      fill: "#b0b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 804.6 H 887.4 V 815.4 H 876.6 V 804.6 Z",
    style: {
      fill: "#bbc0c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 816.6 H 887.4 V 827.4 H 876.6 V 816.6 Z",
    style: {
      fill: "rgba(221,234,229,0.76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 948.6 H 887.4 V 959.4 H 876.6 V 948.6 Z",
    style: {
      fill: "rgba(199,207,207,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 960.6 H 887.4 V 971.4 H 876.6 V 960.6 Z",
    style: {
      fill: "#afb5bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 972.6 H 887.4 V 983.4 H 876.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 984.6 H 887.4 V 995.4 H 876.6 V 984.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 876.6 996.6 H 887.4 V 1007.4 H 876.6 V 996.6 Z",
    style: {
      fill: "rgba(181,195,191,0.3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 336.6 H 899.4 V 347.4 H 888.6 V 336.6 Z",
    style: {
      fill: "rgba(253,255,255,0.45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 348.6 H 899.4 V 359.4 H 888.6 V 348.6 Z",
    style: {
      fill: "rgba(221,224,226,0.98)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 360.6 H 899.4 V 371.4 H 888.6 V 360.6 Z",
    style: {
      fill: "#c7cacd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 372.6 H 899.4 V 383.4 H 888.6 V 372.6 Z",
    style: {
      fill: "#bcbfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 384.6 H 899.4 V 395.4 H 888.6 V 384.6 Z",
    style: {
      fill: "#b2b8be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 396.6 H 899.4 V 407.4 H 888.6 V 396.6 Z",
    style: {
      fill: "#abb1b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 408.6 H 899.4 V 419.4 H 888.6 V 408.6 Z",
    style: {
      fill: "#a7adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 420.6 H 899.4 V 431.4 H 888.6 V 420.6 Z",
    style: {
      fill: "#a9afb7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 432.6 H 899.4 V 443.4 H 888.6 V 432.6 Z",
    style: {
      fill: "#b6bbc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 444.6 H 899.4 V 455.4 H 888.6 V 444.6 Z",
    style: {
      fill: "#cacdd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 456.6 H 899.4 V 467.4 H 888.6 V 456.6 Z",
    style: {
      fill: "rgba(252,254,254,0.93)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 756.6 H 899.4 V 767.4 H 888.6 V 756.6 Z",
    style: {
      fill: "rgba(255,255,255,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 768.6 H 899.4 V 779.4 H 888.6 V 768.6 Z",
    style: {
      fill: "#d6d9db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 780.6 H 899.4 V 791.4 H 888.6 V 780.6 Z",
    style: {
      fill: "#babfc5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 792.6 H 899.4 V 803.4 H 888.6 V 792.6 Z",
    style: {
      fill: "#afb5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 804.6 H 899.4 V 815.4 H 888.6 V 804.6 Z",
    style: {
      fill: "#b7bcc3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 816.6 H 899.4 V 827.4 H 888.6 V 816.6 Z",
    style: {
      fill: "rgba(214,226,224,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 948.6 H 899.4 V 959.4 H 888.6 V 948.6 Z",
    style: {
      fill: "rgba(201,209,208,0.91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 960.6 H 899.4 V 971.4 H 888.6 V 960.6 Z",
    style: {
      fill: "#b0b6bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 972.6 H 899.4 V 983.4 H 888.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 984.6 H 899.4 V 995.4 H 888.6 V 984.6 Z",
    style: {
      fill: "#a6adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 888.6 996.6 H 899.4 V 1007.4 H 888.6 V 996.6 Z",
    style: {
      fill: "rgba(180,193,190,0.38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 348.6 H 911.4 V 359.4 H 900.6 V 348.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 360.6 H 911.4 V 371.4 H 900.6 V 360.6 Z",
    style: {
      fill: "rgba(248,252,252,0.76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 372.6 H 911.4 V 383.4 H 900.6 V 372.6 Z",
    style: {
      fill: "#d9dddf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 384.6 H 911.4 V 395.4 H 900.6 V 384.6 Z",
    style: {
      fill: "#c7cace"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 396.6 H 911.4 V 407.4 H 900.6 V 396.6 Z",
    style: {
      fill: "#bec2c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 408.6 H 911.4 V 419.4 H 900.6 V 408.6 Z",
    style: {
      fill: "#b7bbc1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 420.6 H 911.4 V 431.4 H 900.6 V 420.6 Z",
    style: {
      fill: "#b3b9bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 432.6 H 911.4 V 443.4 H 900.6 V 432.6 Z",
    style: {
      fill: "#b9bec4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 444.6 H 911.4 V 455.4 H 900.6 V 444.6 Z",
    style: {
      fill: "#c8ccd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 456.6 H 911.4 V 467.4 H 900.6 V 456.6 Z",
    style: {
      fill: "rgba(229,231,233,0.78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 468.6 H 911.4 V 479.4 H 900.6 V 468.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 768.6 H 911.4 V 779.4 H 900.6 V 768.6 Z",
    style: {
      fill: "rgba(228,231,233,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 780.6 H 911.4 V 791.4 H 900.6 V 780.6 Z",
    style: {
      fill: "#bdc1c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 792.6 H 911.4 V 803.4 H 900.6 V 792.6 Z",
    style: {
      fill: "#afb4bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 804.6 H 911.4 V 815.4 H 900.6 V 804.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 816.6 H 911.4 V 827.4 H 900.6 V 816.6 Z",
    style: {
      fill: "rgba(202,209,209,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 948.6 H 911.4 V 959.4 H 900.6 V 948.6 Z",
    style: {
      fill: "rgba(205,215,213,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 960.6 H 911.4 V 971.4 H 900.6 V 960.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 972.6 H 911.4 V 983.4 H 900.6 V 972.6 Z",
    style: {
      fill: "#a5acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 984.6 H 911.4 V 995.4 H 900.6 V 984.6 Z",
    style: {
      fill: "#a6acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 900.6 996.6 H 911.4 V 1007.4 H 900.6 V 996.6 Z",
    style: {
      fill: "rgba(177,189,189,0.24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 372.6 H 923.4 V 383.4 H 912.6 V 372.6 Z",
    style: {
      fill: "rgba(255,255,255,0.11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 384.6 H 923.4 V 395.4 H 912.6 V 384.6 Z",
    style: {
      fill: "rgba(250,255,255,0.4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 396.6 H 923.4 V 407.4 H 912.6 V 396.6 Z",
    style: {
      fill: "#e5eaeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 408.6 H 923.4 V 419.4 H 912.6 V 408.6 Z",
    style: {
      fill: "#cccfd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 420.6 H 923.4 V 431.4 H 912.6 V 420.6 Z",
    style: {
      fill: "#c7cacf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 432.6 H 923.4 V 443.4 H 912.6 V 432.6 Z",
    style: {
      fill: "#c8ccd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 444.6 H 923.4 V 455.4 H 912.6 V 444.6 Z",
    style: {
      fill: "#d1d4d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 456.6 H 923.4 V 467.4 H 912.6 V 456.6 Z",
    style: {
      fill: "rgba(242,244,245,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 768.6 H 923.4 V 779.4 H 912.6 V 768.6 Z",
    style: {
      fill: "rgba(242,246,247,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 780.6 H 923.4 V 791.4 H 912.6 V 780.6 Z",
    style: {
      fill: "#c0c4c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 792.6 H 923.4 V 803.4 H 912.6 V 792.6 Z",
    style: {
      fill: "#afb5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 804.6 H 923.4 V 815.4 H 912.6 V 804.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 816.6 H 923.4 V 827.4 H 912.6 V 816.6 Z",
    style: {
      fill: "#c3c8ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 948.6 H 923.4 V 959.4 H 912.6 V 948.6 Z",
    style: {
      fill: "#d0dbd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 960.6 H 923.4 V 971.4 H 912.6 V 960.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 972.6 H 923.4 V 983.4 H 912.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 984.6 H 923.4 V 995.4 H 912.6 V 984.6 Z",
    style: {
      fill: "#a5acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 912.6 996.6 H 923.4 V 1007.4 H 912.6 V 996.6 Z",
    style: {
      fill: "rgba(178,188,188,0.21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 408.6 H 935.4 V 419.4 H 924.6 V 408.6 Z",
    style: {
      fill: "rgba(255,255,255,0.18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 420.6 H 935.4 V 431.4 H 924.6 V 420.6 Z",
    style: {
      fill: "rgba(250,253,253,0.64)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 432.6 H 935.4 V 443.4 H 924.6 V 432.6 Z",
    style: {
      fill: "rgba(237,240,241,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 444.6 H 935.4 V 455.4 H 924.6 V 444.6 Z",
    style: {
      fill: "rgba(239,242,242,0.76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 456.6 H 935.4 V 467.4 H 924.6 V 456.6 Z",
    style: {
      fill: "rgba(255,255,255,0.08)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 768.6 H 935.4 V 779.4 H 924.6 V 768.6 Z",
    style: {
      fill: "rgba(247,250,251,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 780.6 H 935.4 V 791.4 H 924.6 V 780.6 Z",
    style: {
      fill: "#c3c6ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 792.6 H 935.4 V 803.4 H 924.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 804.6 H 935.4 V 815.4 H 924.6 V 804.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 816.6 H 935.4 V 827.4 H 924.6 V 816.6 Z",
    style: {
      fill: "#c2c7c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 948.6 H 935.4 V 959.4 H 924.6 V 948.6 Z",
    style: {
      fill: "#d0dcd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 960.6 H 935.4 V 971.4 H 924.6 V 960.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 972.6 H 935.4 V 983.4 H 924.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 984.6 H 935.4 V 995.4 H 924.6 V 984.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 924.6 996.6 H 935.4 V 1007.4 H 924.6 V 996.6 Z",
    style: {
      fill: "rgba(174,180,180,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.6 768.6 H 947.4 V 779.4 H 936.6 V 768.6 Z",
    style: {
      fill: "rgba(248,251,251,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.6 780.6 H 947.4 V 791.4 H 936.6 V 780.6 Z",
    style: {
      fill: "#c2c5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.6 792.6 H 947.4 V 803.4 H 936.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.6 804.6 H 947.4 V 815.4 H 936.6 V 804.6 Z",
    style: {
      fill: "#b1b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.6 816.6 H 947.4 V 827.4 H 936.6 V 816.6 Z",
    style: {
      fill: "#c3c8ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.6 948.6 H 947.4 V 959.4 H 936.6 V 948.6 Z",
    style: {
      fill: "#d1dcda"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.6 960.6 H 947.4 V 971.4 H 936.6 V 960.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.6 972.6 H 947.4 V 983.4 H 936.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.6 984.6 H 947.4 V 995.4 H 936.6 V 984.6 Z",
    style: {
      fill: "#a4aab3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 936.6 996.6 H 947.4 V 1007.4 H 936.6 V 996.6 Z",
    style: {
      fill: "rgba(176,187,187,0.28)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.6 768.6 H 959.4 V 779.4 H 948.6 V 768.6 Z",
    style: {
      fill: "rgba(248,251,251,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.6 780.6 H 959.4 V 791.4 H 948.6 V 780.6 Z",
    style: {
      fill: "#c2c5ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.6 792.6 H 959.4 V 803.4 H 948.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.6 804.6 H 959.4 V 815.4 H 948.6 V 804.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.6 816.6 H 959.4 V 827.4 H 948.6 V 816.6 Z",
    style: {
      fill: "#c9d2d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.6 948.6 H 959.4 V 959.4 H 948.6 V 948.6 Z",
    style: {
      fill: "#d1ddda"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.6 960.6 H 959.4 V 971.4 H 948.6 V 960.6 Z",
    style: {
      fill: "#b3b8be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.6 972.6 H 959.4 V 983.4 H 948.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.6 984.6 H 959.4 V 995.4 H 948.6 V 984.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 948.6 996.6 H 959.4 V 1007.4 H 948.6 V 996.6 Z",
    style: {
      fill: "rgba(173,186,186,0.58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 960.6 768.6 H 971.4 V 779.4 H 960.6 V 768.6 Z",
    style: {
      fill: "rgba(248,251,252,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 960.6 780.6 H 971.4 V 791.4 H 960.6 V 780.6 Z",
    style: {
      fill: "#c2c5ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 960.6 792.6 H 971.4 V 803.4 H 960.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 960.6 804.6 H 971.4 V 815.4 H 960.6 V 804.6 Z",
    style: {
      fill: "#b3b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 960.6 816.6 H 971.4 V 827.4 H 960.6 V 816.6 Z",
    style: {
      fill: "#cbd4d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 960.6 948.6 H 971.4 V 959.4 H 960.6 V 948.6 Z",
    style: {
      fill: "#d1ddda"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 960.6 960.6 H 971.4 V 971.4 H 960.6 V 960.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 960.6 972.6 H 971.4 V 983.4 H 960.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 960.6 984.6 H 971.4 V 995.4 H 960.6 V 984.6 Z",
    style: {
      fill: "#a3aab1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 960.6 996.6 H 971.4 V 1007.4 H 960.6 V 996.6 Z",
    style: {
      fill: "rgba(174,185,185,0.53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972.6 768.6 H 983.4 V 779.4 H 972.6 V 768.6 Z",
    style: {
      fill: "rgba(248,251,252,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972.6 780.6 H 983.4 V 791.4 H 972.6 V 780.6 Z",
    style: {
      fill: "#c2c5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972.6 792.6 H 983.4 V 803.4 H 972.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972.6 804.6 H 983.4 V 815.4 H 972.6 V 804.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972.6 816.6 H 983.4 V 827.4 H 972.6 V 816.6 Z",
    style: {
      fill: "#ccd4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972.6 948.6 H 983.4 V 959.4 H 972.6 V 948.6 Z",
    style: {
      fill: "#d1ddda"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972.6 960.6 H 983.4 V 971.4 H 972.6 V 960.6 Z",
    style: {
      fill: "#b3b8be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972.6 972.6 H 983.4 V 983.4 H 972.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972.6 984.6 H 983.4 V 995.4 H 972.6 V 984.6 Z",
    style: {
      fill: "#a3a9b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 972.6 996.6 H 983.4 V 1007.4 H 972.6 V 996.6 Z",
    style: {
      fill: "rgba(175,186,186,0.36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 984.6 768.6 H 995.4 V 779.4 H 984.6 V 768.6 Z",
    style: {
      fill: "rgba(248,251,252,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 984.6 780.6 H 995.4 V 791.4 H 984.6 V 780.6 Z",
    style: {
      fill: "#c2c5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 984.6 792.6 H 995.4 V 803.4 H 984.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 984.6 804.6 H 995.4 V 815.4 H 984.6 V 804.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 984.6 816.6 H 995.4 V 827.4 H 984.6 V 816.6 Z",
    style: {
      fill: "#ccd5d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 984.6 948.6 H 995.4 V 959.4 H 984.6 V 948.6 Z",
    style: {
      fill: "#d1ddda"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 984.6 960.6 H 995.4 V 971.4 H 984.6 V 960.6 Z",
    style: {
      fill: "#b3b8be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 984.6 972.6 H 995.4 V 983.4 H 984.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 984.6 984.6 H 995.4 V 995.4 H 984.6 V 984.6 Z",
    style: {
      fill: "#a3a9b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 984.6 996.6 H 995.4 V 1007.4 H 984.6 V 996.6 Z",
    style: {
      fill: "rgba(173,186,186,0.49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 996.6 768.6 H 1007.4 V 779.4 H 996.6 V 768.6 Z",
    style: {
      fill: "rgba(248,251,252,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 996.6 780.6 H 1007.4 V 791.4 H 996.6 V 780.6 Z",
    style: {
      fill: "#c2c5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 996.6 792.6 H 1007.4 V 803.4 H 996.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 996.6 804.6 H 1007.4 V 815.4 H 996.6 V 804.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 996.6 816.6 H 1007.4 V 827.4 H 996.6 V 816.6 Z",
    style: {
      fill: "#ccd5d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 996.6 948.6 H 1007.4 V 959.4 H 996.6 V 948.6 Z",
    style: {
      fill: "#d1ddd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 996.6 960.6 H 1007.4 V 971.4 H 996.6 V 960.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 996.6 972.6 H 1007.4 V 983.4 H 996.6 V 972.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 996.6 984.6 H 1007.4 V 995.4 H 996.6 V 984.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 996.6 996.6 H 1007.4 V 1007.4 H 996.6 V 996.6 Z",
    style: {
      fill: "rgba(173,185,185,0.42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1008.6 768.6 H 1019.4 V 779.4 H 1008.6 V 768.6 Z",
    style: {
      fill: "rgba(248,251,251,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1008.6 780.6 H 1019.4 V 791.4 H 1008.6 V 780.6 Z",
    style: {
      fill: "#c2c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1008.6 792.6 H 1019.4 V 803.4 H 1008.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1008.6 804.6 H 1019.4 V 815.4 H 1008.6 V 804.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1008.6 816.6 H 1019.4 V 827.4 H 1008.6 V 816.6 Z",
    style: {
      fill: "#ccd5d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1008.6 948.6 H 1019.4 V 959.4 H 1008.6 V 948.6 Z",
    style: {
      fill: "#d1dcd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1008.6 960.6 H 1019.4 V 971.4 H 1008.6 V 960.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1008.6 972.6 H 1019.4 V 983.4 H 1008.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1008.6 984.6 H 1019.4 V 995.4 H 1008.6 V 984.6 Z",
    style: {
      fill: "#a4aab2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1008.6 996.6 H 1019.4 V 1007.4 H 1008.6 V 996.6 Z",
    style: {
      fill: "rgba(174,185,185,0.37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020.6 768.6 H 1031.4 V 779.4 H 1020.6 V 768.6 Z",
    style: {
      fill: "rgba(247,251,251,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020.6 780.6 H 1031.4 V 791.4 H 1020.6 V 780.6 Z",
    style: {
      fill: "#c2c5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020.6 792.6 H 1031.4 V 803.4 H 1020.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020.6 804.6 H 1031.4 V 815.4 H 1020.6 V 804.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020.6 816.6 H 1031.4 V 827.4 H 1020.6 V 816.6 Z",
    style: {
      fill: "#ccd5d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020.6 948.6 H 1031.4 V 959.4 H 1020.6 V 948.6 Z",
    style: {
      fill: "#d0dcd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020.6 960.6 H 1031.4 V 971.4 H 1020.6 V 960.6 Z",
    style: {
      fill: "#b2b7be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020.6 972.6 H 1031.4 V 983.4 H 1020.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020.6 984.6 H 1031.4 V 995.4 H 1020.6 V 984.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1020.6 996.6 H 1031.4 V 1007.4 H 1020.6 V 996.6 Z",
    style: {
      fill: "rgba(174,184,184,0.18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1032.6 768.6 H 1043.4 V 779.4 H 1032.6 V 768.6 Z",
    style: {
      fill: "rgba(245,250,250,0.82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1032.6 780.6 H 1043.4 V 791.4 H 1032.6 V 780.6 Z",
    style: {
      fill: "#c1c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1032.6 792.6 H 1043.4 V 803.4 H 1032.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1032.6 804.6 H 1043.4 V 815.4 H 1032.6 V 804.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1032.6 816.6 H 1043.4 V 827.4 H 1032.6 V 816.6 Z",
    style: {
      fill: "#ccd5d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1032.6 948.6 H 1043.4 V 959.4 H 1032.6 V 948.6 Z",
    style: {
      fill: "#d0dcd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1032.6 960.6 H 1043.4 V 971.4 H 1032.6 V 960.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1032.6 972.6 H 1043.4 V 983.4 H 1032.6 V 972.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1032.6 984.6 H 1043.4 V 995.4 H 1032.6 V 984.6 Z",
    style: {
      fill: "#a4abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1032.6 996.6 H 1043.4 V 1007.4 H 1032.6 V 996.6 Z",
    style: {
      fill: "rgba(174,180,180,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.6 768.6 H 1055.4 V 779.4 H 1044.6 V 768.6 Z",
    style: {
      fill: "rgba(243,247,247,0.61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.6 780.6 H 1055.4 V 791.4 H 1044.6 V 780.6 Z",
    style: {
      fill: "#c1c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.6 792.6 H 1055.4 V 803.4 H 1044.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.6 804.6 H 1055.4 V 815.4 H 1044.6 V 804.6 Z",
    style: {
      fill: "#b3b8be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.6 816.6 H 1055.4 V 827.4 H 1044.6 V 816.6 Z",
    style: {
      fill: "#ccd5d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.6 948.6 H 1055.4 V 959.4 H 1044.6 V 948.6 Z",
    style: {
      fill: "#cfdbd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.6 960.6 H 1055.4 V 971.4 H 1044.6 V 960.6 Z",
    style: {
      fill: "#b2b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.6 972.6 H 1055.4 V 983.4 H 1044.6 V 972.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.6 984.6 H 1055.4 V 995.4 H 1044.6 V 984.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1044.6 996.6 H 1055.4 V 1007.4 H 1044.6 V 996.6 Z",
    style: {
      fill: "rgba(174,180,180,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.6 768.6 H 1067.4 V 779.4 H 1056.6 V 768.6 Z",
    style: {
      fill: "rgba(246,250,250,0.87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.6 780.6 H 1067.4 V 791.4 H 1056.6 V 780.6 Z",
    style: {
      fill: "#c1c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.6 792.6 H 1067.4 V 803.4 H 1056.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.6 804.6 H 1067.4 V 815.4 H 1056.6 V 804.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.6 816.6 H 1067.4 V 827.4 H 1056.6 V 816.6 Z",
    style: {
      fill: "#ccd5d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.6 948.6 H 1067.4 V 959.4 H 1056.6 V 948.6 Z",
    style: {
      fill: "rgba(207,218,215,0.96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.6 960.6 H 1067.4 V 971.4 H 1056.6 V 960.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.6 972.6 H 1067.4 V 983.4 H 1056.6 V 972.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.6 984.6 H 1067.4 V 995.4 H 1056.6 V 984.6 Z",
    style: {
      fill: "#a5acb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.6 996.6 H 1067.4 V 1007.4 H 1056.6 V 996.6 Z",
    style: {
      fill: "rgba(176,182,182,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1068.6 768.6 H 1079.4 V 779.4 H 1068.6 V 768.6 Z",
    style: {
      fill: "rgba(244,248,248,0.76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1068.6 780.6 H 1079.4 V 791.4 H 1068.6 V 780.6 Z",
    style: {
      fill: "#c1c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1068.6 792.6 H 1079.4 V 803.4 H 1068.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1068.6 804.6 H 1079.4 V 815.4 H 1068.6 V 804.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1068.6 816.6 H 1079.4 V 827.4 H 1068.6 V 816.6 Z",
    style: {
      fill: "rgba(204,214,213,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1068.6 948.6 H 1079.4 V 959.4 H 1068.6 V 948.6 Z",
    style: {
      fill: "rgba(206,215,212,0.91)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1068.6 960.6 H 1079.4 V 971.4 H 1068.6 V 960.6 Z",
    style: {
      fill: "#b1b6bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1068.6 972.6 H 1079.4 V 983.4 H 1068.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1068.6 984.6 H 1079.4 V 995.4 H 1068.6 V 984.6 Z",
    style: {
      fill: "#a6adb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1068.6 996.6 H 1079.4 V 1007.4 H 1068.6 V 996.6 Z",
    style: {
      fill: "rgba(178,190,190,0.17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.6 768.6 H 1091.4 V 779.4 H 1080.6 V 768.6 Z",
    style: {
      fill: "rgba(247,250,250,0.92)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.6 780.6 H 1091.4 V 791.4 H 1080.6 V 780.6 Z",
    style: {
      fill: "#c1c5c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.6 792.6 H 1091.4 V 803.4 H 1080.6 V 792.6 Z",
    style: {
      fill: "#b0b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.6 804.6 H 1091.4 V 815.4 H 1080.6 V 804.6 Z",
    style: {
      fill: "#b3b8bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.6 816.6 H 1091.4 V 827.4 H 1080.6 V 816.6 Z",
    style: {
      fill: "rgba(204,214,214,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.6 948.6 H 1091.4 V 959.4 H 1080.6 V 948.6 Z",
    style: {
      fill: "rgba(205,216,213,0.95)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.6 960.6 H 1091.4 V 971.4 H 1080.6 V 960.6 Z",
    style: {
      fill: "#b1b6bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.6 972.6 H 1091.4 V 983.4 H 1080.6 V 972.6 Z",
    style: {
      fill: "#a5abb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.6 984.6 H 1091.4 V 995.4 H 1080.6 V 984.6 Z",
    style: {
      fill: "#a7aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.6 996.6 H 1091.4 V 1007.4 H 1080.6 V 996.6 Z",
    style: {
      fill: "rgba(174,187,187,0.16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1092.6 768.6 H 1103.4 V 779.4 H 1092.6 V 768.6 Z",
    style: {
      fill: "rgba(247,251,251,0.99)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1092.6 780.6 H 1103.4 V 791.4 H 1092.6 V 780.6 Z",
    style: {
      fill: "#c1c4ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1092.6 792.6 H 1103.4 V 803.4 H 1092.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1092.6 804.6 H 1103.4 V 815.4 H 1092.6 V 804.6 Z",
    style: {
      fill: "#b4b9c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1092.6 816.6 H 1103.4 V 827.4 H 1092.6 V 816.6 Z",
    style: {
      fill: "rgba(205,214,214,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1092.6 948.6 H 1103.4 V 959.4 H 1092.6 V 948.6 Z",
    style: {
      fill: "rgba(205,216,212,0.94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1092.6 960.6 H 1103.4 V 971.4 H 1092.6 V 960.6 Z",
    style: {
      fill: "#b1b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1092.6 972.6 H 1103.4 V 983.4 H 1092.6 V 972.6 Z",
    style: {
      fill: "#a5abb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1092.6 984.6 H 1103.4 V 995.4 H 1092.6 V 984.6 Z",
    style: {
      fill: "#a7adb6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1092.6 996.6 H 1103.4 V 1007.4 H 1092.6 V 996.6 Z",
    style: {
      fill: "rgba(180,194,191,0.35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1104.6 768.6 H 1115.4 V 779.4 H 1104.6 V 768.6 Z",
    style: {
      fill: "rgba(248,251,251,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1104.6 780.6 H 1115.4 V 791.4 H 1104.6 V 780.6 Z",
    style: {
      fill: "#c1c4c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1104.6 792.6 H 1115.4 V 803.4 H 1104.6 V 792.6 Z",
    style: {
      fill: "#b0b5bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1104.6 804.6 H 1115.4 V 815.4 H 1104.6 V 804.6 Z",
    style: {
      fill: "#b4b9c1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1104.6 816.6 H 1115.4 V 827.4 H 1104.6 V 816.6 Z",
    style: {
      fill: "rgba(205,214,214,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1104.6 948.6 H 1115.4 V 959.4 H 1104.6 V 948.6 Z",
    style: {
      fill: "rgba(206,216,214,0.94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1104.6 960.6 H 1115.4 V 971.4 H 1104.6 V 960.6 Z",
    style: {
      fill: "#b1b7bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1104.6 972.6 H 1115.4 V 983.4 H 1104.6 V 972.6 Z",
    style: {
      fill: "#a5acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1104.6 984.6 H 1115.4 V 995.4 H 1104.6 V 984.6 Z",
    style: {
      fill: "#a7aeb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1104.6 996.6 H 1115.4 V 1007.4 H 1104.6 V 996.6 Z",
    style: {
      fill: "rgba(179,192,192,0.38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.6 768.6 H 1127.4 V 779.4 H 1116.6 V 768.6 Z",
    style: {
      fill: "rgba(248,250,250,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.6 780.6 H 1127.4 V 791.4 H 1116.6 V 780.6 Z",
    style: {
      fill: "#bec1c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.6 792.6 H 1127.4 V 803.4 H 1116.6 V 792.6 Z",
    style: {
      fill: "#aeb3bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.6 804.6 H 1127.4 V 815.4 H 1116.6 V 804.6 Z",
    style: {
      fill: "#b1b7bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.6 816.6 H 1127.4 V 827.4 H 1116.6 V 816.6 Z",
    style: {
      fill: "#cbd5d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.6 948.6 H 1127.4 V 959.4 H 1116.6 V 948.6 Z",
    style: {
      fill: "rgba(205,217,214,0.94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.6 960.6 H 1127.4 V 971.4 H 1116.6 V 960.6 Z",
    style: {
      fill: "#b0b6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.6 972.6 H 1127.4 V 983.4 H 1116.6 V 972.6 Z",
    style: {
      fill: "#a4aab4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.6 984.6 H 1127.4 V 995.4 H 1116.6 V 984.6 Z",
    style: {
      fill: "#a5acb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1116.6 996.6 H 1127.4 V 1007.4 H 1116.6 V 996.6 Z",
    style: {
      fill: "rgba(179,193,192,0.69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 756.6 H 1139.4 V 767.4 H 1128.6 V 756.6 Z",
    style: {
      fill: "rgba(255,255,255,0.01)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 768.6 H 1139.4 V 779.4 H 1128.6 V 768.6 Z",
    style: {
      fill: "rgba(246,250,250,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 780.6 H 1139.4 V 791.4 H 1128.6 V 780.6 Z",
    style: {
      fill: "#b6babf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 792.6 H 1139.4 V 803.4 H 1128.6 V 792.6 Z",
    style: {
      fill: "#a7adb5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 804.6 H 1139.4 V 815.4 H 1128.6 V 804.6 Z",
    style: {
      fill: "#abb1b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 816.6 H 1139.4 V 827.4 H 1128.6 V 816.6 Z",
    style: {
      fill: "#c5cecf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 948.6 H 1139.4 V 959.4 H 1128.6 V 948.6 Z",
    style: {
      fill: "rgba(204,216,214,0.94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 960.6 H 1139.4 V 971.4 H 1128.6 V 960.6 Z",
    style: {
      fill: "#aab0b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 972.6 H 1139.4 V 983.4 H 1128.6 V 972.6 Z",
    style: {
      fill: "#9fa6b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 984.6 H 1139.4 V 995.4 H 1128.6 V 984.6 Z",
    style: {
      fill: "#a0a8b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1128.6 996.6 H 1139.4 V 1007.4 H 1128.6 V 996.6 Z",
    style: {
      fill: "rgba(178,191,190,0.89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1140.6 768.6 H 1151.4 V 779.4 H 1140.6 V 768.6 Z",
    style: {
      fill: "rgba(170,170,170,0.02)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1140.6 780.6 H 1151.4 V 791.4 H 1140.6 V 780.6 Z",
    style: {
      fill: "rgba(170,170,170,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1140.6 792.6 H 1151.4 V 803.4 H 1140.6 V 792.6 Z",
    style: {
      fill: "rgba(156,156,156,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1140.6 804.6 H 1151.4 V 815.4 H 1140.6 V 804.6 Z",
    style: {
      fill: "rgba(156,156,156,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1140.6 816.6 H 1151.4 V 827.4 H 1140.6 V 816.6 Z",
    style: {
      fill: "rgba(161,161,174,0.07)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1140.6 948.6 H 1151.4 V 959.4 H 1140.6 V 948.6 Z",
    style: {
      fill: "rgba(179,179,179,0.04)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1140.6 960.6 H 1151.4 V 971.4 H 1140.6 V 960.6 Z",
    style: {
      fill: "rgba(146,146,164,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1140.6 972.6 H 1151.4 V 983.4 H 1140.6 V 972.6 Z",
    style: {
      fill: "rgba(146,146,146,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1140.6 984.6 H 1151.4 V 995.4 H 1140.6 V 984.6 Z",
    style: {
      fill: "rgba(146,146,146,0.05)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1140.6 996.6 H 1151.4 V 1007.4 H 1140.6 V 996.6 Z",
    style: {
      fill: "rgba(127,127,127,0.02)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveTestPixSmall);
export default __webpack_public_path__ + "static/media/waveTestPixSmall.a5ed35ebb44a7ddffbe5fe4b1f9de149.svg";
export { ForwardRef as ReactComponent };